var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _rect, _path, _g42, _g43, _rect2, _path2, _g44, _g45, _rect3, _path3, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _path4, _path5, _g59, _g60, _g61, _g62, _path6, _path7, _g63, _path8, _path9, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutImg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1140,
    height: 490,
    viewBox: "0 0 1140 490",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1436",
    "data-name": "Rectangle 1436",
    width: 1140,
    height: 490,
    transform: "translate(390 1972)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.73
  })))), /*#__PURE__*/React.createElement("g", {
    id: "About_Img_1",
    transform: "translate(-390 -1972)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777",
    transform: "translate(422.232 1972.371)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(170.554 70.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M519.661,510.118H434.118a.767.767,0,0,1-.766-.766,13.921,13.921,0,0,1,22.674-10.834,21.624,21.624,0,0,1,16.31-15.553c.506-.115,1.067-.211,1.7-.293a8.16,8.16,0,0,1,.973-.111,5.029,5.029,0,0,1,.766-.054c.339-.018.655-.034.988-.034h.247c.333,0,.649.016.981.033a5.981,5.981,0,0,1,.838.062,8.321,8.321,0,0,1,.953.109c.279.032.593.087.908.143.538.09,1.063.216,1.57.338a21.984,21.984,0,0,1,3.131,1.053,21.681,21.681,0,0,1,12.363,14.307,13.92,13.92,0,0,1,22.669,10.837A.766.766,0,0,1,519.661,510.118Zm-84.753-1.533h83.964a12.386,12.386,0,0,0-20.98-8.142.828.828,0,0,1-.788.208.766.766,0,0,1-.55-.555,20.128,20.128,0,0,0-11.763-14.481,20.4,20.4,0,0,0-2.87-.967c-.519-.124-.994-.239-1.487-.321-.293-.052-.579-.1-.864-.136a8,8,0,0,0-.888-.1,4.889,4.889,0,0,0-.68-.052l-.087,0c-.3-.016-.595-.031-.9-.031h-.247c-.306,0-.6.015-.9.031l-.088,0a4.278,4.278,0,0,0-.615.045,7.875,7.875,0,0,0-.893.1c-.624.082-1.138.17-1.605.276a20.1,20.1,0,0,0-15.44,15.64.766.766,0,0,1-1.3.382,12.385,12.385,0,0,0-21.019,8.1Z",
    transform: "translate(-433.352 -482.471)",
    fill: "#231f20"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(0 425.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M215.917,956.045a5.137,5.137,0,1,1,5.136-5.137A5.143,5.143,0,0,1,215.917,956.045Zm0-8.741a3.6,3.6,0,1,0,3.6,3.6A3.608,3.608,0,0,0,215.917,947.3Z",
    transform: "translate(-210.78 -945.771)",
    fill: "#231f20"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(850.801 168.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M1326.206,620.563a5.137,5.137,0,1,1,5.137-5.137A5.143,5.143,0,0,1,1326.206,620.563Zm0-8.741a3.6,3.6,0,1,0,3.6,3.6A3.608,3.608,0,0,0,1326.206,611.822Z",
    transform: "translate(-1321.07 -610.289)",
    fill: "#231f20"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(997.011 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M1551.376,408.341h-38.737a.765.765,0,0,1-.766-.766,8.876,8.876,0,0,1,8.866-8.866,8.778,8.778,0,0,1,5.211,1.7,13.595,13.595,0,0,1,26.606,3.936,13.464,13.464,0,0,1-.439,3.426A.766.766,0,0,1,1551.376,408.341Zm-37.931-1.533h37.325a12.062,12.062,0,1,0-23.628-4.868.766.766,0,0,1-1.287.395,7.263,7.263,0,0,0-5.116-2.094A7.344,7.344,0,0,0,1513.445,406.808Z",
    transform: "translate(-1511.873 -390.752)",
    fill: "#231f20"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(1068.424 370.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M1612.039,879a1.148,1.148,0,1,1-1.628,1.62l-1.689-1.7-1.7,1.689a1.148,1.148,0,1,1-1.62-1.628l1.7-1.689-1.689-1.7a1.148,1.148,0,0,1,1.628-1.62l1.689,1.7,1.7-1.689a1.149,1.149,0,0,1,1.62,1.629l-1.7,1.689Z",
    transform: "translate(-1605.066 -873.638)",
    fill: "#231f20"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(393.186 123.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M731.88,558.1a1.317,1.317,0,1,1-1.867,1.858l-1.936-1.946-1.946,1.936a1.316,1.316,0,1,1-1.857-1.867l1.946-1.936-1.936-1.946a1.317,1.317,0,0,1,1.867-1.858l1.936,1.946,1.946-1.936a1.317,1.317,0,1,1,1.858,1.867l-1.946,1.936Z",
    transform: "translate(-723.886 -551.95)",
    fill: "#231f20"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(127.981 268.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M385.788,746.656a1.317,1.317,0,1,1-1.867,1.857l-1.936-1.946-1.946,1.936a1.317,1.317,0,0,1-1.858-1.867l1.946-1.936-1.936-1.946a1.317,1.317,0,1,1,1.867-1.857l1.936,1.946,1.946-1.936a1.317,1.317,0,1,1,1.857,1.867l-1.946,1.936Z",
    transform: "translate(-377.794 -740.509)",
    fill: "#231f20"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(969.731 172.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M1539.938,622.378c-2.582,0-3.9-1.42-5.057-2.672-1.083-1.171-2.019-2.182-3.932-2.182s-2.847,1.011-3.929,2.182c-1.16,1.252-2.474,2.672-5.055,2.672s-3.9-1.42-5.056-2.672c-1.083-1.171-2.019-2.182-3.931-2.182s-2.846,1.011-3.929,2.181c-1.16,1.253-2.474,2.673-5.054,2.673s-3.9-1.42-5.055-2.672c-1.083-1.171-2.019-2.182-3.93-2.182s-2.848,1.011-3.93,2.182c-1.159,1.252-2.474,2.672-5.054,2.672s-3.9-1.42-5.055-2.672c-1.083-1.171-2.018-2.182-3.93-2.182a.766.766,0,0,1,0-1.533c2.582,0,3.9,1.421,5.055,2.673,1.083,1.17,2.018,2.181,3.93,2.181s2.846-1.011,3.93-2.181c1.159-1.252,2.474-2.673,5.055-2.673s3.9,1.42,5.055,2.673c1.083,1.17,2.019,2.181,3.93,2.181s2.847-1.011,3.929-2.181c1.159-1.253,2.474-2.673,5.054-2.673s3.9,1.42,5.056,2.673c1.084,1.17,2.019,2.181,3.931,2.181s2.846-1.011,3.929-2.181c1.16-1.252,2.473-2.673,5.055-2.673s3.9,1.42,5.057,2.673c1.084,1.17,2.02,2.181,3.932,2.181s2.849-1.011,3.933-2.181c1.16-1.253,2.475-2.673,5.057-2.673a.766.766,0,1,1,0,1.533c-1.913,0-2.849,1.011-3.933,2.182C1543.835,620.958,1542.52,622.378,1539.938,622.378Z",
    transform: "translate(-1476.272 -615.992)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(159.898 175.024)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(61.854 149.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(14.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M535.262,941.049a6.027,6.027,0,0,0,2.2-.953,16.875,16.875,0,0,0,2.752-1.851,13.757,13.757,0,0,0,2.992-3.4,5.672,5.672,0,0,0,.792-2.6,10.081,10.081,0,0,0-.573-2.936,29,29,0,0,1-.868-3.091,8.855,8.855,0,0,1,.054-3.4c.4-2.327,1.56-4.807,1.2-7.636s-1.748-5.4-3.2-8.06-2.964-5.515-2.943-8.812,1.03-6.635.856-10.284-1.94-7.062-3-10.657a14.672,14.672,0,0,1-.659-5.6c.159-1.922.638-3.847.831-5.871.362-4.141-.773-8.18-1.723-12.235q-.737-3.057-1.487-6.181a31.116,31.116,0,0,1-1.115-6.323,54.9,54.9,0,0,1,.135-6.556,20.455,20.455,0,0,0,0-3.4,32.561,32.561,0,0,0-.855-3.307,40.576,40.576,0,0,0-2.581-6.353c-1.03-2.051-2.188-4.036-3.176-6.112l-.133-.374-.205-.408-.313.332a15.3,15.3,0,0,0-3.481,6.032,24.541,24.541,0,0,0-1.018,6.781c-.1,4.559.845,8.946,1.516,13.231a36.573,36.573,0,0,1,.248,12.628c-.422,2.026-1.1,3.982-1.6,5.985a13.989,13.989,0,0,0-.379,6.152c.868,4.134,4.3,6.807,5.1,10.452a12.886,12.886,0,0,1,.048,5.439,51.715,51.715,0,0,1-1.24,5.255,28.769,28.769,0,0,0-.94,5.2,14.44,14.44,0,0,0,.54,5.074c.913,3.215,2.437,6.034,3.211,8.887a21.864,21.864,0,0,1,.467,8.478c-.3,2.693-.8,5.208-1.119,7.6a33.75,33.75,0,0,0-.339,3.47,15.95,15.95,0,0,0,.25,3.241,19.835,19.835,0,0,0,1.9,5.343,14.253,14.253,0,0,0,5.077,5.816,6,6,0,0,0,1.045.541,3.79,3.79,0,0,0,.8.3c.439.135.667.184.667.184Z",
    transform: "translate(-519.34 -814.649)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(0 53.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M534.359,958.008h-.022l-8.028-.238c-6.1.135-10.993-2.7-14.494-8.44a11.051,11.051,0,0,1-1.824-4.835,12.78,12.78,0,0,1,1.456-5.884,11.735,11.735,0,0,0,1.353-5.132c-.128-2.211-1.547-4.049-3.049-5.994a16.041,16.041,0,0,1-3.238-5.628,15.285,15.285,0,0,1,.185-6.506,11.821,11.821,0,0,0-1.8-10.405c-.237-.424-.474-.848-.7-1.274a34.669,34.669,0,0,1-3.991-17.854.766.766,0,0,1,1.318-.494,39.7,39.7,0,0,1,9.992,18.419,10.379,10.379,0,0,0,1.253,3.628,8.966,8.966,0,0,0,2.878,2.292,11.546,11.546,0,0,1,3.1,2.4c1.762,2.133,1.76,4.874,1.759,7.524a14.826,14.826,0,0,0,.661,5.48,13.585,13.585,0,0,0,3.817,4.651c.442.4.883.808,1.306,1.221,2.627,2.565,3.784,5.289,3.278,7.7l5.523,18.383a.766.766,0,0,1-.734.987Zm-8.045-1.77,7,.206-5.276-17.559a.758.758,0,0,1-.008-.408c.651-2.578-1.483-5.142-2.814-6.441-.412-.4-.84-.794-1.27-1.188a14.91,14.91,0,0,1-4.2-5.208,15.954,15.954,0,0,1-.772-6.055c0-2.489,0-4.84-1.408-6.548a10.249,10.249,0,0,0-2.715-2.065,10.145,10.145,0,0,1-3.384-2.791,11.8,11.8,0,0,1-1.459-4.151,38.1,38.1,0,0,0-8.31-16.24,33.148,33.148,0,0,0,3.85,15.162c.221.415.452.83.684,1.245a13.248,13.248,0,0,1,1.975,11.414,13.963,13.963,0,0,0-.21,5.862,14.692,14.692,0,0,0,2.967,5.074c1.579,2.044,3.21,4.157,3.366,6.843a13.05,13.05,0,0,1-1.474,5.821,11.49,11.49,0,0,0-1.341,5.137A9.548,9.548,0,0,0,513.1,948.5C516.364,953.842,520.68,956.348,526.315,956.238Z",
    transform: "translate(-500.166 -885.088)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(31 26.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M545.94,949.2a4.894,4.894,0,0,0,1.941-.13,13.731,13.731,0,0,0,2.607-.667,11.176,11.176,0,0,0,3.212-1.787,4.6,4.6,0,0,0,1.311-1.771,8.191,8.191,0,0,0,.36-2.4,23.593,23.593,0,0,1,.176-2.6,7.2,7.2,0,0,1,.966-2.583c.936-1.672,2.5-3.251,2.99-5.513a19.184,19.184,0,0,0-.253-7.031c-.383-2.431-.767-5.022.146-7.537s2.592-4.792,3.45-7.628.438-5.926.606-8.962a11.911,11.911,0,0,1,1.02-4.463c.644-1.426,1.533-2.767,2.231-4.263,1.4-3.067,1.633-6.463,2.009-9.822q.268-2.537.544-5.129a25.272,25.272,0,0,1,.867-5.137,44.535,44.535,0,0,1,1.886-4.975,16.625,16.625,0,0,0,.92-2.6,26.61,26.61,0,0,0,.245-2.76,32.94,32.94,0,0,0-.245-5.559c-.231-1.847-.575-3.68-.767-5.536v-.322l-.046-.369-.33.169a12.41,12.41,0,0,0-4.3,3.664,19.9,19.9,0,0,0-2.622,4.907,60.027,60.027,0,0,0-2.438,10.526,29.673,29.673,0,0,1-3.243,9.722c-.874,1.434-1.925,2.745-2.852,4.14a11.372,11.372,0,0,0-1.963,4.6c-.46,3.4,1.434,6.372,1.058,9.377a10.452,10.452,0,0,1-1.441,4.171,41.579,41.579,0,0,1-2.377,3.68,23.461,23.461,0,0,0-2.131,3.719,11.706,11.706,0,0,0-.966,4.025c-.176,2.707.222,5.275.038,7.667a17.744,17.744,0,0,1-1.947,6.609c-.959,1.978-2.025,3.765-2.921,5.505a27.351,27.351,0,0,0-1.2,2.561,13.02,13.02,0,0,0-.69,2.546,16.115,16.115,0,0,0,0,4.6,11.566,11.566,0,0,0,2.3,5.827,4.832,4.832,0,0,0,.652.7,3.054,3.054,0,0,0,.529.445c.3.222.46.322.46.322Z",
    transform: "translate(-540.854 -848.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M546.333,949.78a5.005,5.005,0,0,1-.739-.057.725.725,0,0,1-.1-.022l-.214-.061a.787.787,0,0,1-.19-.085s-.181-.11-.515-.358a3.786,3.786,0,0,1-.628-.533,5.344,5.344,0,0,1-.7-.759,12.33,12.33,0,0,1-2.454-6.216,16.727,16.727,0,0,1,0-4.787,13.775,13.775,0,0,1,.733-2.71,28.437,28.437,0,0,1,1.244-2.648c.359-.7.751-1.411,1.152-2.142.586-1.068,1.192-2.172,1.756-3.336a16.936,16.936,0,0,0,1.874-6.344,30.719,30.719,0,0,0-.018-3.6,37.078,37.078,0,0,1-.022-4.052,12.436,12.436,0,0,1,1.029-4.283,24.166,24.166,0,0,1,2.206-3.851,41.691,41.691,0,0,0,2.336-3.614,9.663,9.663,0,0,0,1.349-3.889,11.7,11.7,0,0,0-.5-4.1,14.046,14.046,0,0,1-.553-5.291,12.231,12.231,0,0,1,2.1-4.946c.368-.554.773-1.118,1.179-1.683.56-.779,1.139-1.585,1.641-2.407a29.088,29.088,0,0,0,3.144-9.465c.126-.668.245-1.341.365-2.018a46.507,46.507,0,0,1,2.111-8.641,20.687,20.687,0,0,1,2.719-5.086,13.252,13.252,0,0,1,4.569-3.893l.331-.17a.767.767,0,0,1,1.11.587l.046.368a.8.8,0,0,1,.006.095v.283c.107,1.031.267,2.079.421,3.093.12.795.241,1.59.34,2.388a33.8,33.8,0,0,1,.25,5.684,27.171,27.171,0,0,1-.252,2.838.783.783,0,0,1-.018.087,17.294,17.294,0,0,1-.963,2.72,44.187,44.187,0,0,0-1.853,4.889,24.511,24.511,0,0,0-.833,4.957L569.121,883a28.412,28.412,0,0,1-1.954,8.948c-.353.756-.749,1.467-1.13,2.153-.4.721-.782,1.4-1.1,2.106a11.074,11.074,0,0,0-.952,4.171c-.053.954-.047,1.92-.041,2.854a21.2,21.2,0,0,1-.6,6.307,25.816,25.816,0,0,1-1.971,4.475,27.07,27.07,0,0,0-1.492,3.192c-.863,2.378-.462,4.916-.109,7.156a19.883,19.883,0,0,1,.244,7.313,11.919,11.919,0,0,1-2.108,4.235c-.355.516-.69,1-.962,1.489a6.447,6.447,0,0,0-.878,2.335,22.837,22.837,0,0,0-.166,2.484,8.919,8.919,0,0,1-.394,2.615,5.431,5.431,0,0,1-1.555,2.136,11.9,11.9,0,0,1-3.445,1.918,14.4,14.4,0,0,1-2.748.7A6.649,6.649,0,0,1,546.333,949.78Zm-.464-1.566a4.191,4.191,0,0,0,1.624-.13,13.2,13.2,0,0,0,2.5-.637,10.385,10.385,0,0,0,3-1.666,3.83,3.83,0,0,0,1.082-1.467,7.415,7.415,0,0,0,.3-2.105,24.377,24.377,0,0,1,.182-2.693,7.938,7.938,0,0,1,1.074-2.89c.291-.521.662-1.061,1.021-1.582a10.563,10.563,0,0,0,1.874-3.691,18.485,18.485,0,0,0-.261-6.749c-.363-2.3-.815-5.168.182-7.917a28.489,28.489,0,0,1,1.573-3.377,24.7,24.7,0,0,0,1.864-4.211,19.777,19.777,0,0,0,.531-5.854c-.005-.958-.012-1.947.043-2.93a12.581,12.581,0,0,1,1.085-4.731c.346-.766.759-1.507,1.158-2.225.369-.663.751-1.349,1.079-2.051a26.878,26.878,0,0,0,1.821-8.468l.665-6.24a25.933,25.933,0,0,1,.89-5.26,45.719,45.719,0,0,1,1.925-5.085,15.865,15.865,0,0,0,.867-2.437,25.8,25.8,0,0,0,.231-2.636,32.27,32.27,0,0,0-.239-5.433c-.1-.788-.217-1.569-.336-2.351-.136-.894-.275-1.815-.382-2.739a11.717,11.717,0,0,0-3.349,3.055,19.145,19.145,0,0,0-2.519,4.716,45.468,45.468,0,0,0-2.038,8.369c-.12.683-.241,1.362-.367,2.035a30.456,30.456,0,0,1-3.338,9.972c-.536.879-1.132,1.709-1.709,2.511-.395.549-.789,1.1-1.164,1.662a10.7,10.7,0,0,0-1.847,4.314,12.879,12.879,0,0,0,.53,4.692,13,13,0,0,1,.534,4.641,11.132,11.132,0,0,1-1.546,4.474A42.564,42.564,0,0,1,552,904.822a22.786,22.786,0,0,0-2.06,3.6,10.9,10.9,0,0,0-.9,3.751,36.146,36.146,0,0,0,.024,3.893,31.765,31.765,0,0,1,.014,3.789,18.428,18.428,0,0,1-2.032,6.9c-.57,1.179-1.185,2.3-1.78,3.384-.4.72-.781,1.421-1.139,2.117a26.642,26.642,0,0,0-1.175,2.5,12.155,12.155,0,0,0-.644,2.38,15.291,15.291,0,0,0,0,4.366,10.83,10.83,0,0,0,2.152,5.473,4.079,4.079,0,0,0,.548.585,2.672,2.672,0,0,0,.447.382c.17.125.288.208.359.256Z",
    transform: "translate(-540.62 -848.657)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(4.085 4.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M546.723,951.164a.767.767,0,0,1-.762-.691,2.08,2.08,0,0,1,0-.4c.036-.228.074-.41.117-.617l.048-.23c.157-.691.372-1.621.648-2.8.251-1.03.542-2.247.874-3.638.451-1.894.979-4.112,1.589-6.605.585-2.39,1.233-5.027,1.932-7.868l1.787-7.274,4.431-18.565a92.585,92.585,0,0,0,1.655-9.626,19.758,19.758,0,0,1,1.181-4.785c.444-1.112.969-2.14,1.478-3.134.174-.339.346-.676.513-1.012a29.268,29.268,0,0,0,2.454-7.642c.522-2.406,1.083-4.912,1.7-7.14.6-2.192,1.3-4.146,1.9-5.768.254-.687.523-1.307.781-1.906a15.159,15.159,0,0,0,.834-2.212c.169-.688.3-1.3.412-1.811.081-.374.151-.7.216-.963.057-.221.1-.4.136-.556l.032-.136a1.466,1.466,0,0,1,.155-.456.766.766,0,0,1,1.356.714c0,.022-.008.044-.013.066l-.038.163c-.038.163-.083.353-.141.576-.06.246-.127.557-.205.916-.113.524-.248,1.147-.421,1.851a16.28,16.28,0,0,1-.916,2.454c-.251.581-.51,1.181-.75,1.831-.59,1.592-1.271,3.507-1.858,5.641-.6,2.192-1.159,4.674-1.669,7.028a30.78,30.78,0,0,1-2.581,8.021c-.174.349-.349.692-.526,1.037-.493.963-1,1.958-1.416,2.994a18.222,18.222,0,0,0-1.085,4.405,94.263,94.263,0,0,1-1.685,9.795l-4.434,18.577-1.788,7.28c-.7,2.841-1.346,5.477-1.931,7.867-.609,2.489-1.137,4.7-1.588,6.6-.333,1.395-.623,2.614-.874,3.639-.273,1.171-.488,2.1-.641,2.771l-.046.221c-.039.184-.073.345-.1.5,0-.012,0,.015.006.052a.765.765,0,0,1-.687.838C546.773,951.163,546.748,951.164,546.723,951.164Z",
    transform: "translate(-545.951 -854.92)",
    fill: "#231f20"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(207.103 3.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(52.216 213.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M832.328,925.211v-9.117a12.87,12.87,0,0,0-12.87-12.872H771.727a12.873,12.873,0,0,0-12.871,12.872v9.117Z",
    transform: "translate(-758.09 -902.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M832.094,925.743H758.622a.766.766,0,0,1-.766-.766V915.86a13.653,13.653,0,0,1,13.637-13.638h47.731A13.653,13.653,0,0,1,832.86,915.86v9.117A.766.766,0,0,1,832.094,925.743Zm-72.705-1.532h71.939v-8.35a12.118,12.118,0,0,0-12.1-12.106H771.493a12.119,12.119,0,0,0-12.1,12.106Z",
    transform: "translate(-757.856 -902.222)",
    fill: "#231f20"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(336.093 213.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M1202.786,925.211v-9.117a12.872,12.872,0,0,0-12.872-12.872h-47.728a12.874,12.874,0,0,0-12.873,12.872v9.117Z",
    transform: "translate(-1128.547 -902.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M1202.552,925.743h-73.473a.767.767,0,0,1-.766-.766V915.86a13.654,13.654,0,0,1,13.639-13.638h47.728a13.653,13.653,0,0,1,13.638,13.638v9.117A.766.766,0,0,1,1202.552,925.743Zm-72.707-1.532h71.94v-8.35a12.119,12.119,0,0,0-12.106-12.106h-47.728a12.12,12.12,0,0,0-12.107,12.106Z",
    transform: "translate(-1128.313 -902.222)",
    fill: "#231f20"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(51.01 201.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 32.177,
    cy: 32.177,
    r: 32.177,
    transform: "matrix(0.23, -0.973, 0.973, 0.23, 0, 62.633)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(19.978 19.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M819.284,932.248a17.966,17.966,0,1,1-17.966-17.965A17.965,17.965,0,0,1,819.284,932.248Z",
    transform: "translate(-782.587 -913.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M801.084,950.745a18.731,18.731,0,1,1,18.733-18.731A18.752,18.752,0,0,1,801.084,950.745Zm0-35.93a17.2,17.2,0,1,0,17.2,17.2A17.218,17.218,0,0,0,801.084,914.816Z",
    transform: "translate(-782.353 -913.283)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(24.003 23.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M802.708,920.725a15.108,15.108,0,0,1,15.022,13.527,15.342,15.342,0,0,0,.084-1.578,15.1,15.1,0,1,0-30.127,1.578A15.1,15.1,0,0,1,802.708,920.725Z",
    transform: "translate(-787.605 -917.569)",
    fill: "#231f20"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(334.887 201.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 32.177,
    cy: 32.177,
    r: 32.177,
    transform: "translate(0 62.633) rotate(-76.717)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(19.978 19.978)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 17.965,
    cy: 17.965,
    r: 17.965,
    transform: "translate(0.766 0.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M1171.541,950.745a18.731,18.731,0,1,1,18.732-18.731A18.752,18.752,0,0,1,1171.541,950.745Zm0-35.93a17.2,17.2,0,1,0,17.2,17.2A17.218,17.218,0,0,0,1171.541,914.816Z",
    transform: "translate(-1152.81 -913.283)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(24.002 23.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M1173.165,920.725a15.107,15.107,0,0,1,15.022,13.527,15.342,15.342,0,0,0,.083-1.578,15.1,15.1,0,1,0-30.209,0,15.342,15.342,0,0,0,.084,1.578A15.1,15.1,0,0,1,1173.165,920.725Z",
    transform: "translate(-1158.061 -917.569)",
    fill: "#231f20"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(2.81 20.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M1163.022,719.66c-11.44-44.942-27.017-68.466-50.053-68.466H740.756c-12.307,0-24.1,9.314-30.376,26.7a255.59,255.59,0,0,0-14.108,68.629c-4.291,60.566,0,119.788,0,119.788h47.512v-8.953a12.758,12.758,0,0,1,12.871-12.641h47.731a12.755,12.755,0,0,1,12.87,12.641v8.953h210.4v-8.953a12.759,12.759,0,0,1,12.873-12.641h47.728a12.757,12.757,0,0,1,12.872,12.641v8.953h68.974S1177.914,778.157,1163.022,719.66Z",
    transform: "translate(-693.611 -650.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M1169.878,866.841H1100.9a.767.767,0,0,1-.766-.766v-8.953a12.005,12.005,0,0,0-12.106-11.874H1040.3a12.005,12.005,0,0,0-12.106,11.874v8.953a.766.766,0,0,1-.766.766h-210.4a.767.767,0,0,1-.766-.766v-8.953a12,12,0,0,0-12.1-11.874H756.424a12,12,0,0,0-12.1,11.874v8.953a.767.767,0,0,1-.766.766H696.042a.766.766,0,0,1-.765-.711c-.043-.592-4.246-59.969,0-119.9A255.794,255.794,0,0,1,709.429,677.4c6.153-17.034,17.777-27.2,31.1-27.2H1112.74c22.665,0,38.8,21.94,50.8,69.043,14.753,57.954,7.184,146.022,7.106,146.9A.767.767,0,0,1,1169.878,866.841Zm-68.208-1.533h67.5c.685-8.442,6.869-90.732-7.123-145.694-11.791-46.316-27.459-67.889-49.311-67.889H740.526c-12.646,0-23.733,9.791-29.655,26.192a254.218,254.218,0,0,0-14.064,68.423c-3.987,56.27-.51,112.06-.049,118.968h46.03v-8.186a13.539,13.539,0,0,1,13.637-13.407h47.731a13.538,13.538,0,0,1,13.636,13.407v8.186h208.872v-8.186a13.54,13.54,0,0,1,13.639-13.407h47.728a13.539,13.539,0,0,1,13.638,13.407Z",
    transform: "translate(-693.381 -650.194)",
    fill: "#231f20"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(4.13 16.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M1172.386,796.572c.172-32.613-6.123-69.455-8.957-80.791-11.44-45.763-27.017-69.717-50.053-69.717H741.163c-12.307,0-24.1,9.483-30.376,27.186a264.354,264.354,0,0,0-14.108,69.882q-.319,4.567-.574,9.116h350.773C1140.906,752.248,1172.386,796.572,1172.386,796.572Z",
    transform: "translate(-695.337 -645.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M1172.153,797.1a.768.768,0,0,1-.625-.323c-.078-.11-8.052-11.123-27.343-21.993-17.816-10.041-49.2-22.009-97.542-22.009H695.87a.767.767,0,0,1-.766-.809c.177-3.137.371-6.208.575-9.127a264.53,264.53,0,0,1,14.15-70.085c6.15-17.342,17.775-27.7,31.1-27.7h372.214c22.666,0,38.807,22.337,50.8,70.3,3.213,12.849,9.146,49.795,8.98,80.981a.766.766,0,0,1-.535.726A.776.776,0,0,1,1172.153,797.1ZM696.681,751.248h349.962c48.739,0,80.408,12.106,98.393,22.261,15.188,8.576,23.326,17.062,26.352,20.636-.112-30.57-5.814-65.928-8.936-78.413-11.792-47.167-27.46-69.136-49.31-69.136H740.929c-12.645,0-23.73,9.972-29.654,26.675a263,263,0,0,0-14.066,69.679C697.023,745.612,696.845,748.4,696.681,751.248Z",
    transform: "translate(-695.104 -645.064)",
    fill: "#231f20"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(0 218.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M736.033,925.146c0,4.149-1.727,7.512-3.857,7.512h-37.6c-2.131,0-3.857-3.363-3.857-7.512v-6.887c0-4.147,1.726-7.512,3.857-7.512h37.6c2.13,0,3.857,3.365,3.857,7.512Z",
    transform: "translate(-689.948 -909.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M731.942,933.19h-37.6c-2.592,0-4.623-3.636-4.623-8.278v-6.887c0-4.642,2.031-8.278,4.623-8.278h37.6c2.592,0,4.624,3.636,4.624,8.278v6.887C736.566,929.554,734.534,933.19,731.942,933.19Zm-37.6-21.911c-1.461,0-3.09,2.77-3.09,6.746v6.887c0,3.975,1.629,6.746,3.09,6.746h37.6c1.462,0,3.091-2.771,3.091-6.746v-6.887c0-3.975-1.629-6.746-3.091-6.746Z",
    transform: "translate(-689.714 -909.747)",
    fill: "#231f20"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(0.855 235.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M690.83,931.592c.37,3.392,1.915,5.937,3.768,5.937h37.6c1.852,0,3.4-2.546,3.769-5.937Z",
    transform: "translate(-690.83 -931.592)",
    fill: "#231f20"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(414.252 218.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M1300.67,925.146c0,4.149-2.642,7.512-5.9,7.512h-57.554c-3.26,0-5.9-3.363-5.9-7.512v-6.887c0-4.147,2.642-7.512,5.9-7.512h57.554c3.261,0,5.9,3.365,5.9,7.512Z",
    transform: "translate(-1230.544 -909.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M1294.533,933.19h-57.554c-3.677,0-6.668-3.714-6.668-8.278v-6.887c0-4.565,2.992-8.278,6.668-8.278h57.554c3.677,0,6.67,3.714,6.67,8.278v6.887C1301.2,929.476,1298.21,933.19,1294.533,933.19Zm-57.554-21.911c-2.832,0-5.135,3.026-5.135,6.746v6.887c0,3.72,2.3,6.746,5.135,6.746h57.554c2.832,0,5.137-3.026,5.137-6.746v-6.887c0-3.72-2.305-6.746-5.137-6.746Z",
    transform: "translate(-1230.31 -909.747)",
    fill: "#231f20"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(415.152 235.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M1231.485,931.592c.57,3.392,2.934,5.937,5.768,5.937h57.554c2.835,0,5.2-2.546,5.769-5.937Z",
    transform: "translate(-1231.485 -931.592)",
    fill: "#231f20"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(126.454 235.902)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_927",
    "data-name": "Rectangle 927",
    width: 210.405,
    height: 5.688,
    fill: "#231f20"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(19.184 30.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M1152.29,669.125a3.914,3.914,0,0,0-3.9-3.933H719.646a3.915,3.915,0,0,0-3.9,3.933h0a3.915,3.915,0,0,0,3.9,3.933h428.746a3.914,3.914,0,0,0,3.9-3.933Z",
    transform: "translate(-714.983 -664.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M1148.158,673.59H719.413a4.7,4.7,0,0,1,0-9.4h428.746a4.7,4.7,0,0,1,0,9.4Zm-428.746-7.865a3.167,3.167,0,0,0,0,6.333h428.746a3.167,3.167,0,0,0,0-6.333Z",
    transform: "translate(-714.749 -664.192)",
    fill: "#231f20"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(20.116 36.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M715.965,671.723a3.891,3.891,0,0,0,3.732,2.861h428.746a3.891,3.891,0,0,0,3.733-2.861Z",
    transform: "translate(-715.965 -671.723)",
    fill: "#231f20"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(70.988)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_928",
    "data-name": "Rectangle 928",
    width: 343.264,
    height: 7.15,
    transform: "translate(0.766 0.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M1126.383,632.749H783.119a.766.766,0,0,1-.766-.766v-7.15a.767.767,0,0,1,.766-.766h343.264a.767.767,0,0,1,.766.766v7.15A.766.766,0,0,1,1126.383,632.749Zm-342.5-1.533h341.731V625.6H783.886Z",
    transform: "translate(-782.353 -624.066)",
    fill: "#231f20"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(78.892 3.576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_929",
    "data-name": "Rectangle 929",
    width: 10.062,
    height: 12.515,
    transform: "translate(0.766 0.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M803.495,642.78H793.433a.766.766,0,0,1-.766-.766V629.5a.766.766,0,0,1,.766-.766h10.061a.766.766,0,0,1,.766.766v12.515A.767.767,0,0,1,803.495,642.78Zm-9.3-1.533h8.529V630.265H794.2Z",
    transform: "translate(-792.667 -628.732)",
    fill: "#231f20"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(183.952 3.576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 10.063,
    height: 12.515,
    transform: "translate(0.766 0.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M940.6,642.78H930.536a.767.767,0,0,1-.766-.766V629.5a.766.766,0,0,1,.766-.766H940.6a.766.766,0,0,1,.766.766v12.515A.766.766,0,0,1,940.6,642.78Zm-9.3-1.533h8.53V630.265H931.3Z",
    transform: "translate(-929.77 -628.732)",
    fill: "#231f20"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(289.014 3.576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_931",
    "data-name": "Rectangle 931",
    width: 10.062,
    height: 12.515,
    transform: "translate(0.767 0.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M1077.7,642.78h-10.062a.767.767,0,0,1-.766-.766V629.5a.766.766,0,0,1,.766-.766H1077.7a.766.766,0,0,1,.766.766v12.515A.767.767,0,0,1,1077.7,642.78Zm-9.3-1.533h8.53V630.265h-8.53Z",
    transform: "translate(-1066.875 -628.732)",
    fill: "#231f20"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(394.076 3.576)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_932",
    "data-name": "Rectangle 932",
    width: 10.062,
    height: 12.515,
    transform: "translate(0.766 0.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M1214.809,642.78h-10.061a.767.767,0,0,1-.766-.766V629.5a.766.766,0,0,1,.766-.766h10.061a.765.765,0,0,1,.766.766v12.515A.766.766,0,0,1,1214.809,642.78Zm-9.3-1.533h8.529V630.265h-8.529Z",
    transform: "translate(-1203.981 -628.732)",
    fill: "#231f20"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(32.443 50.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(1.61 1.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M738.878,749.551a3.593,3.593,0,0,1-3.686-4.208l6.268-47.294a5.557,5.557,0,0,1,5.284-4.631h64.349a4.478,4.478,0,0,1,4.474,4.473v47.188a4.477,4.477,0,0,1-4.474,4.472Z",
    transform: "translate(-734.387 -692.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M810.859,750.083H738.644a4.358,4.358,0,0,1-4.446-5.074l6.268-47.294a6.355,6.355,0,0,1,6.044-5.3h64.349a5.246,5.246,0,0,1,5.24,5.239v47.188A5.245,5.245,0,0,1,810.859,750.083ZM746.51,693.951a4.823,4.823,0,0,0-4.524,3.966l-6.268,47.294a2.83,2.83,0,0,0,2.926,3.341h72.215a3.711,3.711,0,0,0,3.707-3.706V697.657a3.711,3.711,0,0,0-3.707-3.707Z",
    transform: "translate(-734.153 -692.418)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M810.6,691.32H746.253a7.151,7.151,0,0,0-6.879,6.028l-6.268,47.293a5.2,5.2,0,0,0,5.281,6.028H810.6a6.1,6.1,0,0,0,6.081-6.081V697.4a6.1,6.1,0,0,0-6.081-6.081Z",
    transform: "translate(-732.286 -690.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M810.368,751.2H738.153a5.966,5.966,0,0,1-6.041-6.9l6.268-47.294a7.927,7.927,0,0,1,7.639-6.693h64.349a6.855,6.855,0,0,1,6.848,6.847v47.188A6.855,6.855,0,0,1,810.368,751.2Zm-64.349-59.349a6.35,6.35,0,0,0-6.12,5.362l-6.268,47.294a4.434,4.434,0,0,0,4.522,5.161h72.215a5.32,5.32,0,0,0,5.315-5.314V697.167a5.32,5.32,0,0,0-5.315-5.314Z",
    transform: "translate(-732.052 -690.32)",
    fill: "#231f20"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(136.097 50.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(1.608 1.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_933",
    "data-name": "Rectangle 933",
    d: "M5.835,0H79.612a5.836,5.836,0,0,1,5.836,5.836V50.3a5.836,5.836,0,0,1-5.836,5.836H5.836A5.836,5.836,0,0,1,0,50.3V5.835A5.835,5.835,0,0,1,5.835,0Z",
    transform: "translate(0.766 0.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M951.16,750.083h-76.5a5.244,5.244,0,0,1-5.237-5.238V697.657a5.244,5.244,0,0,1,5.237-5.239h76.5a5.245,5.245,0,0,1,5.239,5.239v47.188A5.245,5.245,0,0,1,951.16,750.083Zm-76.5-56.133a3.71,3.71,0,0,0-3.7,3.707v47.188a3.709,3.709,0,0,0,3.7,3.706h76.5a3.71,3.71,0,0,0,3.707-3.706V697.657a3.711,3.711,0,0,0-3.707-3.707Z",
    transform: "translate(-869.418 -692.418)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M950.9,691.32H874.4a6.1,6.1,0,0,0-6.079,6.081v47.188a6.1,6.1,0,0,0,6.079,6.081h76.5a6.1,6.1,0,0,0,6.082-6.081V697.4a6.1,6.1,0,0,0-6.082-6.081Z",
    transform: "translate(-867.554 -690.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M950.67,751.2h-76.5a6.854,6.854,0,0,1-6.845-6.847V697.167a6.853,6.853,0,0,1,6.845-6.847h76.5a6.855,6.855,0,0,1,6.848,6.847v47.188A6.855,6.855,0,0,1,950.67,751.2Zm-76.5-59.349a5.319,5.319,0,0,0-5.313,5.314v47.188a5.319,5.319,0,0,0,5.313,5.314h76.5a5.321,5.321,0,0,0,5.316-5.314V697.167a5.32,5.32,0,0,0-5.316-5.314Z",
    transform: "translate(-867.32 -690.32)",
    fill: "#231f20"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(244.681 50.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(1.609 1.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_934",
    "data-name": "Rectangle 934",
    d: "M5.836,0H79.612a5.836,5.836,0,0,1,5.836,5.836V50.3a5.836,5.836,0,0,1-5.836,5.836H5.835A5.835,5.835,0,0,1,0,50.3V5.836A5.836,5.836,0,0,1,5.836,0Z",
    transform: "translate(0.766 0.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M1092.864,750.083h-76.5a5.245,5.245,0,0,1-5.239-5.238V697.657a5.245,5.245,0,0,1,5.239-5.239h76.5a5.244,5.244,0,0,1,5.238,5.239v47.188A5.244,5.244,0,0,1,1092.864,750.083Zm-76.5-56.133a3.711,3.711,0,0,0-3.707,3.707v47.188a3.71,3.71,0,0,0,3.707,3.706h76.5a3.709,3.709,0,0,0,3.7-3.706V697.657a3.71,3.71,0,0,0-3.7-3.707Z",
    transform: "translate(-1011.121 -692.418)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M1092.607,691.32h-76.5a6.1,6.1,0,0,0-6.081,6.081v47.188a6.1,6.1,0,0,0,6.081,6.081h76.5a6.1,6.1,0,0,0,6.08-6.081V697.4a6.1,6.1,0,0,0-6.08-6.081Z",
    transform: "translate(-1009.255 -690.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M1092.373,751.2h-76.5a6.855,6.855,0,0,1-6.848-6.847V697.167a6.855,6.855,0,0,1,6.848-6.847h76.5a6.854,6.854,0,0,1,6.847,6.847v47.188A6.854,6.854,0,0,1,1092.373,751.2Zm-76.5-59.349a5.32,5.32,0,0,0-5.316,5.314v47.188a5.321,5.321,0,0,0,5.316,5.314h76.5a5.32,5.32,0,0,0,5.314-5.314V697.167a5.319,5.319,0,0,0-5.314-5.314Z",
    transform: "translate(-1009.021 -690.32)",
    fill: "#231f20"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(354.774 50.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(1.608 1.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M1160.262,749.551a4.477,4.477,0,0,1-4.471-4.472V697.891a4.477,4.477,0,0,1,4.471-4.473h66.7a6.781,6.781,0,0,1,6.111,4.681l12.844,47.608a2.832,2.832,0,0,1-2.943,3.844Z",
    transform: "translate(-1155.025 -692.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M1242.739,750.083h-82.712a5.243,5.243,0,0,1-5.237-5.238V697.657a5.243,5.243,0,0,1,5.237-5.239h66.7a7.5,7.5,0,0,1,6.851,5.247l12.844,47.609a3.591,3.591,0,0,1-3.684,4.809Zm-82.712-56.133a3.709,3.709,0,0,0-3.7,3.707v47.188a3.709,3.709,0,0,0,3.7,3.706h82.712a2.077,2.077,0,0,0,2.2-2.877L1232.1,698.065a6.049,6.049,0,0,0-5.372-4.114Z",
    transform: "translate(-1154.791 -692.418)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M1226.471,691.32h-66.7a6.1,6.1,0,0,0-6.08,6.081v47.188a6.1,6.1,0,0,0,6.08,6.081h82.711a4.428,4.428,0,0,0,4.5-5.87l-12.844-47.607a8.4,8.4,0,0,0-7.665-5.871Z",
    transform: "translate(-1152.926 -690.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M1242.249,751.2h-82.711a6.854,6.854,0,0,1-6.845-6.847V697.167a6.854,6.854,0,0,1,6.845-6.847h66.7a9.2,9.2,0,0,1,8.4,6.438l12.844,47.608a5.191,5.191,0,0,1-5.237,6.836Zm-82.711-59.349a5.319,5.319,0,0,0-5.313,5.314v47.188a5.319,5.319,0,0,0,5.313,5.314h82.711a3.666,3.666,0,0,0,3.757-4.9l-12.844-47.608a7.684,7.684,0,0,0-6.925-5.3Z",
    transform: "translate(-1152.692 -690.32)",
    fill: "#231f20"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(449.907 51.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M1295.884,750.244c-1.53,0-2.706-1.388-3.5-4.124-3.668-12.654-12.685-43.75-13.785-47.53-1.134-3.907-.744-5.86-.378-6.346.055-.074.095-.128.309-.128h9.663c9.774,21.2,14.264,49.614,15.472,57.9Z",
    transform: "translate(-1277.075 -691.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M1295.649,750.777c-1.91,0-3.336-1.573-4.237-4.677-3.668-12.654-12.685-43.749-13.785-47.529-1.137-3.916-.877-6.194-.254-7.021a1.047,1.047,0,0,1,.921-.434h9.663a.767.767,0,0,1,.7.445c9.323,20.221,13.969,47.377,15.535,58.115a.766.766,0,0,1-.736.876l-7.78.225Zm-17.124-58.128c-.182.575-.36,2.277.574,5.494,1.1,3.779,10.116,34.876,13.785,47.53.686,2.363,1.613,3.565,2.756,3.572l6.906-.2c-1.657-11.113-6.212-36.921-15.081-56.4Z",
    transform: "translate(-1276.84 -691.116)",
    fill: "#231f20"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(16.016 139.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M748.693,808.3c0,1.086-1.763,1.967-3.934,1.967H714.55c-2.172,0-3.935-.881-3.935-1.967h0c0-1.087,1.762-1.967,3.935-1.967h30.209c2.171,0,3.934.88,3.934,1.967Z",
    transform: "translate(-710.615 -806.33)",
    fill: "#231f20"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(16.016 146.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M748.693,816.7c0,1.086-1.763,1.967-3.934,1.967H714.55c-2.172,0-3.935-.881-3.935-1.967h0c0-1.087,1.762-1.967,3.935-1.967h30.209c2.171,0,3.934.88,3.934,1.967Z",
    transform: "translate(-710.615 -814.729)",
    fill: "#231f20"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(16.016 152.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M748.693,825.094c0,1.086-1.763,1.967-3.934,1.967H714.55c-2.172,0-3.935-.881-3.935-1.967h0c0-1.087,1.762-1.967,3.935-1.967h30.209c2.171,0,3.934.88,3.934,1.967Z",
    transform: "translate(-710.615 -823.127)",
    fill: "#231f20"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(16.016 158.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M748.693,833.492c0,1.086-1.763,1.967-3.934,1.967H714.55c-2.172,0-3.935-.881-3.935-1.967h0c0-1.086,1.762-1.967,3.935-1.967h30.209c2.171,0,3.934.881,3.934,1.967Z",
    transform: "translate(-710.615 -831.525)",
    fill: "#231f20"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(466.949 179.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M1315.169,874.333a29.282,29.282,0,0,0-1.521-9.594v-6.853h-6.525c-4.442,0-8.044,7.364-8.044,16.447s3.6,16.446,8.044,16.446h6.525v-6.853A29.277,29.277,0,0,0,1315.169,874.333Z",
    transform: "translate(-1299.079 -857.886)",
    fill: "#231f20"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(472.082 178.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M1322.866,874.333c0,9.083-3.6,16.446-8.044,16.446s-8.044-7.363-8.044-16.446,3.6-16.447,8.044-16.447S1322.866,865.25,1322.866,874.333Z",
    transform: "translate(-1306.012 -857.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M1314.587,891.312c-4.94,0-8.809-7.56-8.809-17.212s3.87-17.212,8.809-17.212,8.812,7.56,8.812,17.212S1319.529,891.312,1314.587,891.312Zm0-32.892c-3.944,0-7.277,7.181-7.277,15.68s3.332,15.68,7.277,15.68,7.279-7.18,7.279-15.68S1318.533,858.42,1314.587,858.42Z",
    transform: "translate(-1305.778 -856.887)",
    fill: "#231f20"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(342.619 40.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M1138.438,676.856s.141,2.638.311,7.253c.138,4.615.427,11.209.609,19.121.207,7.913.378,17.144.493,27.035.046,4.945.091,10.055.139,15.247.019,5.192.037,10.468.055,15.743-.018,5.274-.035,10.549-.054,15.742,0,5.192-.1,10.3-.137,15.248-.112,9.891-.285,19.122-.493,27.035-.179,7.912-.473,14.506-.611,19.121-.171,4.615-.313,7.253-.313,7.253s-.143-2.638-.313-7.253c-.138-4.615-.431-11.209-.611-19.121-.208-7.913-.381-17.143-.493-27.035-.041-4.945-.136-10.055-.137-15.248-.018-5.192-.036-10.467-.054-15.742.018-5.275.037-10.55.055-15.743.048-5.192.094-10.3.14-15.247.114-9.891.286-19.121.493-27.035.182-7.912.47-14.506.608-19.121C1138.3,679.494,1138.437,676.856,1138.438,676.856Z",
    transform: "translate(-1136.83 -676.856)",
    fill: "#231f20"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(236.613 40.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M1000.1,676.856s.141,2.972.311,8.172c.138,5.2.427,12.629.608,21.544.207,8.915.379,19.315.494,30.459.045,5.572.091,11.33.139,17.179.018,5.851.037,11.794.056,17.736-.018,5.943-.036,11.887-.054,17.737,0,5.851-.1,11.608-.137,17.179-.112,11.144-.285,21.544-.493,30.459-.179,8.915-.473,16.344-.61,21.544-.172,5.2-.313,8.172-.313,8.172s-.143-2.971-.313-8.172c-.138-5.2-.431-12.629-.61-21.544-.208-8.915-.382-19.315-.493-30.459-.041-5.572-.136-11.329-.137-17.179-.018-5.851-.036-11.794-.054-17.737.018-5.943.037-11.886.055-17.736.048-5.85.094-11.608.139-17.179.114-11.144.286-21.544.493-30.459.181-8.915.47-16.343.608-21.544C999.959,679.828,1000.1,676.856,1000.1,676.856Z",
    transform: "translate(-998.492 -676.856)",
    fill: "#231f20"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(127.21 40.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M857.329,676.856s.141,2.621.312,7.207c.138,4.586.427,11.138.608,19,.208,7.862.379,17.035.494,26.862.045,4.913.091,9.992.139,15.151.018,5.159.037,10.4.055,15.642-.018,5.241-.035,10.483-.054,15.642,0,5.159-.1,10.237-.136,15.151-.112,9.828-.285,19-.494,26.862-.179,7.862-.472,14.414-.61,19-.171,4.586-.313,7.207-.313,7.207s-.142-2.621-.314-7.207c-.138-4.586-.43-11.138-.61-19-.208-7.862-.381-17.034-.494-26.862-.041-4.914-.136-9.992-.136-15.151-.018-5.159-.036-10.4-.054-15.642.018-5.242.037-10.483.055-15.642.047-5.159.094-10.238.139-15.151.115-9.828.287-19,.494-26.862.182-7.862.47-14.414.608-19C857.188,679.477,857.328,676.856,857.329,676.856Z",
    transform: "translate(-855.722 -676.856)",
    fill: "#231f20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(348.287 127.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(0 2.652)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_935",
    "data-name": "Rectangle 935",
    width: 28.424,
    height: 8.848,
    transform: "translate(0.766 0.766)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M1173.415,804.4h-28.423a.766.766,0,0,1-.766-.766v-8.848a.766.766,0,0,1,.766-.766h28.423a.767.767,0,0,1,.766.766v8.848A.766.766,0,0,1,1173.415,804.4Zm-27.657-1.532h26.891V795.55h-26.891Z",
    transform: "translate(-1144.226 -794.017)",
    fill: "#231f20"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M1173.649,795.155a3.6,3.6,0,0,1-3.6,3.6h-21.225a3.6,3.6,0,0,1-3.6-3.6h0a3.6,3.6,0,0,1,3.6-3.6h21.225a3.6,3.6,0,0,1,3.6,3.6Z",
    transform: "translate(-1144.46 -790.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M1169.816,799.287h-21.225a4.366,4.366,0,0,1,0-8.731h21.225a4.366,4.366,0,1,1,0,8.731Zm-21.225-7.2a2.833,2.833,0,0,0,0,5.666h21.225a2.833,2.833,0,1,0,0-5.666Z",
    transform: "translate(-1144.226 -790.556)",
    fill: "#231f20"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(0.834 5.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M1145.314,797.116a3.6,3.6,0,0,0,3.532,2.938h21.225a3.594,3.594,0,0,0,3.533-2.938Z",
    transform: "translate(-1145.314 -797.116)",
    fill: "#231f20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(241.692 127.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(0 2.652)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_936",
    "data-name": "Rectangle 936",
    width: 28.424,
    height: 8.848,
    transform: "translate(0.766 0.766)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M1034.309,804.4h-28.423a.766.766,0,0,1-.766-.766v-8.848a.766.766,0,0,1,.766-.766h28.423a.766.766,0,0,1,.766.766v8.848A.766.766,0,0,1,1034.309,804.4Zm-27.657-1.532h26.891V795.55h-26.891Z",
    transform: "translate(-1005.12 -794.017)",
    fill: "#231f20"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M1034.543,795.155a3.6,3.6,0,0,1-3.6,3.6h-21.225a3.6,3.6,0,0,1-3.6-3.6h0a3.6,3.6,0,0,1,3.6-3.6h21.225a3.6,3.6,0,0,1,3.6,3.6Z",
    transform: "translate(-1005.354 -790.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M1030.71,799.287h-21.225a4.366,4.366,0,1,1,0-8.731h21.225a4.366,4.366,0,1,1,0,8.731Zm-21.225-7.2a2.833,2.833,0,1,0,0,5.666h21.225a2.833,2.833,0,1,0,0-5.666Z",
    transform: "translate(-1005.12 -790.556)",
    fill: "#231f20"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(0.832 5.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M1006.206,797.116a3.6,3.6,0,0,0,3.533,2.938h21.225a3.6,3.6,0,0,0,3.533-2.938Z",
    transform: "translate(-1006.206 -797.116)",
    fill: "#231f20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(132.644 127.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(0 2.652)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_937",
    "data-name": "Rectangle 937",
    width: 28.423,
    height: 8.848,
    transform: "translate(0.766 0.766)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M892,804.4H863.58a.766.766,0,0,1-.766-.766v-8.848a.767.767,0,0,1,.766-.766H892a.767.767,0,0,1,.766.766v8.848A.766.766,0,0,1,892,804.4Zm-27.658-1.532h26.891V795.55H864.347Z",
    transform: "translate(-862.814 -794.017)",
    fill: "#231f20"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M892.238,795.155a3.6,3.6,0,0,1-3.6,3.6H867.415a3.6,3.6,0,0,1-3.6-3.6h0a3.6,3.6,0,0,1,3.6-3.6h21.223a3.6,3.6,0,0,1,3.6,3.6Z",
    transform: "translate(-863.048 -790.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M888.4,799.287H867.181a4.366,4.366,0,1,1,0-8.731H888.4a4.366,4.366,0,1,1,0,8.731Zm-21.223-7.2a2.833,2.833,0,1,0,0,5.666H888.4a2.833,2.833,0,1,0,0-5.666Z",
    transform: "translate(-862.814 -790.556)",
    fill: "#231f20"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(0.834 5.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M863.9,797.116a3.6,3.6,0,0,0,3.533,2.938h21.223a3.6,3.6,0,0,0,3.535-2.938Z",
    transform: "translate(-863.902 -797.116)",
    fill: "#231f20"
  })))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(463.642 68.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(77.399 72.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M1126.5,810.549l1.16-7.194,9.631,3.294.947-.386c1.962-.7,2.653.018,4.5.012h0a3.076,3.076,0,0,0-.433.015c-1.006.106-1.79.544-1.744.983.031.294.428.509.989.578-.582.19-.964.507-.932.809.03.284.418.5.979.579-.6.192-1,.5-.971.813.025.245.312.432.726.526-.474.189-.761.465-.733.729.045.43.853.691,1.822.609a.142.142,0,0,0-.081.067l1.2-.077a.981.981,0,0,1-.74,1.421,15.181,15.181,0,0,1-5.651-.384l-.008.02S1131.891,811.731,1126.5,810.549Z",
    transform: "translate(-1125.735 -802.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M1140.841,813.977a16.253,16.253,0,0,1-3.943-.48.777.777,0,0,1-.15-.019c-.053-.012-5.323-1.247-10.645-2.414a.767.767,0,0,1-.592-.871l1.161-7.194a.766.766,0,0,1,1-.6l9.359,3.2.682-.278a5.531,5.531,0,0,1,3.26-.209,8.29,8.29,0,0,0,1.374.162c.058,0,.119,0,.178,0a.766.766,0,0,1-.025,1.532h-.156c-.066,0-.134.006-.2.013a3.212,3.212,0,0,0-.526.1,1.852,1.852,0,0,0,.5,2.025.767.767,0,0,1-.531.795l-.008,0a.766.766,0,0,1,.035,1.183,3.038,3.038,0,0,0,.52,0,.749.749,0,0,1,.323.042l.808-.052a.764.764,0,0,1,.731.416,1.727,1.727,0,0,1,0,1.594,1.765,1.765,0,0,1-1.31.934A13.214,13.214,0,0,1,1140.841,813.977Zm-3.9-2.031a.715.715,0,0,1,.2.028,14.621,14.621,0,0,0,4.189.461c-.982-.118-1.636-.586-1.708-1.282a1.128,1.128,0,0,0,.006-1.254,1.185,1.185,0,0,1,.226-.816,1.123,1.123,0,0,1-.234-.575,1.16,1.16,0,0,1,.2-.779,1.132,1.132,0,0,1-.256-.608,1.159,1.159,0,0,1,.116-.631,3.866,3.866,0,0,0-1.416.261l-.916.374a.768.768,0,0,1-.537.015l-8.771-3-.9,5.582c4.55,1,8.895,2.014,9.791,2.223Z",
    transform: "translate(-1125.501 -802.355)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(91.513 79.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M1144.922,813.43c-.028-.264.26-.54.733-.729h.01a3.5,3.5,0,0,1,.992-.243,3.442,3.442,0,0,1,1.182.064.036.036,0,0,1,.031.007c.405.1.672.285.7.519.046.439-.738.877-1.744.983l-.078.008C1145.775,814.121,1144.967,813.859,1144.922,813.43Z",
    transform: "translate(-1144.154 -811.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M1146.15,814.586c-1.27,0-2.14-.5-2.224-1.31-.066-.625.388-1.193,1.212-1.52.016-.007.033-.012.049-.018a4.284,4.284,0,0,1,1.156-.276,4.136,4.136,0,0,1,1.441.081l.028.006h0c1.071.253,1.254.913,1.282,1.185a1.4,1.4,0,0,1-.864,1.365,4.158,4.158,0,0,1-1.562.461l-.078.008C1146.439,814.58,1146.292,814.586,1146.15,814.586Zm-.7-1.47h0Zm.65-.063a3.057,3.057,0,0,0,.346-.012l.063-.007a3.271,3.271,0,0,0,.4-.067,3.236,3.236,0,0,0-.408.018A3.2,3.2,0,0,0,1146.1,813.053Z",
    transform: "translate(-1143.92 -811.434)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(91.52 77.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M1144.931,811.791c-.033-.312.369-.621.971-.813a3.885,3.885,0,0,1,.774-.16,3.8,3.8,0,0,1,.929.011v.01c.551.07.938.287.969.57.028.264-.25.53-.705.716a.035.035,0,0,1-.028.013,3.44,3.44,0,0,0-1.182-.064,3.493,3.493,0,0,0-.992.243h-.01C1145.242,812.223,1144.956,812.036,1144.931,811.791Z",
    transform: "translate(-1144.162 -810.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M1145.425,812.849a.8.8,0,0,1-.172-.018c-1.1-.251-1.29-.918-1.319-1.193h0c-.034-.333.041-1.159,1.5-1.624a4.661,4.661,0,0,1,.926-.192,4.546,4.546,0,0,1,1.123.015.7.7,0,0,1,.12.028c.877.146,1.433.6,1.5,1.23.031.293-.021,1.027-1.166,1.5a.813.813,0,0,1-.242.07.773.773,0,0,1-.281-.02,2.694,2.694,0,0,0-.909-.043,2.729,2.729,0,0,0-.77.185.785.785,0,0,1-.31.062Z",
    transform: "translate(-1143.929 -809.794)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(91.511 76.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M1144.919,809.972c-.031-.3.35-.619.932-.809a3.594,3.594,0,0,1,.812-.174,4.632,4.632,0,0,1,.66-.02c.09.01.179.021.26.032.562.079.951.3.981.588.033.313-.36.621-.962.812a3.8,3.8,0,0,0-.93-.011,3.878,3.878,0,0,0-.774.16C1145.338,810.472,1144.949,810.255,1144.919,809.972Z",
    transform: "translate(-1144.151 -808.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M1145.666,811.083a.7.7,0,0,1-.107-.008c-.955-.135-1.566-.6-1.635-1.257h0c-.073-.693.472-1.3,1.458-1.618a4.355,4.355,0,0,1,.969-.208,5.367,5.367,0,0,1,.768-.023c.154.015.251.026.338.038.956.136,1.568.609,1.636,1.268.073.694-.484,1.3-1.491,1.621a.776.776,0,0,1-.346.028,2.966,2.966,0,0,0-.736-.006,3.069,3.069,0,0,0-.62.127A.761.761,0,0,1,1145.666,811.083Z",
    transform: "translate(-1143.917 -807.965)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(91.455 75.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M1144.845,808.164c-.046-.439.738-.877,1.744-.983a3.075,3.075,0,0,1,.433-.015c.809-.006,1.428.244,1.468.616.031.3-.341.608-.924.8-.08-.012-.17-.022-.26-.032a4.632,4.632,0,0,0-.66.02,3.6,3.6,0,0,0-.812.174C1145.274,808.673,1144.876,808.457,1144.845,808.164Z",
    transform: "translate(-1144.078 -806.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M1145.6,809.274a.787.787,0,0,1-.094-.005c-.968-.12-1.587-.591-1.657-1.258a1.4,1.4,0,0,1,.864-1.365,4.135,4.135,0,0,1,1.562-.461,3.882,3.882,0,0,1,.54-.02h.035c1.223,0,2.084.509,2.167,1.3.072.687-.47,1.288-1.448,1.606a.772.772,0,0,1-.344.031l-.239-.029a4.072,4.072,0,0,0-.494.021,2.819,2.819,0,0,0-.635.134A.771.771,0,0,1,1145.6,809.274Z",
    transform: "translate(-1143.845 -806.163)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(0 94.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M1039.492,834.021s-.04,5.343-1.978,6.7-4.949,4.762-5.13,3.837,2.05-2.472,1.986-3.056-4.1,1.083-5.172,1.675-3.457,2.233-3.716,1.671,2.663-5.474,5.887-7.141a24.5,24.5,0,0,0,6.214-5.267Z",
    transform: "translate(-1024.723 -831.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M1025.48,845.5a1.122,1.122,0,0,1-.329-.048.947.947,0,0,1-.592-.513c-.6-1.3,3.149-6.549,6.231-8.143a23.823,23.823,0,0,0,5.976-5.076.766.766,0,0,1,1.078-.1l1.909,1.581a.767.767,0,0,1,.277.6c0,.587-.106,5.782-2.3,7.321a27.488,27.488,0,0,0-2.379,2.018c-1.9,1.725-2.591,2.308-3.322,2.066a.939.939,0,0,1-.622-.728,2.711,2.711,0,0,1,.988-2.157,25.545,25.545,0,0,0-3.053,1.3c-.231.127-.525.3-.844.5C1027,845.013,1026.125,845.5,1025.48,845.5Zm11.963-12.223a23.673,23.673,0,0,1-5.948,4.881c-2.143,1.108-4.163,3.819-5.038,5.375.447-.246.934-.54,1.247-.729.34-.205.652-.393.9-.529.045-.025,4.677-2.373,5.829-1.772a.88.88,0,0,1,.474.684,1.054,1.054,0,0,1-.008.29,21.827,21.827,0,0,1,1.952-1.615c1.1-.772,1.576-3.771,1.642-5.718Z",
    transform: "translate(-1024.496 -831.44)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(64.834 64.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M1126.868,800.137l-4.165,10.147-12.034-4.941c-.176-4.44-.451-10.609-.559-10.963a3.312,3.312,0,0,1,.363-.982Z",
    transform: "translate(-1109.338 -792.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M1122.469,810.816a.769.769,0,0,1-.291-.057l-12.034-4.941a.766.766,0,0,1-.474-.678c-.232-5.846-.452-10.261-.537-10.8-.1-.357.06-.709.407-1.487a.764.764,0,0,1,.991-.4l16.4,6.739a.767.767,0,0,1,.418,1l-4.166,10.147a.764.764,0,0,1-.709.475Zm-11.287-6.229,10.87,4.463,3.583-8.73-14.985-6.159-.005.015C1110.768,795.221,1110.945,798.7,1111.181,804.587Z",
    transform: "translate(-1109.104 -792.397)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(40.733 38.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M1078.652,761.751a13.211,13.211,0,0,1,1.6-2.594Z",
    transform: "translate(-1077.886 -758.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M1078.418,762.284a.756.756,0,0,1-.365-.094.764.764,0,0,1-.326-1,14.023,14.023,0,0,1,1.694-2.743.766.766,0,0,1,1.251.88l-1.6,2.593A.766.766,0,0,1,1078.418,762.284Z",
    transform: "translate(-1077.652 -758.158)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331",
    transform: "translate(8.44 180.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M1050.742,949.637,1043.6,960.45l-7.094-3.48,8.04-12.006Z",
    transform: "translate(-1035.744 -944.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M1043.37,960.982a.776.776,0,0,1-.337-.078l-7.094-3.48a.766.766,0,0,1-.3-1.115l8.04-12.006a.767.767,0,0,1,.51-.329.759.759,0,0,1,.589.143l6.192,4.674a.767.767,0,0,1,.177,1.034l-7.138,10.812A.767.767,0,0,1,1043.37,960.982Zm-5.969-4.548,5.7,2.8,6.371-9.649-4.97-3.752Z",
    transform: "translate(-1035.51 -943.963)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(13.253 93.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M1074.011,830.64l-11.768,51.006-19.451,38.063,9.251,6.841,26.062-39.911,9.052-19.9Z",
    transform: "translate(-1042.025 -829.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M1051.81,927.081a.767.767,0,0,1-.456-.15l-9.251-6.841a.766.766,0,0,1-.227-.965l19.409-37.979,11.746-50.914a.766.766,0,0,1,1.467-.09l13.146,36.1a.767.767,0,0,1-.022.58l-9.052,19.9a.775.775,0,0,1-.056.1l-26.061,39.911a.765.765,0,0,1-.506.335A.739.739,0,0,1,1051.81,927.081Zm-8.274-7.837,8.076,5.972,25.586-39.183,8.9-19.566-12.153-33.37-11.186,48.485a.789.789,0,0,1-.064.176Zm18.473-37.833h0Z",
    transform: "translate(-1041.791 -829.638)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    transform: "translate(39.047 102.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M1077.161,852.568l-1.709,52.318,10.286-15.752,3.211-6.721-6.6-35.613-2.6-5.484Z",
    transform: "translate(-1075.452 -841.316)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(62.497 184.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M1114.812,950.04l1.995,20.485-7.758,1.5-1.995-21.981Z",
    transform: "translate(-1106.288 -949.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M1108.816,972.554a.761.761,0,0,1-.461-.154.769.769,0,0,1-.3-.543l-1.995-21.98a.766.766,0,0,1,.763-.836h7.757a.766.766,0,0,1,.762.692l2,20.485a.766.766,0,0,1-.618.827l-7.758,1.5A.77.77,0,0,1,1108.816,972.554Zm-1.156-21.981,1.843,20.3,6.241-1.2-1.86-19.1Z",
    transform: "translate(-1106.055 -949.04)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(40.866 80.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M1103.573,813.531l7.726,115.987h-11.63l-16.521-89.211s-7.667-12.508-2.522-26.776Z",
    transform: "translate(-1078.064 -812.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M1111.059,930.05h-11.63a.766.766,0,0,1-.753-.627l-16.5-89.076c-.842-1.431-7.509-13.459-2.514-27.31a.766.766,0,0,1,.721-.507h22.947a.765.765,0,0,1,.764.716l7.726,115.986a.767.767,0,0,1-.765.818Zm-10.992-1.533h10.173l-7.624-114.454h-21.687c-4.606,13.554,2.558,25.488,2.632,25.609a.76.76,0,0,1,.1.26Z",
    transform: "translate(-1077.825 -812.531)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(63.264 201.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M1107.756,973.027a.706.706,0,0,1,1.1-.29,5.576,5.576,0,0,0,3.962,1.189c2.016-.126,3.432-1.145,3.729-1.881a.718.718,0,0,1,.969-.4L1129,977.321a3.065,3.065,0,0,1,1.583,1.733h0a1.07,1.07,0,0,1-1.059,1.432l-21.091-1.038a1.449,1.449,0,0,1-1.371-1.6l.412-4.058a.7.7,0,0,1,.049-.2Z",
    transform: "translate(-1107.055 -971.578)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(6.002 191.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M1035.382,958.708a.707.707,0,0,1,1.11.243,5.585,5.585,0,0,0,2.984,2.867c1.851.807,3.576.546,4.176.027a.717.717,0,0,1,1.045.087l7.631,10.291a3.058,3.058,0,0,1,.616,2.264h0a1.07,1.07,0,0,1-1.6.792l-18.293-10.547a1.452,1.452,0,0,1-.493-2.046l2.221-3.422a.692.692,0,0,1,.132-.152Z",
    transform: "translate(-1032.329 -958.534)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349",
    transform: "translate(32.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(6.136 22.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M1081.838,739.017s-5.523-.254-6.115,2.373C1075.723,741.39,1080.619,743,1081.838,739.017Z",
    transform: "translate(-1074.957 -738.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M1077.659,742.245a8.421,8.421,0,0,1-2.409-.361.765.765,0,0,1-.507-.9c.712-3.164,6.268-3,6.9-2.971a.767.767,0,0,1,.7.99,4.286,4.286,0,0,1-2.144,2.68A5.508,5.508,0,0,1,1077.659,742.245Zm-1-1.611a4.788,4.788,0,0,0,2.834-.31,2.532,2.532,0,0,0,.889-.76A6.764,6.764,0,0,0,1076.66,740.634Z",
    transform: "translate(-1074.723 -738.007)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339",
    transform: "translate(5.039 0.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M1083.195,739.116s-2.066,4.388.043,6.065C1083.238,745.181,1086.255,741.949,1083.195,739.116Z",
    transform: "translate(-1081.531 -738.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M1083.006,745.714a.765.765,0,0,1-.477-.166c-2.553-2.031-.354-6.79-.259-6.992a.766.766,0,0,1,1.214-.236,4.6,4.6,0,0,1,1.614,3.261,6,6,0,0,1-1.532,3.89A.765.765,0,0,1,1083.006,745.714Zm.2-5.322a5.456,5.456,0,0,0-.208,3.28A3.211,3.211,0,0,0,1083.206,740.392Z",
    transform: "translate(-1081.299 -738.115)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M1080.521,713.912s-4.351-9.555-11.2-4.227c-5.066,3.943-2.7,12.922,6.658,12.077Z",
    transform: "translate(-1066.716 -708.069)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(8.23 3.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M1099.951,727.8s3.728-8.084-2.358-12.366a12.836,12.836,0,0,0-18.459,3.387c-4.3,6.252,1.015,13.769,1.015,13.769l2.69-6.119,2.422-4.789,4.061-2.261,3.385-.2h2.887l2.418.665Z",
    transform: "translate(-1077.456 -712.906)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343",
    transform: "translate(15.502 22.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M1100,756.854l-11.935-5.943-.118-.059V738.121h8.7v12.593A19.776,19.776,0,0,1,1100,756.854Z",
    transform: "translate(-1087.18 -737.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M1099.765,757.387a.772.772,0,0,1-.342-.08l-12.054-6a.768.768,0,0,1-.423-.685V737.887a.767.767,0,0,1,.766-.766h8.7a.767.767,0,0,1,.766.766v12.3a21.067,21.067,0,0,1,3.313,6.2.767.767,0,0,1-.73,1Zm-11.287-7.243,9.844,4.9a15.283,15.283,0,0,0-2.463-4.038.766.766,0,0,1-.21-.527V738.654h-7.171Z",
    transform: "translate(-1086.946 -737.121)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(16.273 27.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M1087.952,745.631s1.173,4.522,5.241,5.114a3.151,3.151,0,0,0,3.46-3.068c0-1.778-4.056-4.237-4.056-4.237Z",
    transform: "translate(-1087.952 -743.44)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345",
    transform: "translate(12.116 7.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M1092.791,741.438h0a9.265,9.265,0,0,1-9.264-9.264v-4.618a9.265,9.265,0,0,1,9.264-9.264h0a9.265,9.265,0,0,1,9.265,9.264v4.618A9.265,9.265,0,0,1,1092.791,741.438Z",
    transform: "translate(-1082.761 -717.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M1092.558,741.971a10.042,10.042,0,0,1-10.031-10.031v-4.618a10.031,10.031,0,0,1,20.062,0v4.618A10.042,10.042,0,0,1,1092.558,741.971Zm0-23.146a8.508,8.508,0,0,0-8.5,8.5v4.618a8.5,8.5,0,1,0,17,0v-4.618A8.508,8.508,0,0,0,1092.558,718.825Z",
    transform: "translate(-1082.527 -717.292)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(13.229 9.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M1098.434,721.152c-.147,4.853-6.945,7.77-10.982,9.067l-1.483,3.408-.7-2.76h-.01c-.461.118-.736.177-.736.177s-2.279-2.7,2.495-8.163S1098.434,721.152,1098.434,721.152Z",
    transform: "translate(-1083.981 -719.903)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347",
    transform: "translate(11.957 6.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M1083.6,731.168s2.182-10.648,11.7-10.251c0,0,5.406.251,6.7,7.765,0,0,2.055-12.487-10.228-11.071C1080.938,718.861,1083.6,731.268,1083.6,731.168Z",
    transform: "translate(-1082.552 -716.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M1083.322,731.7c-.709,0-.779-.687-.912-1.995-.284-2.794-.472-11.995,9.047-13.093,3.825-.439,6.747.366,8.684,2.4,3.34,3.506,2.43,9.312,2.389,9.558a.767.767,0,0,1-.753.642h0a.766.766,0,0,1-.755-.636c-1.18-6.828-5.937-7.127-5.985-7.13-8.738-.352-10.835,9.232-10.92,9.64a.768.768,0,0,1-.683.61C1083.393,731.7,1083.356,731.7,1083.322,731.7Zm.043-.768h0Zm10.032-12.9a15.366,15.366,0,0,0-1.763.106,8.16,8.16,0,0,0-6.056,3.247,10.913,10.913,0,0,0-1.719,5.931c1.569-3.279,4.874-7.671,11.243-7.4a7.88,7.88,0,0,1,5.737,3.775,7.583,7.583,0,0,0-1.812-3.626A7.443,7.443,0,0,0,1093.4,718.032Z",
    transform: "translate(-1082.32 -716.499)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    transform: "translate(8.458 17.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M1084.844,735.136a3.045,3.045,0,1,1-3.045-3.044A3.045,3.045,0,0,1,1084.844,735.136Z",
    transform: "translate(-1077.987 -731.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M1081.565,738.714a3.811,3.811,0,1,1,3.811-3.812A3.817,3.817,0,0,1,1081.565,738.714Zm0-6.09a2.279,2.279,0,1,0,2.278,2.278A2.281,2.281,0,0,0,1081.565,732.625Z",
    transform: "translate(-1077.753 -731.092)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(8.1 34.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M1093.169,784.263a3.323,3.323,0,0,0-.363.982c.108.353.383,6.523.559,10.963.108,2.544.187,4.529.187,4.529l-22.927-1.041a119.044,119.044,0,0,1-3.359-15.845L1045.409,819.3l-9.342-5.756,32.632-52.927,1.6-2.594.019-.029c.118-.137.226-.275.344-.4a9.847,9.847,0,0,1,3.989-2.77l1.286-.127,11.935,5.943c-.078-.255-1.483-4.332-3.526-6.326,1.562.668,4.382,2.721,6.749,9l3.772,5.089a8.257,8.257,0,0,1,1.69,6.984C1095.91,778.487,1093.975,782.445,1093.169,784.263Z",
    transform: "translate(-1035.3 -753.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M1045.174,819.835a.762.762,0,0,1-.4-.114l-9.342-5.756a.767.767,0,0,1-.251-1.055l34.235-55.521a1.169,1.169,0,0,1,.09-.125l.112-.133c.083-.1.165-.2.251-.291a10.6,10.6,0,0,1,4.282-2.968.783.783,0,0,1,.193-.045l1.287-.127a.764.764,0,0,1,.418.077l10.153,5.055a14.23,14.23,0,0,0-2.622-4.2.767.767,0,0,1,.836-1.254c1.6.684,4.641,2.8,7.126,9.332l3.709,5a9,9,0,0,1,1.825,7.6,43.46,43.46,0,0,1-3.023,8.116c-.158.345-.3.655-.416.919v0c-.062.139-.237.53-.3.7.128,1.074.312,4.722.557,10.9.108,2.543.187,4.528.187,4.528a.766.766,0,0,1-.8.8l-22.928-1.041a.766.766,0,0,1-.7-.546,121.068,121.068,0,0,1-3.073-13.88l-20.757,33.669A.766.766,0,0,1,1045.174,819.835Zm-8.287-6.773,8.038,4.953,21.454-34.8a.767.767,0,0,1,1.412.3,121.316,121.316,0,0,0,3.184,15.211l21.544.978c-.033-.813-.087-2.149-.153-3.692-.232-5.848-.452-10.263-.537-10.8-.1-.356.06-.708.406-1.486.119-.268.262-.582.422-.933a42.2,42.2,0,0,0,2.918-7.792,7.486,7.486,0,0,0-1.524-6.333l-3.8-5.127a.776.776,0,0,1-.1-.186,24.3,24.3,0,0,0-2.471-4.968c.446,1.032.693,1.783.7,1.8a.767.767,0,0,1-1.074.911l-11.737-5.845-.966.1a9.129,9.129,0,0,0-3.589,2.524c-.081.088-.146.166-.211.246l-.087.1-1.589,2.573Zm56.4-28.317a1.738,1.738,0,0,1,.044.253A.676.676,0,0,0,1093.29,784.744Zm-.355-.715h0Z",
    transform: "translate(-1035.066 -753.312)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351",
    transform: "translate(42.354 37.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M1081.111,758.578c-.118.128-.226.266-.344.4l.275-.452Z",
    transform: "translate(-1080.001 -757.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M1080.533,759.514a.767.767,0,0,1-.654-1.165l.275-.452a.766.766,0,0,1,1.1-.224l.069.049a.766.766,0,0,1,.116,1.143c-.069.074-.133.153-.2.232l-.126.149A.764.764,0,0,1,1080.533,759.514Z",
    transform: "translate(-1079.768 -757.53)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353",
    transform: "translate(85.796 68.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M1152.135,805.141l-12.085,7.024a.843.843,0,0,1-1.242-.527l-1.324-5.366a.842.842,0,0,1,.4-.933l11.912-6.853a.843.843,0,0,1,1.23.5l1.5,5.2A.843.843,0,0,1,1152.135,805.141Z",
    transform: "translate(-1136.693 -797.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M1139.4,812.813a1.61,1.61,0,0,1-.631-.129,1.592,1.592,0,0,1-.934-1.1l-1.325-5.366a1.615,1.615,0,0,1,.759-1.781l11.911-6.852a1.61,1.61,0,0,1,2.35.949l1.5,5.2a1.61,1.61,0,0,1-.737,1.837h0l-12.085,7.024A1.6,1.6,0,0,1,1139.4,812.813Zm-.077-1.593.113.048h0l12.084-7.023a.079.079,0,0,0,.035-.089l-1.5-5.2h0l-.113-.045h0l-11.911,6.852a.078.078,0,0,0-.036.086l1.325,5.366Zm12.583-6.313h0Z",
    transform: "translate(-1136.459 -797.372)",
    fill: "#231f20"
  }))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    transform: "translate(220.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355",
    transform: "translate(13.548 38.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M744.661,669.833a19.087,19.087,0,0,1-10.369,3.385q-1.763-.041-3.525.093a5.346,5.346,0,0,0-3.173,1.373,2.936,2.936,0,0,0-.71,3.235c.719,1.49,2.885,2.009,3.271,3.619a3.149,3.149,0,0,1-1.505,3.018,17.5,17.5,0,0,0-2.876,2.1,4.059,4.059,0,0,0,2.269,6.69c.843.165,1.871.132,2.352.844a2.638,2.638,0,0,1,.19,1.752,6.241,6.241,0,0,0,.616,3.674,3.429,3.429,0,0,0,3.086,1.834c.494-.018.97-.205,1.464-.212a1.218,1.218,0,0,1,1.211.667,2.574,2.574,0,0,1-.007,1.012c-.117,1.661,1.581,2.9,3.2,3.306a11.057,11.057,0,0,0,9.376-2.286,18.04,18.04,0,0,0,5.536-8.176,54.029,54.029,0,0,0,2.252-9.727",
    transform: "translate(-724.743 -669.833)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(30.43 111.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M788.579,773.323a6.911,6.911,0,0,0-1.665-2.291,21.539,21.539,0,0,0-17.019-5.664,29.913,29.913,0,0,0-16.573,7.54c-2.475,2.167-5.77,6.286-6.549,9.484,3.782.762,9.334-.706,12.834-2.382s6.907-3.671,10.725-4.208c4.427-.622,8.851.79,13.261,1.518a8.465,8.465,0,0,0,2.684.112,3.188,3.188,0,0,0,2.23-1.365A3.128,3.128,0,0,0,788.579,773.323Z",
    transform: "translate(-746.774 -765.266)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(30.001 112.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M788.9,773.712a7.066,7.066,0,0,0-1.7-2.339,22,22,0,0,0-17.379-5.784,30.546,30.546,0,0,0-16.923,7.7c-2.527,2.212-5.892,6.418-6.687,9.684,3.862.779,9.532-.72,13.1-2.432s7.054-3.749,10.952-4.3c4.52-.635,9.039.808,13.543,1.55a8.638,8.638,0,0,0,2.741.115,3.257,3.257,0,0,0,2.277-1.394A3.193,3.193,0,0,0,788.9,773.712Z",
    transform: "translate(-746.215 -765.484)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(63.648 151.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M797.9,839.355l10.439-7.332s10.982,8.144,13.022,6.977l-13.5-20.725-16.738,10.744Z",
    transform: "translate(-790.358 -817.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M797.668,839.887a.756.756,0,0,1-.144-.013.766.766,0,0,1-.5-.333l-6.778-10.336a.767.767,0,0,1,.226-1.065L807.214,817.4a.766.766,0,0,1,1.056.227l13.5,20.725a.767.767,0,0,1-.261,1.084c-2.143,1.224-9.772-4.027-13.415-6.7l-9.988,7.015A.764.764,0,0,1,797.668,839.887Zm-5.713-10.875,5.92,9.028,9.792-6.878a.767.767,0,0,1,.9.012c4.519,3.351,9.017,6.058,11.119,6.775L807.4,819.1Z",
    transform: "translate(-790.124 -817.274)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(69.978 158.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M800.709,825.668l5.283,10.915L804.4,837.8l-6.018-10.612Z",
    transform: "translate(-798.384 -825.668)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(12.004 114.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M775.248,769.154c-.438.017-14.841.239-22.419,5.665l-6.041,3.7.4,6.222s-1.236,2.249-.9,3.556a51.865,51.865,0,0,1,.221,6.892s-2.3.233-2.444,4.2a10.957,10.957,0,0,0-4.463,3.838c-1.314,2.4-14.7,29.327-15.411,33.613s-1.028,11.782,2.291,14.151,10.508,1.218,10.508,1.218,1.143,3.041,7.455,2.95,15.7-7.784,15.7-7.784L788.436,826.5l-7.444-14.447-9.905,6.582,10.371-13.015s4.668-8.688,2.861-17.577C782.986,781.444,775.248,769.154,775.248,769.154Z",
    transform: "translate(-722.962 -768.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M743.938,855.7c-4.958,0-6.91-1.909-7.585-2.888-1.776.223-7.519.739-10.548-1.424-4.328-3.089-2.927-12.955-2.6-14.9.749-4.492,14.416-31.888,15.494-33.855a11.134,11.134,0,0,1,4.4-3.955c.23-2.884,1.583-3.918,2.427-4.285a42.578,42.578,0,0,0-.205-6.132c-.353-1.352.526-3.266.857-3.917l-.384-6.007a.769.769,0,0,1,.365-.7l6.042-3.7c7.134-5.111,20.181-5.708,22.723-5.775a.915.915,0,0,1,.744.356c.319.507,7.829,12.484,9.175,19.142,1.841,9.055-2.742,17.727-2.937,18.091a.872.872,0,0,1-.076.115l-7.33,9.2,5.841-3.882a.766.766,0,0,1,1.1.287l7.444,14.447a.766.766,0,0,1-.226.968l-28.285,20.882c-.362.3-9.643,7.838-16.148,7.933Zm-7.179-4.484a.766.766,0,0,1,.716.5c.006.013,1.132,2.541,6.727,2.453,5.97-.086,15.137-7.534,15.229-7.609l27.791-20.519L780.47,812.93l-9.192,6.108a.766.766,0,0,1-1.023-1.116l10.324-12.958c.391-.76,4.41-8.87,2.756-17-1.163-5.753-7.451-16.167-8.74-18.259-3.153.109-15.025.832-21.555,5.508l-5.693,3.489.369,5.761a.772.772,0,0,1-.093.418,5.667,5.667,0,0,0-.825,2.995,48.69,48.69,0,0,1,.244,7.1.765.765,0,0,1-.689.746c-.05.008-1.64.284-1.754,3.471a.769.769,0,0,1-.447.669,10.233,10.233,0,0,0-4.11,3.508c-1.488,2.716-14.644,29.278-15.327,33.371-.89,5.333-.622,11.544,1.981,13.4,3.029,2.163,9.873,1.1,9.942,1.084A.818.818,0,0,1,736.76,851.214Z",
    transform: "translate(-722.729 -768.158)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(35.537 118.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M785.083,774.978l-.343.013-.976.037-3.591.135a49.956,49.956,0,0,0-5.3.486,29.363,29.363,0,0,0-6.291,1.563,43.845,43.845,0,0,0-10.206,5.9l-2.874,2.153-.781.591a1.248,1.248,0,0,1-.286.185",
    transform: "translate(-753.672 -774.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M754.205,786.576a.766.766,0,0,1-.323-1.461.45.45,0,0,0,.106-.07l3.7-2.779a44.959,44.959,0,0,1,10.393-6,30.2,30.2,0,0,1,6.462-1.606,50.673,50.673,0,0,1,5.369-.492l4.91-.185a.766.766,0,0,1,.058,1.532l-4.91.185a49,49,0,0,0-5.215.478,28.671,28.671,0,0,0-6.135,1.523,42.93,42.93,0,0,0-10.022,5.8l-3.643,2.736a1.844,1.844,0,0,1-.425.269A.764.764,0,0,1,754.205,786.576Z",
    transform: "translate(-753.438 -773.978)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(22.938 146.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M752.056,810.794a.57.57,0,0,1-.074.12l-.234.341c-.208.3-.506.743-.86,1.33a29.1,29.1,0,0,0-2.465,5.273,67.7,67.7,0,0,0-2.254,8.345,84.5,84.5,0,0,1-2.709,10.272c-1.277,3.554-2.989,6.731-4.03,9.816A23.706,23.706,0,0,0,738,854.745a14.545,14.545,0,0,0,.494,3.257,14.208,14.208,0,0,0,.891,2.333,13.9,13.9,0,0,0,.777,1.381c.084.143.156.258.215.352a.772.772,0,0,1,.067.126.573.573,0,0,1-.094-.109l-.238-.334",
    transform: "translate(-737.231 -810.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M740.21,862.726a.767.767,0,0,1-.512-.2,1.374,1.374,0,0,1-.222-.258l-.222-.311a.762.762,0,0,1-.132-.323c-.233-.38-.457-.787-.659-1.2a15.08,15.08,0,0,1-.94-2.46A15.425,15.425,0,0,1,737,854.54a24.425,24.425,0,0,1,1.475-8.745c.537-1.592,1.245-3.194,1.995-4.889.7-1.579,1.419-3.212,2.035-4.923a72.154,72.154,0,0,0,2.405-8.939l.277-1.243a68.385,68.385,0,0,1,2.276-8.421,29.92,29.92,0,0,1,2.532-5.419c.367-.608.674-1.066.888-1.375l.234-.339a.769.769,0,0,1,1.4.63,1.322,1.322,0,0,1-.173.283l-.2.3c-.2.293-.492.723-.835,1.292a28.359,28.359,0,0,0-2.4,5.13,66.908,66.908,0,0,0-2.225,8.243l-.28,1.255a74.414,74.414,0,0,1-2.459,9.123c-.633,1.763-1.366,3.422-2.075,5.026-.735,1.662-1.429,3.233-1.95,4.776a22.9,22.9,0,0,0-1.389,8.2,13.8,13.8,0,0,0,.467,3.067,13.477,13.477,0,0,0,.841,2.2,13.145,13.145,0,0,0,.733,1.3c.093.157.16.264.215.351a1.512,1.512,0,0,1,.129.247.767.767,0,0,1-.707,1.06Z",
    transform: "translate(-736.998 -809.794)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(26.882 24.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M769.228,655.252c-2.9-5.712-9.5-4.317-12.613-2.655a14.036,14.036,0,0,0-6.739,7.7c-.847,2.28-1.5,4.866-3.325,6.306a26.811,26.811,0,0,1-2.613,1.487,3.462,3.462,0,0,0-1.779,2.432c-.208,1.946,1.806,3.213,3.451,3.933a3.128,3.128,0,0,0-.754,3.4,8.667,8.667,0,0,0,2.035,3.014,47.558,47.558,0,0,0,10.044,7.842c3.136,1.792,5.13,1.942,8.366.449,1.314-.612,2.526-1.567,3.945-1.783,1.648-.248,3.262.54,4.913.821s3.7-.269,4.167-2.012a12.715,12.715,0,0,0,.146-2.09,1.779,1.779,0,0,1,.989-1.639,2.819,2.819,0,0,1,1.516.286c1.2.349,3.313,9.067,4.427,8.492,0,0,1.089-14.953-2.415-23.547-1.121-2.767-3.51-8.589-5.324-10.829-2.5-3.075-8.172-2.159-8.438-1.587",
    transform: "translate(-742.144 -651.139)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(36.089 28.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M768.906,657.847c-4.281-1.316-9.859,2.141-10.994,6.471-1.264,4.806-2.608,10.729-2.742,14.476-.278,7.534,5.153,9.56,5.153,9.56l-1.729,11.825,18.085-6.609,5.349-27.914.507-2.346Z",
    transform: "translate(-754.393 -656.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M758.36,700.713a.766.766,0,0,1-.759-.877l1.647-11.263c-1.491-.785-5.322-3.452-5.078-10.041.141-3.936,1.582-10.135,2.766-14.642a10.175,10.175,0,0,1,4.982-6,9.089,9.089,0,0,1,6.979-1.009l.06.021,13.628,5.465a.767.767,0,0,1,.464.874l-.507,2.345-5.346,27.9a.766.766,0,0,1-.49.576l-18.085,6.609A.78.78,0,0,1,758.36,700.713Zm8.363-42.615a8.458,8.458,0,0,0-4.058,1.132,8.623,8.623,0,0,0-4.245,5.049c-1.165,4.433-2.582,10.514-2.717,14.309-.254,6.855,4.457,8.739,4.658,8.816a.771.771,0,0,1,.487.828L759.3,698.786l16.471-6.018,5.267-27.487.375-1.731-13-5.212A5.864,5.864,0,0,0,766.722,658.1Z",
    transform: "translate(-754.16 -656.567)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(41.729 60.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M761.793,699.187a19.69,19.69,0,0,0,10.544-.661s-3.382,4.656-10.818,2.508Z",
    transform: "translate(-761.519 -698.526)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(44.884 51.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M765.637,686.826",
    transform: "translate(-765.637 -686.826)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(50.73 29.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M787.8,663.155a2.893,2.893,0,0,0-1.45-1.2,93.742,93.742,0,0,0-11.487-4.827l-1.559.963a7.915,7.915,0,0,0,4.169,7.754c1.111.565,2.547,1.084,2.734,2.319s-1.12,2.205-1.838,3.278a4.041,4.041,0,0,0,.04,4.493c.517.739,1.279,1.283,1.762,2.046a4.026,4.026,0,0,1,.282,3.456,6.9,6.9,0,0,1-2.123,3.3,6.866,6.866,0,0,0,7.228-3.368,10.9,10.9,0,0,0,.848-4.92,62.708,62.708,0,0,1,1.387-11.374A2.98,2.98,0,0,0,787.8,663.155Z",
    transform: "translate(-773.266 -657.13)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(36.877 27.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M770.9,656.938a15.546,15.546,0,0,1-3.369,3.5,5.289,5.289,0,0,1-4.626.831c.36-.43.726-.859,1.075-1.294A23.379,23.379,0,0,1,755.188,664c1.916-2.516,3.893-5.085,6.577-6.766s6.263-2.3,9-.72",
    transform: "translate(-755.188 -655.605)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(51.928 42.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M788.83,675.233l-8.3,6.965c1.022,1.035.743,3.776-.181,4.9s-2.169,2.093-2.492,3.51c-.358,1.547.516,3.1.6,4.692.119,2.243-1.318,4.23-2.413,6.192s-1.84,4.565-.469,6.35c1.543,2.01,4.847,1.588,6.792-.031s3-4.047,4.409-6.145,3.674-3.751,6.2-3.6A48.428,48.428,0,0,0,788.83,675.233Z",
    transform: "translate(-774.829 -675.233)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M741.716,677.782l-5.053,14.562s-16.576-18.251-21.623-26.153c-4.952-7.7-6.628-27.284-6.933-30.493h-.012c-.278-1.8,1.3-6.4,2.365-9.9-1.242-.225-1.4-1.712-1.4-1.712l-.694-2.392,4.335-1.52c3.356-.408,6.721,6.174,5.906,7.13a3.64,3.64,0,0,0-.707,1.532,2.465,2.465,0,0,1-.513,1.105c-.885,1.069-2.618,3.516-2.472,5.767v.013c1.109,6.2,5.673,14.047,9.22,22.092C727.832,666.19,741.716,677.782,741.716,677.782Z",
    transform: "translate(-707.297 -619.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M736.43,692.875a.769.769,0,0,1-.567-.251c-.678-.748-16.677-18.389-21.7-26.257-3.188-4.955-5.615-15.478-7.012-30.429l-.025-.271a.706.706,0,0,1-.02-.089c-.264-1.715.835-5.239,1.9-8.648.1-.31.192-.616.285-.916a2.854,2.854,0,0,1-1.211-2.006l-.677-2.332a.767.767,0,0,1,.482-.937l4.335-1.52a.765.765,0,0,1,.161-.038c2.428-.3,4.653,2.141,5.93,4.518.57,1.062,1.414,2.978.652,3.871a2.864,2.864,0,0,0-.539,1.188,3.225,3.225,0,0,1-.671,1.435c-.577.7-2.438,3.125-2.3,5.234.754,4.2,3.234,9.346,5.86,14.8,1.1,2.293,2.247,4.665,3.3,7.048,3.582,8.115,17.231,19.57,17.369,19.685a.767.767,0,0,1,.233.839l-5.053,14.563a.766.766,0,0,1-.57.5A.814.814,0,0,1,736.43,692.875ZM708.6,635.235a.788.788,0,0,1,.031.155l.038.407c1.356,14.5,3.763,25.06,6.777,29.744,4.3,6.727,17.208,21.228,20.68,25.092l4.455-12.841c-2.368-2.02-13.972-12.17-17.383-19.9-1.04-2.359-2.177-4.72-3.276-7-2.673-5.549-5.2-10.789-6-15.265a.631.631,0,0,1-.011-.1c-.169-2.6,1.795-5.274,2.647-6.3a1.693,1.693,0,0,0,.349-.752,4.451,4.451,0,0,1,.82-1.818,8.67,8.67,0,0,0-2.251-4.343c-.581-.645-1.713-1.7-2.847-1.612l-3.563,1.25.492,1.7a.787.787,0,0,1,.026.134c0,.031.118.919.771,1.037a.766.766,0,0,1,.6.977c-.156.513-.324,1.05-.5,1.6C709.572,630.25,708.467,633.793,708.6,635.235Zm9.172-8.638-.011.015Z",
    transform: "translate(-707.063 -619.158)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(61.932 43.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M866.228,678.917c-.8.671-4.394,3.739-4.394,3.739l.149.71s2.418-.264,2.759.29a1.26,1.26,0,0,1,.142,1.474c-.329.431-2.08,4.33-2.542,4.828a1.5,1.5,0,0,1-.825.351s-3.972,2.183-4.916,2.663a5.829,5.829,0,0,1-2.375.409v-.025c-2.094.7-25.681,8.571-30.419,10.4-4.969,1.913-27.648,10.667-32.019,9.82l-2.9-5.436,3.273-8s7.548-.506,12.014-2.03,21.675-6.3,21.675-6.3l27.394-5.628,1.365-1.37a33.222,33.222,0,0,1,3.766-4.418c.87-.772,7.774-3.336,8.233-3.255C867.039,677.222,867.041,678.245,866.228,678.917Z",
    transform: "translate(-788.118 -676.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M792.224,714.164a4.372,4.372,0,0,1-.815-.066.766.766,0,0,1-.53-.392l-2.9-5.436a.764.764,0,0,1-.034-.651l3.273-8a.768.768,0,0,1,.658-.474c.074,0,7.5-.517,11.817-1.99,4.45-1.5,21.015-6.118,21.717-6.313l27.22-5.595,1.159-1.162a33.955,33.955,0,0,1,3.815-4.468c.822-.731,7.987-3.628,8.9-3.464a1.119,1.119,0,0,1,.874.862,2.359,2.359,0,0,1-.9,2.259c-.557.467-2.442,2.074-3.552,3.02a2.624,2.624,0,0,1,2.182.658,2.036,2.036,0,0,1,.195,2.338.646.646,0,0,1-.048.072c-.112.16-.548,1.05-.9,1.765a18.492,18.492,0,0,1-1.691,3.12.657.657,0,0,1-.079.074,2.322,2.322,0,0,1-1.066.5c-.7.383-3.951,2.167-4.811,2.6a6.684,6.684,0,0,1-2.678.495c-3.87,1.286-25.722,8.6-30.188,10.323l-.143.055C806.678,710.851,796.1,714.164,792.224,714.164Zm-.18-1.53c2.022.12,8.8-1.179,31.111-9.769l.143-.054c4.576-1.767,27.2-9.333,30.452-10.413a.773.773,0,0,1,.449-.01,5.226,5.226,0,0,0,1.886-.36c.858-.439,4.79-2.6,4.83-2.621a.782.782,0,0,1,.31-.093.688.688,0,0,0,.348-.142c.245-.336.972-1.819,1.413-2.719A21.98,21.98,0,0,1,864,684.485a.492.492,0,0,0-.068-.552h0a6.781,6.781,0,0,0-2.1-.037.765.765,0,0,1-.832-.6l-.15-.71a.768.768,0,0,1,.252-.742s3.6-3.071,4.4-3.743l0,0a1.205,1.205,0,0,0,.235-.258,46.2,46.2,0,0,0-7.1,2.9A32.488,32.488,0,0,0,855,685.026a.757.757,0,0,1-.082.1l-1.365,1.37a.77.77,0,0,1-.389.21l-27.394,5.628c-.12.036-17.177,4.788-21.585,6.276a57.32,57.32,0,0,1-11.729,2.033l-2.957,7.226Zm71.93-28.685Zm-.117-.123v0Z",
    transform: "translate(-787.884 -676.147)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(39.941 89.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M773.309,738.332a2.25,2.25,0,0,1-.516.323,9.4,9.4,0,0,1-1.522.619,11.7,11.7,0,0,1-5.422.474,11.431,11.431,0,0,1-5.028-2.058,9.6,9.6,0,0,1-1.248-1.077,2.4,2.4,0,0,1-.389-.468c.043-.041.618.606,1.738,1.384a12.1,12.1,0,0,0,4.956,1.954,12.294,12.294,0,0,0,5.313-.374C772.52,738.715,773.274,738.294,773.309,738.332Z",
    transform: "translate(-759.186 -736.143)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(24.095 56.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M755.176,708.151s17.539-6.346,18.194-6.551,16.368.6,16.368.6-.272,10.4,3.782,13.612h0L782.158,720.4,778.9,730.53s-1.872,4.15-.118,7.91c3.32,7.118,9.035,18.331,8.3,19.667-.079.138-.709-3.906-8.3-5.778a24.752,24.752,0,0,0-10.152.484c-15.981,3.849-21.919,11.5-23.677,12.865,0,0,2.336-26.143.618-30.146s-3.48-6.612-2.325-10.257,2.872-9.531,2.872-9.531l-6.616-6.943,8.31-15.074,8.366,6.428Z",
    transform: "translate(-738.741 -692.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M744.724,766.211a.766.766,0,0,1-.763-.834c.645-7.218,2.024-26.637.677-29.775-.285-.664-.572-1.29-.845-1.887-1.372-3-2.557-5.586-1.506-8.9.961-3.032,2.328-7.676,2.743-9.091l-6.311-6.623a.767.767,0,0,1-.117-.9l8.31-15.074a.766.766,0,0,1,1.138-.238l8.366,6.428a.765.765,0,0,1,.294.7l-.851,6.752c3.975-1.438,16.479-5.958,17.049-6.136.649-.2,9.405.2,16.635.569a.767.767,0,0,1,.726.785c0,.1-.214,10.055,3.493,12.992a.766.766,0,0,1-.189,1.311l-11.029,4.451-3.144,9.788a.818.818,0,0,1-.031.08c-.017.039-1.7,3.887-.123,7.272.67,1.438,1.438,3.042,2.231,4.7,5.118,10.693,6.71,14.454,6.051,15.661a.784.784,0,0,1-.734.4.843.843,0,0,1-.717-.613c-.92-2.348-3.657-4.191-7.707-5.189a24,24,0,0,0-9.789.484c-13.476,3.246-19.65,9.185-22.287,11.72-.473.455-.815.783-1.1,1A.76.76,0,0,1,744.724,766.211Zm-4.508-57.763,6.228,6.536a.767.767,0,0,1,.181.744c-.017.058-1.733,5.936-2.877,9.547-.873,2.753.1,4.871,1.438,7.8.278.608.569,1.244.86,1.92,1.521,3.545.146,22.07-.389,28.536,2.942-2.806,9.362-8.517,22.564-11.7,3.688-.892,8.011-1.091,10.512-.484a15.922,15.922,0,0,1,6.454,3.016c-1.247-3.092-3.447-7.687-5.093-11.125-.795-1.661-1.565-3.27-2.237-4.712-1.8-3.867-.119-8.012.095-8.506l3.242-10.092a.763.763,0,0,1,.443-.477l10.281-4.149c-2.859-3.411-3.165-10.313-3.185-12.61-5.852-.3-14.657-.687-15.44-.582-.454.146-13.218,4.759-18.091,6.523a.767.767,0,0,1-1.021-.817l.953-7.558-7.31-5.617ZM786.15,757.59Z",
    transform: "translate(-738.507 -692.729)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(36.179 85.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M755.277,731.46a19.54,19.54,0,0,0,.476,2.2,10,10,0,0,0,2.905,4.464,10.7,10.7,0,0,0,4.781,2.371,44.808,44.808,0,0,0,5.373.5",
    transform: "translate(-754.511 -730.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M768.578,741.524a.76.76,0,0,1-.126-.011c-.08-.006-.253-.014-.49-.026a33.081,33.081,0,0,1-4.956-.49,11.444,11.444,0,0,1-5.084-2.531,10.776,10.776,0,0,1-3.134-4.812,20.421,20.421,0,0,1-.5-2.309.766.766,0,1,1,1.514-.238,18.7,18.7,0,0,0,.458,2.109,9.211,9.211,0,0,0,2.674,4.1,9.953,9.953,0,0,0,4.432,2.2,33.952,33.952,0,0,0,4.674.449c.686.034,1.278.063,1.306.77a.766.766,0,0,1-.735.8Z",
    transform: "translate(-754.277 -730.46)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(29.255 73.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M747.189,722.666a.777.777,0,0,1-.247-.041.767.767,0,0,1-.479-.972,6.288,6.288,0,0,0-1.041-5.568.766.766,0,1,1,1.17-.99,7.822,7.822,0,0,1,1.322,7.052A.767.767,0,0,1,747.189,722.666Z",
    transform: "translate(-745.241 -714.823)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(64.281 75.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M792.248,725.88a3.025,3.025,0,0,1-.276-1.209,6.545,6.545,0,0,1,.451-2.956,6.769,6.769,0,0,1,1.688-2.468,3.138,3.138,0,0,1,1.053-.692",
    transform: "translate(-791.184 -717.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M792.014,726.412a.766.766,0,0,1-.7-.447,3.775,3.775,0,0,1-.346-1.514,7.277,7.277,0,0,1,.506-3.256,7.578,7.578,0,0,1,1.878-2.744,3.834,3.834,0,0,1,1.29-.841.766.766,0,1,1,.568,1.423,2.371,2.371,0,0,0-.8.523,6.084,6.084,0,0,0-1.517,2.208,5.827,5.827,0,0,0-.4,2.613,2.348,2.348,0,0,0,.209.95.767.767,0,0,1-.377,1.016A.78.78,0,0,1,792.014,726.412Z",
    transform: "translate(-790.95 -717.555)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(30.248 105.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M783.438,758.671c0,.034-.477-.3-1.414-.683a10.574,10.574,0,0,0-4.179-.708,15.41,15.41,0,0,0-6.125,1.484,39.957,39.957,0,0,0-6.588,4.114,71.422,71.422,0,0,1-12.146,7.351c-1.656.776-3.006,1.339-3.953,1.706-.471.192-.841.323-1.108.412a1.924,1.924,0,0,1-.389.122",
    transform: "translate(-746.77 -756.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M747.3,773a.767.767,0,0,1-.151-1.518,1.162,1.162,0,0,0,.237-.073c.316-.108.672-.235,1.122-.418.831-.323,2.172-.871,3.918-1.69a70.853,70.853,0,0,0,12.012-7.271,40.734,40.734,0,0,1,6.706-4.187,16.061,16.061,0,0,1,6.441-1.563,11.241,11.241,0,0,1,4.481.759,11.632,11.632,0,0,1,1.359.654l.042.023a.768.768,0,0,1,.135,1.375.859.859,0,0,1-.924-.059,10.135,10.135,0,0,0-1.178-.569,9.663,9.663,0,0,0-3.864-.652,14.541,14.541,0,0,0-5.822,1.409,39.315,39.315,0,0,0-6.449,4.029,72.417,72.417,0,0,1-12.284,7.436c-1.789.839-3.166,1.4-4.005,1.728-.478.2-.866.333-1.143.425a2.425,2.425,0,0,1-.48.146A.79.79,0,0,1,747.3,773Z",
    transform: "translate(-746.536 -756.274)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(62.318 97.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M788.388,745.985",
    transform: "translate(-788.388 -745.985)",
    fill: "#fff",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(30.862 95.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M780.066,746.581a10.475,10.475,0,0,0-1.1-.79,7.482,7.482,0,0,0-3.5-.959,11.879,11.879,0,0,0-5.271,1.176,63.537,63.537,0,0,0-5.9,3.222,58.3,58.3,0,0,1-5.966,3.158,23.079,23.079,0,0,1-5.277,1.626,15.248,15.248,0,0,1-3.712.2,9.592,9.592,0,0,1-1.005-.126",
    transform: "translate(-747.572 -744.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M750.142,754.784c-.362,0-.723-.012-1.084-.037a10.535,10.535,0,0,1-1.087-.135.766.766,0,0,1,.268-1.509,8.811,8.811,0,0,0,.926.115,14.52,14.52,0,0,0,3.523-.192,22.373,22.373,0,0,0,5.1-1.571,57.866,57.866,0,0,0,5.881-3.113,64.646,64.646,0,0,1,5.962-3.258,12.669,12.669,0,0,1,5.61-1.251,8.276,8.276,0,0,1,3.871,1.057,11.221,11.221,0,0,1,1.208.867.766.766,0,0,1-.974,1.183,9.792,9.792,0,0,0-1.017-.733,6.712,6.712,0,0,0-3.113-.841,11.16,11.16,0,0,0-4.923,1.1,63.047,63.047,0,0,0-5.826,3.184,59.35,59.35,0,0,1-6.05,3.2,23.929,23.929,0,0,1-5.459,1.683A16.078,16.078,0,0,1,750.142,754.784Z",
    transform: "translate(-747.338 -743.832)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(27.567 91.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M755.1,739.053a3.157,3.157,0,0,1-.349.306,3.685,3.685,0,0,1-.449.309,6.032,6.032,0,0,1-.621.361,9.333,9.333,0,0,1-1.744.689,10.873,10.873,0,0,1-2.267.378,11.2,11.2,0,0,1-2.3-.155,9.275,9.275,0,0,1-1.805-.494,6.391,6.391,0,0,1-.657-.29,3.23,3.23,0,0,1-.476-.264c-.253-.153-.386-.249-.376-.267",
    transform: "translate(-743.276 -738.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M749.037,741.636a11.981,11.981,0,0,1-2.035-.172,10.05,10.05,0,0,1-1.951-.534,6.973,6.973,0,0,1-.73-.323,3.814,3.814,0,0,1-.553-.308c-.31-.187-1.014-.615-.608-1.3a.766.766,0,0,1,1.051-.266.781.781,0,0,1,.17.137c.049.034.12.077.21.133a2.65,2.65,0,0,0,.392.218,6.133,6.133,0,0,0,.614.273,8.535,8.535,0,0,0,1.663.455,10.487,10.487,0,0,0,2.145.146,10.147,10.147,0,0,0,2.089-.35,8.57,8.57,0,0,0,1.6-.632,5.142,5.142,0,0,0,.549-.318,3.236,3.236,0,0,0,.394-.268,2.858,2.858,0,0,0,.27-.233.766.766,0,0,1,1.12,1.046,3.782,3.782,0,0,1-.439.389,4.4,4.4,0,0,1-.533.365,6.4,6.4,0,0,1-.665.385,10.136,10.136,0,0,1-1.879.742,11.692,11.692,0,0,1-2.431.4C749.33,741.633,749.183,741.636,749.037,741.636Z",
    transform: "translate(-743.038 -738.061)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(37.519 88.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M784.454,735.716a1.154,1.154,0,0,1-.211.2,4.968,4.968,0,0,1-.69.471,7.765,7.765,0,0,1-2.908.958,13.4,13.4,0,0,1-4.533-.245c-1.7-.341-3.468-.932-5.368-1.394a24.216,24.216,0,0,0-9.933-.267c-1,.181-2.815.718-3.785,1.019",
    transform: "translate(-756.259 -734.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M778.852,737.965a14.157,14.157,0,0,1-3.146-.355c-1-.2-2.013-.484-3.089-.785-.743-.208-1.5-.421-2.289-.612a23.308,23.308,0,0,0-9.615-.258c-.86.156-2.471.617-3.693,1a.766.766,0,1,1-.455-1.464c.615-.191,2.709-.831,3.876-1.041a24.83,24.83,0,0,1,10.246.275c.805.2,1.584.414,2.344.626,1.047.293,2.036.569,3,.762a12.609,12.609,0,0,0,4.293.236,6.938,6.938,0,0,0,2.618-.864,4.161,4.161,0,0,0,.586-.4.539.539,0,0,0,.1-.091.766.766,0,0,1,1.185.972,1.866,1.866,0,0,1-.356.335,5.365,5.365,0,0,1-.762.516,8.461,8.461,0,0,1-3.192,1.051A14.16,14.16,0,0,1,778.852,737.965Z",
    transform: "translate(-756.026 -734.042)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(29.601 78.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M781.256,724.292a1.67,1.67,0,0,1-.357.07c-.235.009-.559.088-1.034.14a19.846,19.846,0,0,1-3.821-.132c-1.6-.2-3.483-.6-5.558-1.078a41.689,41.689,0,0,0-6.785-1.149,17.89,17.89,0,0,0-1.8.012c-.3.011-.589.022-.88.061l-.854.133a15.881,15.881,0,0,0-3.174.923c-1.97.782-3.685,1.661-5.2,2.235a14.182,14.182,0,0,1-3.7.959,5.724,5.724,0,0,1-1.038.039,1.534,1.534,0,0,1-.366-.02",
    transform: "translate(-745.927 -721.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M747.126,727.046c-.1,0-.2,0-.3-.006a2.366,2.366,0,0,1-.5-.032.766.766,0,0,1,.262-1.51.793.793,0,0,0,.185.01.863.863,0,0,1,.089,0,5.068,5.068,0,0,0,.9-.034,13.406,13.406,0,0,0,3.5-.908c.758-.287,1.563-.651,2.417-1.035.881-.4,1.792-.808,2.789-1.2a16.617,16.617,0,0,1,3.32-.966l.873-.136c.331-.044.647-.057.969-.07.611-.035,1.244-.038,1.866-.012a42.644,42.644,0,0,1,6.942,1.172c1.859.429,3.822.857,5.462,1.059a19.115,19.115,0,0,0,3.679.128c.179-.021.36-.05.514-.075a4.9,4.9,0,0,1,.538-.067.939.939,0,0,0,.159-.035.766.766,0,0,1,.454,1.464,2.431,2.431,0,0,1-.52.1,3.429,3.429,0,0,0-.385.05c-.178.029-.385.062-.63.089a20.7,20.7,0,0,1-4-.134c-1.7-.21-3.714-.648-5.63-1.09a40.958,40.958,0,0,0-6.679-1.133c-.539-.024-1.12-.02-1.7.013-.287.011-.555.02-.822.056l-.838.131a15.094,15.094,0,0,0-3,.875c-.971.385-1.866.789-2.732,1.179s-1.7.767-2.484,1.064a14.881,14.881,0,0,1-3.875,1A6.6,6.6,0,0,1,747.126,727.046Z",
    transform: "translate(-745.693 -721.126)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(67.345 65.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M801.049,720.738a2.993,2.993,0,0,1-.576-.383,10.808,10.808,0,0,1-1.4-1.284,11.862,11.862,0,0,1-2.882-5.51,11.681,11.681,0,0,1,.407-6.2,10.648,10.648,0,0,1,.784-1.715,3.127,3.127,0,0,1,.4-.616",
    transform: "translate(-795.182 -704.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M800.815,721.271a.761.761,0,0,1-.346-.083,3.77,3.77,0,0,1-.725-.481,11.44,11.44,0,0,1-1.472-1.352,12.643,12.643,0,0,1-3.065-5.863,12.454,12.454,0,0,1,.432-6.613,11.426,11.426,0,0,1,.841-1.841,3.718,3.718,0,0,1,.474-.726.767.767,0,1,1,1.181.978,2.362,2.362,0,0,0-.3.464,10.217,10.217,0,0,0-.749,1.633,10.917,10.917,0,0,0-.379,5.786,11.12,11.12,0,0,0,2.693,5.145,10.137,10.137,0,0,0,1.307,1.2,2.325,2.325,0,0,0,.457.308.766.766,0,0,1-.348,1.45Z",
    transform: "translate(-794.948 -704.033)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(28.36 63.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M745.073,703.2c.162-.064.326-.346.5-.331a3.116,3.116,0,0,1,1.362.342,5.929,5.929,0,0,1,1.666,1.257c.542.542,1.069,1.23,1.714,1.818a4.459,4.459,0,0,0,2.127,1.133,7.763,7.763,0,0,0,2.006.138,10.118,10.118,0,0,1,1.911-.128",
    transform: "translate(-744.307 -702.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M753.738,708.106a8.492,8.492,0,0,1-1.682-.167,5.22,5.22,0,0,1-2.506-1.331,14.649,14.649,0,0,1-1.083-1.133c-.218-.244-.429-.483-.643-.7a5.228,5.228,0,0,0-1.471-1.117,2.367,2.367,0,0,0-.833-.247,1.291,1.291,0,0,1-.4.264.767.767,0,0,1-.65-1.385l.041-.037a1.148,1.148,0,0,1,.888-.384,3.828,3.828,0,0,1,1.647.424,6.638,6.638,0,0,1,1.878,1.418c.214.212.446.473.685.741a13.693,13.693,0,0,0,.983,1.031,3.709,3.709,0,0,0,1.775.952,6.983,6.983,0,0,0,1.795.122c.351-.03.671-.06.939-.086,1.017-.1,1.228-.118,1.519.136a.79.79,0,0,1,.267.556.766.766,0,0,1-.736.8.748.748,0,0,1-.217-.023c-.142.008-.418.034-.686.06s-.6.057-.974.09C754.1,708.1,753.917,708.106,753.738,708.106Zm1.621-.877a.729.729,0,0,0,.047.237A.759.759,0,0,1,755.359,707.229Zm0,0v0ZM745.324,703.4h0Zm-.768-1.147h0Z",
    transform: "translate(-744.073 -701.87)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(41.082 54.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M767.122,697.531a19.548,19.548,0,0,1-5.942-.91.766.766,0,0,1,.521-1.441c.438.157,10.773,3.753,16.493-4.926a.766.766,0,0,1,1.28.844A14.116,14.116,0,0,1,767.122,697.531Z",
    transform: "translate(-760.675 -689.91)",
    fill: "#231f20"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(0 275.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M1237.352,980.435H420.212a.766.766,0,1,1,0-1.533h817.139a.766.766,0,1,1,0,1.533Z",
    transform: "translate(-419.446 -978.902)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2",
    transform: "translate(610.184 64.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    transform: "translate(45.058 39.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M1282.368,756.858s4.493,19.454,5.569,23.042,13.3,26.267,13.3,26.267a8.964,8.964,0,0,1,2.873,2.212c1.075,1.375,4.186,7.258,4.186,7.91s-7.058,2.8-7.956,2.45-3.779-7.765-3.779-7.765l.361-2.6s-12.043-18.064-13.3-20.546-8.088-22.865-8.088-22.865Z",
    transform: "translate(-1274.766 -756.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M1300.381,819.294a1.569,1.569,0,0,1-.554-.076c-.3-.118-1.212-.476-4.213-8.2a.761.761,0,0,1-.044-.383l.32-2.308c-1.5-2.249-11.985-18.017-13.186-20.381-1.27-2.5-7.851-22.133-8.131-22.968a.767.767,0,0,1,.141-.737l6.835-8.111a.766.766,0,0,1,1.333.322c.045.194,4.5,19.471,5.556,22.993.985,3.29,11.885,23.6,13.128,25.911a9.675,9.675,0,0,1,2.893,2.288c.927,1.183,4.372,7.39,4.372,8.411a1.117,1.117,0,0,1-.562.89A24.192,24.192,0,0,1,1300.381,819.294Zm.055-1.5a26.317,26.317,0,0,0,6.778-1.994,53.594,53.594,0,0,0-3.939-7.186,8.142,8.142,0,0,0-2.6-2,.763.763,0,0,1-.339-.326c-.5-.929-12.277-22.79-13.362-26.41-.907-3.026-4.156-16.945-5.235-21.6l-5.571,6.611c.97,2.889,6.784,20.141,7.907,22.353,1.225,2.413,13.136,20.287,13.256,20.468a.765.765,0,0,1,.122.53l-.334,2.4C1298.31,813.705,1299.866,817.18,1300.436,817.8Z",
    transform: "translate(-1274.533 -755.858)",
    fill: "#231f20"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(41.594 32.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M1286.88,767.707l-5.415,3.349-5.1,3.134s-2.089-5.576-3.656-10.353a33.606,33.606,0,0,1-1.7-6.329c-.038-2.458,6.789-10.753,6.789-10.753C1282.026,749.1,1286.88,767.707,1286.88,767.707Z",
    transform: "translate(-1270.245 -745.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M1276.132,774.721a.776.776,0,0,1-.249-.041.767.767,0,0,1-.468-.455c-.021-.057-2.113-5.646-3.667-10.384-1.2-3.66-1.736-5.685-1.736-6.567-.041-2.6,5.795-9.818,6.965-11.24a.764.764,0,0,1,.962-.183c4.385,2.432,8.943,19.492,9.449,21.429a.768.768,0,0,1-.339.845l-10.517,6.483A.763.763,0,0,1,1276.132,774.721Zm1.575-27.158c-2.713,3.366-6.185,8.278-6.163,9.7,0,.482.288,1.92,1.659,6.1,1.181,3.6,2.674,7.7,3.322,9.451l9.235-5.693C1284.375,761.963,1280.737,750.272,1277.707,747.563Z",
    transform: "translate(-1270.012 -745.754)",
    fill: "#231f20"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(0 37.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M1247.335,753.284s-22.618,2.3-25.26,4.431c-1.413,1.129-2.411,9.877-2.212,15.614,0,0-3.633,4.77-3.073,16.936s2.781,19.493,5.3,20.952,25.23.446,27.219-.768S1247.335,753.284,1247.335,753.284Z",
    transform: "translate(-1215.966 -752.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M1230.288,812.459c-4.261,0-7.813-.231-8.816-.812-3.015-1.746-5.139-9.814-5.68-21.58-.506-10.966,2.332-16.074,3.064-17.2-.129-4.8.612-14.471,2.507-15.986,2.737-2.2,23.324-4.357,25.661-4.595a.756.756,0,0,1,.571.175.766.766,0,0,1,.271.533c.01.14,1,14.156,1.734,28.142,1.508,28.735.564,29.311-.125,29.732C1248.125,811.693,1238.036,812.459,1230.288,812.459Zm16.1-58.565c-8.716.915-22.33,2.782-24.072,4.185-.985.787-2.146,8.671-1.927,14.99a.766.766,0,0,1-.156.491c-.033.044-3.455,4.766-2.916,16.436.571,12.4,2.881,19.145,4.918,20.324,2.315,1.341,23.8.357,26.31-.7C1249.624,806.624,1247.83,774.356,1246.393,753.894Z",
    transform: "translate(-1215.732 -752.283)",
    fill: "#231f20"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(12.041 184.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M1232.444,953.6l3.748,4.34,9.186-8.249-3.748-4.332Z",
    transform: "translate(-1231.678 -944.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M1235.958,958.472c-.016,0-.032,0-.048,0a.765.765,0,0,1-.531-.264l-3.748-4.339a.767.767,0,0,1,.067-1.071l9.186-8.241a.767.767,0,0,1,1.091.068l3.748,4.332a.767.767,0,0,1-.067,1.072l-9.186,8.248A.766.766,0,0,1,1235.958,958.472Zm-2.676-5.038,2.746,3.179,8.044-7.224-2.745-3.173Z",
    transform: "translate(-1231.445 -944.359)",
    fill: "#231f20"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(16.656 185.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M1242.207,946.138l3.748,4.332-4.739,4.255-3.748-4.339Z",
    transform: "translate(-1237.468 -946.138)",
    fill: "#231f20"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(17.662 89.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M1239.781,916.839s17.78-23.041,21.16-31.851-15.7-59.485-15.7-59.485l21.39-4.309s15.753,38.817,13.825,56.966-33.333,45.99-33.333,45.99Z",
    transform: "translate(-1239.014 -820.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M1246.89,924.684a.767.767,0,0,1-.541-.223l-7.343-7.312a.767.767,0,0,1-.066-1.012c.177-.23,17.75-23.052,21.051-31.657,2.591-6.753-9.137-41.507-15.7-58.941a.768.768,0,0,1,.566-1.021l21.39-4.308a.767.767,0,0,1,.861.463c.646,1.592,15.8,39.2,13.877,57.334-1.937,18.235-32.3,45.338-33.587,46.483A.76.76,0,0,1,1246.89,924.684Zm-6.325-8.146,6.35,6.323c4.134-3.767,30.809-28.658,32.546-45.016,1.757-16.544-11.587-51.072-13.538-56.007l-19.882,4c2.563,6.89,18.622,50.739,15.382,59.187C1258.288,893.2,1243.318,912.942,1240.565,916.538Z",
    transform: "translate(-1238.781 -820.195)",
    fill: "#231f20"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(6.832 191.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M1236.113,959.584l-5.612-5.278a.572.572,0,0,0-.7-.053l-4.759,3.264a.933.933,0,0,0-.231,1.3l0,0a.7.7,0,0,0,.132.149c1.848,1.672,3.273,2.8,5.551,4.936,1.408,1.32,5.506,5.428,7.442,7.248s3.984.132,3.36-.783c-2.832-4.117-4.5-7.7-4.689-9.791A1.571,1.571,0,0,0,1236.113,959.584Z",
    transform: "translate(-1224.647 -954.159)",
    fill: "#231f20"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(15.75 183.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M1245,955.621l-7.719-9.739,2.6-2.227,8.179,9.961Z",
    transform: "translate(-1236.519 -942.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M1244.771,956.153a.764.764,0,0,1-.6-.29l-7.719-9.739a.766.766,0,0,1,.1-1.057l2.6-2.228a.767.767,0,0,1,1.09.1l8.179,9.962a.767.767,0,0,1-.172,1.128l-3.064,2A.767.767,0,0,1,1244.771,956.153Zm-6.661-10.4,6.826,8.612,1.764-1.154-7.141-8.7Z",
    transform: "translate(-1236.285 -942.655)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(15.75 183.086)",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M1245,955.621l-7.719-9.739,2.6-2.227,8.179,9.961Z",
    transform: "translate(-1236.519 -942.889)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M1244.771,956.153a.764.764,0,0,1-.6-.29l-7.719-9.739a.766.766,0,0,1,.1-1.057l2.6-2.228a.767.767,0,0,1,1.09.1l8.179,9.962a.767.767,0,0,1-.172,1.128l-3.064,2A.767.767,0,0,1,1244.771,956.153Zm-6.661-10.4,6.826,8.612,1.764-1.154-7.141-8.7Z",
    transform: "translate(-1236.285 -942.655)",
    fill: "#231f20"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(29.605 194.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M1255.366,971.966h5.53l.453-12.8h-5.53Z",
    transform: "translate(-1254.6 -958.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M1260.663,972.5h-5.53a.766.766,0,0,1-.766-.793l.453-12.8a.767.767,0,0,1,.766-.74h5.529a.767.767,0,0,1,.766.793l-.453,12.8A.767.767,0,0,1,1260.663,972.5Zm-4.736-1.533h4l.4-11.263h-4Z",
    transform: "translate(-1254.367 -958.17)",
    fill: "#231f20"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(27.944 207.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M1261.291,975.036h-7.384a.525.525,0,0,0-.515.414l-1.175,5.4a.9.9,0,0,0,.694,1.064h.194c2.391-.042,4.131-.185,7.13-.185,1.85,0,7.426.194,9.977.194s2.881-2.534,1.834-2.754c-4.68-1.022-8.2-2.433-9.707-3.776A1.436,1.436,0,0,0,1261.291,975.036Z",
    transform: "translate(-1252.199 -975.033)",
    fill: "#231f20"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399",
    transform: "translate(30.587 196.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M1255.885,959.909h5.53l-.238,6.6h-5.53Z",
    transform: "translate(-1255.647 -959.909)",
    fill: "#231f20"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(16.488 85.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M1238.247,817.606c0,30.829,12.858,52.1,11.352,112.5h10.107s8.211-42.073,1.851-113.555Z",
    transform: "translate(-1237.482 -815.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M1259.473,930.642h-10.107a.765.765,0,0,1-.765-.785c.9-36.041-3.412-58.55-6.875-76.636-2.4-12.547-4.477-23.383-4.477-35.847a.765.765,0,0,1,.732-.766l23.31-1.053a.775.775,0,0,1,.8.7c6.3,70.771-1.78,113.348-1.862,113.769A.767.767,0,0,1,1259.473,930.642Zm-9.323-1.533h8.684c.957-5.458,7.541-46.508,1.792-111.991l-21.843.986c.08,12.015,2.107,22.6,4.448,34.827C1246.682,870.959,1250.971,893.363,1250.15,929.11Z",
    transform: "translate(-1237.248 -815.555)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(16.488 85.691)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M1238.247,817.606c0,30.829,12.858,52.1,11.352,112.5h10.107s8.211-42.073,1.851-113.555Z",
    transform: "translate(-1237.482 -815.789)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M1259.473,930.642h-10.107a.765.765,0,0,1-.765-.785c.9-36.041-3.412-58.55-6.875-76.636-2.4-12.547-4.477-23.383-4.477-35.847a.765.765,0,0,1,.732-.766l23.31-1.053a.775.775,0,0,1,.8.7c6.3,70.771-1.78,113.348-1.862,113.769A.767.767,0,0,1,1259.473,930.642Zm-9.323-1.533h8.684c.957-5.458,7.541-46.508,1.792-111.991l-21.843.986c.08,12.015,2.107,22.6,4.448,34.827C1246.682,870.959,1250.971,893.363,1250.15,929.11Z",
    transform: "translate(-1237.248 -815.555)",
    fill: "#231f20"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(27.178 196.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M1264.127,965.247H1252.2v-3.564l12.373-.238Z",
    transform: "translate(-1251.433 -960.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M1263.893,965.78h-11.928a.767.767,0,0,1-.766-.766V961.45a.767.767,0,0,1,.752-.766l12.373-.238a.782.782,0,0,1,.582.251.764.764,0,0,1,.193.6l-.445,3.8A.767.767,0,0,1,1263.893,965.78Zm-11.162-1.533h10.48l.264-2.252-10.744.206Z",
    transform: "translate(-1251.199 -960.446)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(27.178 196.719)",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M1264.127,965.247H1252.2v-3.564l12.373-.238Z",
    transform: "translate(-1251.433 -960.68)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M1263.893,965.78h-11.928a.767.767,0,0,1-.766-.766V961.45a.767.767,0,0,1,.752-.766l12.373-.238a.782.782,0,0,1,.582.251.764.764,0,0,1,.193.6l-.445,3.8A.767.767,0,0,1,1263.893,965.78Zm-11.162-1.533h10.48l.264-2.252-10.744.206Z",
    transform: "translate(-1251.199 -960.446)",
    fill: "#231f20"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(5.347 30.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M1266.436,808.165l-34.172-2.416c1.035-8.728,1.5-23.632,1.7-36.452l-.321.665-9.936-5.781s7.187-18.517,10.392-18.763c14.213-2.022,32.643.838,32.643.838C1269.654,764.8,1266.436,808.165,1266.436,808.165Z",
    transform: "translate(-1222.943 -743.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M1266.2,808.7l-.055,0-34.172-2.417a.767.767,0,0,1-.707-.854c1.04-8.761,1.485-23.655,1.676-35.081l-9.855-5.734a.766.766,0,0,1-.329-.94c1.726-4.449,7.627-18.986,11.047-19.25,14.114-2.008,32.634.816,32.819.845a.767.767,0,0,1,.64.639c2.89,18.415-.269,61.649-.3,62.084A.766.766,0,0,1,1266.2,808.7Zm-33.321-3.891,32.609,2.306c.4-5.812,2.858-43.248.346-60.413-3.174-.449-19.294-2.545-31.864-.756-1.691.132-6.2,9.156-9.547,17.671l8.658,5.037a.767.767,0,0,1,1.413.423C1234.324,780.355,1233.9,795.553,1232.883,804.809Z",
    transform: "translate(-1222.709 -743.701)",
    fill: "#231f20"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(26.487 16.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M1251.3,740.345c2.419,2.719,9.07,2.512,9.07,2.512s4.217-.692,3.488-2.059c-2.366-.653-3.418-1.9-3.749-3.395a7.086,7.086,0,0,1,.047-2.78,14.9,14.9,0,0,1,.369-1.536l-7.474-6.858C1253.685,730.322,1254.223,737.748,1251.3,740.345Z",
    transform: "translate(-1250.531 -725.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M1259.778,743.393c-1.507,0-6.982-.183-9.287-2.772a.767.767,0,0,1,.064-1.083c2.327-2.065,2.3-8.29,1.5-13.425a.767.767,0,0,1,1.276-.683l7.473,6.859a.765.765,0,0,1,.216.782,14.328,14.328,0,0,0-.349,1.457,6.325,6.325,0,0,0-.046,2.5c.3,1.361,1.35,2.283,3.2,2.794a.763.763,0,0,1,.472.378,1.369,1.369,0,0,1,.03,1.282c-.611,1.238-3.269,1.762-4.069,1.893a.626.626,0,0,1-.1.01C1260.123,743.39,1259.989,743.393,1259.778,743.393Zm-7.628-3.32c2.061,1.571,6.27,1.826,7.91,1.785a9.26,9.26,0,0,0,2.587-.8,5.091,5.091,0,0,1-3.522-3.719,7.847,7.847,0,0,1,.045-3.109c.068-.369.153-.749.254-1.127l-5.573-5.115C1254.251,731.685,1254.391,737.269,1252.15,740.073Z",
    transform: "translate(-1250.298 -725.228)",
    fill: "#231f20"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(29.379 22.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M1254.079,733.131c-.243,6.188,4.626,8.419,7.06,9.019a8.934,8.934,0,0,1,.058-3.51Z",
    transform: "translate(-1254.071 -733.131)",
    fill: "#231f20"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(36.715 5.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M1270.6,710.783s2.035,7.435-1.636,10.806-5.323-10.7-5.323-10.7Z",
    transform: "translate(-1263.645 -710.783)",
    fill: "#231f20"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(25.865 5.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M1256.428,710.316l.289,2.455a1.828,1.828,0,0,0-.938,2.3c.782,2.072-.4,5.27-1.994,6.536,0,0-.047-.891-.781-.687s-.571,4.871.891,7.1c0,0-2.22-2.017-3.455-6.919-1.142-4.526-1.267-8.294-.329-10.046Z",
    transform: "translate(-1249.486 -710.316)",
    fill: "#231f20"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(25.02 3.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M1267.1,725.543a5.543,5.543,0,0,1-.271.765,7.687,7.687,0,0,1-3.945,4.056,6.913,6.913,0,0,1-8.2-1.727,8.622,8.622,0,0,1-2.108-4.462.217.217,0,0,1-.086-.025,5.25,5.25,0,0,1-2.848-2.785,2.315,2.315,0,0,1,1.973-3.378,1.686,1.686,0,0,1,.654.086v-1.084a7.417,7.417,0,0,1,.727-3.378,7.492,7.492,0,0,1,9.985-3.538C1268.221,712.526,1268.541,720.687,1267.1,725.543Z",
    transform: "translate(-1248.616 -708.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M1259.689,731.565a7.67,7.67,0,0,1-5.82-2.66,9.286,9.286,0,0,1-2.2-4.406,6.032,6.032,0,0,1-2.966-3.063,2.958,2.958,0,0,1-.322-1.314,3.046,3.046,0,0,1,.847-2.193,3,3,0,0,1,2.038-.936v-.236a8.256,8.256,0,0,1,11.808-7.608c5.682,2.661,6.067,11.177,4.524,16.377a6.322,6.322,0,0,1-.308.865,8.412,8.412,0,0,1-4.328,4.44A7.647,7.647,0,0,1,1259.689,731.565Zm-7.174-8.369a.766.766,0,0,1,.582.614,7.84,7.84,0,0,0,1.926,4.086,6.157,6.157,0,0,0,7.3,1.543,6.906,6.906,0,0,0,3.565-3.657,4.85,4.85,0,0,0,.242-.68l0-.008c1.349-4.54,1.1-12.307-3.707-14.559a6.724,6.724,0,0,0-9.621,6.206v1.1a.767.767,0,0,1-1.021.723.934.934,0,0,0-.356-.044,1.509,1.509,0,0,0-1.084.467,1.572,1.572,0,0,0-.245,1.8A4.538,4.538,0,0,0,1252.516,723.2Zm.008,0,.021.008Zm-.177-.022h0Zm0,0h0Z",
    transform: "translate(-1248.382 -708.346)",
    fill: "#231f20"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(25.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M1249.428,712.881s-1.563-5.347,3.62-6.536h-1.907a14.951,14.951,0,0,1,9.693-2.564c5.363.641,6.114,3.127,6.114,3.127a5.771,5.771,0,0,0-.454-2.2s4.964,4.347-.539,6.575C1265.955,711.271,1253.743,710.481,1249.428,712.881Z",
    transform: "translate(-1249.206 -703.729)",
    fill: "#231f20"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(15.281 29.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M1241.474,743.957s4.132,14.869-4.8,38.878V786.3s12.626-17.35,9.785-42.481Z",
    transform: "translate(-1235.908 -743.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M1236.44,786.831a.766.766,0,0,1-.766-.766V782.6a.754.754,0,0,1,.048-.267c8.726-23.457,4.82-38.26,4.779-38.407a.767.767,0,0,1,.718-.97l4.984-.138a.758.758,0,0,1,.783.68,66.234,66.234,0,0,1-9.927,43.017A.765.765,0,0,1,1236.44,786.831Zm.766-4.093v.684a65.7,65.7,0,0,0,8.332-39.052l-3.339.092C1242.952,748.116,1244.909,761.957,1237.207,782.739Z",
    transform: "translate(-1235.674 -742.818)",
    fill: "#231f20"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(3.149 40.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M1235.354,763.3l8.84-5.315a14.951,14.951,0,0,1,2.857,8.2l-7.68,4.893s-9.984,22.764-15.361,21.505-3.126-10.069.9-24.217l7.757,2.949,2.688-4.254Z",
    transform: "translate(-1220.074 -757.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M1224.181,793.159a2.49,2.49,0,0,1-.579-.066,4.343,4.343,0,0,1-2.877-2.057c-2.114-3.593-.2-11.13,3.213-23.114a.766.766,0,0,1,1.009-.507l7.172,2.727,2.235-3.538v-3.542a.766.766,0,0,1,.372-.657l8.84-5.315a.767.767,0,0,1,.974.155c.1.122,2.6,3.05,3.042,8.645a.765.765,0,0,1-.353.706l-7.484,4.768C1237.893,775.559,1229.787,793.158,1224.181,793.159Zm1-24.015c-3.066,10.813-4.894,18.13-3.138,21.114a2.827,2.827,0,0,0,1.905,1.343c3.279.769,10.445-11.857,14.484-21.067a.77.77,0,0,1,.29-.339l7.287-4.641a15.307,15.307,0,0,0-2.258-6.789l-7.867,4.73v3.33a.77.77,0,0,1-.119.41l-2.688,4.255a.767.767,0,0,1-.92.307Zm9.937-2.32h0Z",
    transform: "translate(-1219.841 -756.98)",
    fill: "#231f20"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(17.371 92.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M1238.4,824.62l.357,5.267,30.231-.866-.852-2.3Z",
    transform: "translate(-1238.401 -824.62)",
    fill: "#231f20"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-6",
    transform: "translate(91.907 50.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(56.956 224.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M629.219,978.862l.7,15.045s-15.058,5.759-15.205,8.556l29.22-.3-.121-23.486Z",
    transform: "translate(-613.945 -977.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M614.477,1003a.768.768,0,0,1-.765-.807c.151-2.868,10.274-7.132,15.179-9.032l-.672-14.493a.766.766,0,0,1,.756-.8l14.591-.185a.768.768,0,0,1,.776.762l.121,23.486a.766.766,0,0,1-.758.77l-29.22.3Zm15.31-23.612.661,14.254a.766.766,0,0,1-.492.751c-6.572,2.514-12.336,5.432-14.134,7.061l27.105-.28-.113-21.951Z",
    transform: "translate(-613.712 -977.676)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(72.396 229.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M633.861,984.22l.122,2.681,14.36-.281-.006-2.419Z",
    transform: "translate(-633.861 -984.2)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(99.801 204.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M670.623,963.609l11.814,9.337s-5.523,15.147-3.507,17.087l18.93-22.258-17.816-15.314Z",
    transform: "translate(-669.857 -951.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M678.7,990.566a.768.768,0,0,1-.531-.214c-2.068-1.99,1.349-12.43,3.129-17.381l-11.38-8.994a.766.766,0,0,1-.11-1.1l9.42-11.148a.768.768,0,0,1,1.085-.087l17.816,15.314a.766.766,0,0,1,.084,1.077L679.28,990.3a.768.768,0,0,1-.546.269Zm-7.21-27.3,11.192,8.845a.766.766,0,0,1,.244.864c-2.41,6.612-3.986,12.875-3.935,15.3l17.56-20.648L679.9,953.313Z",
    transform: "translate(-669.623 -951.462)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(108.384 218.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M700.243,971.971l-1.772-1.529-17.541,21.95s-.409,1.356.384,1.836Z",
    transform: "translate(-680.824 -970.442)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(102.909 206.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M673.68,966.071l2.105,1.67,9.2-11.026-1.83-1.581Z",
    transform: "translate(-673.68 -955.134)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(53.78 121.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M623.829,883.931s.781-35.94,0-35.94-6.323-3.162-6.323-3.162l-6.924,53.4s-.64,6,6.8,10.239,40.592,33.718,40.592,33.718L669.207,928.5s-21.828-22.75-30.717-30.269A171.706,171.706,0,0,1,623.829,883.931Z",
    transform: "translate(-609.8 -844.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M657.736,942.725a.766.766,0,0,1-.509-.194c-.331-.294-33.18-29.471-40.463-33.626-7.782-4.44-7.206-10.72-7.178-10.986l6.926-53.421a.766.766,0,0,1,1.139-.567,47.915,47.915,0,0,0,5.992,3.064.719.719,0,0,1,.523.24c.288.294.961.98.2,36.173a169.974,169.974,0,0,0,14.379,14c8.822,7.463,30.562,30.1,30.78,30.328a.766.766,0,0,1,.04,1.017l-11.238,13.688a.771.771,0,0,1-.533.278Zm-39.85-96.9L611.108,898.1c-.02.205-.457,5.554,6.416,9.475,6.958,3.971,35.481,29.166,40.124,33.283l10.3-12.546c-3.232-3.355-22.153-22.927-30.188-29.725a173.7,173.7,0,0,1-14.735-14.374.77.77,0,0,1-.2-.53c.27-12.412.536-32.319.157-35.3A42.118,42.118,0,0,1,617.886,845.824Zm5.575,2.688a.744.744,0,0,0,.133.012A.9.9,0,0,1,623.46,848.512Z",
    transform: "translate(-609.566 -843.83)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(88.171 181.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M654.821,935.826l19.839,16.462,4.8-5.85-25.016-24.875Z",
    transform: "translate(-654.447 -921.562)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(60.124 114.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M646.094,873.446l.762-5.689s5.465-11.52,6.246-16.422.268-15.525.268-15.525H618.845s.147,38.98,4.313,49.916c0,0,2.112,20.927,2.425,22.68.64,3.724,2.963,41.827,2.963,41.827l17.406-.641s1.51-35.03.3-44.975c-.6-4.928-.877-10.176-1.012-14.514A103.726,103.726,0,0,1,646.094,873.446Z",
    transform: "translate(-618.079 -835.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M628.312,950.766a.766.766,0,0,1-.764-.72c-.023-.381-2.328-38.1-2.953-41.744-.307-1.713-2.246-20.881-2.423-22.633-4.132-11.064-4.321-48.5-4.327-50.089a.767.767,0,0,1,.766-.769h34.525a.766.766,0,0,1,.766.729c.021.437.507,10.759-.277,15.683-.757,4.754-5.665,15.261-6.259,16.52l-.746,5.571a103.251,103.251,0,0,0-.844,16.534c.169,5.458.507,10.318,1.005,14.445,1.2,9.893-.234,43.668-.3,45.1a.765.765,0,0,1-.737.733l-17.407.64Zm17.407-1.406h0ZM619.384,836.344c.05,5.52.509,39.036,4.257,48.877a.782.782,0,0,1,.046.2c.021.209,2.113,20.917,2.418,22.622.6,3.483,2.59,35.668,2.927,41.169l15.951-.586c.2-5.013,1.37-35.152.277-44.144-.5-4.171-.846-9.077-1.016-14.582a104.752,104.752,0,0,1,.857-16.782h0l.761-5.689a.786.786,0,0,1,.067-.227c.054-.114,5.427-11.476,6.182-16.213.643-4.034.388-12.166.291-14.638Z",
    transform: "translate(-617.845 -834.811)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(71.227 44.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M651.062,744.9a29.946,29.946,0,0,1,16.933,1.779c2.375.992,4.73,2.394,6.009,4.627,1.523,2.637,1.28,5.887,1.107,8.927a105.107,105.107,0,0,0,.64,18.559c.64,5.12,1.644,10.239,1.625,15.359s-1.171,10.508-4.4,14.526c-4.985,6.189-13.861,7.929-21.758,6.873a25.324,25.324,0,0,1-11.673-4.261,14.607,14.607,0,0,1-6.207-10.451",
    transform: "translate(-632.568 -743.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M655.407,816.378a34.143,34.143,0,0,1-4.527-.307,25.963,25.963,0,0,1-12.023-4.4,15.389,15.389,0,0,1-6.52-11.016.766.766,0,0,1,1.529-.106,13.847,13.847,0,0,0,5.9,9.884,24.471,24.471,0,0,0,11.322,4.121c8.9,1.189,16.776-1.274,21.061-6.594,3.471-4.317,4.218-10.022,4.233-14.049a77.81,77.81,0,0,0-1.063-11.212c-.194-1.349-.388-2.7-.556-4.049a106.219,106.219,0,0,1-.645-18.7l.018-.3c.165-2.877.336-5.851-1.023-8.2-.987-1.723-2.831-3.13-5.641-4.3a29.1,29.1,0,0,0-16.5-1.733.767.767,0,0,1-.28-1.507,30.651,30.651,0,0,1,17.366,1.825c3.134,1.31,5.221,2.929,6.381,4.953,1.587,2.747,1.394,6.1,1.224,9.056l-.017.3a104.664,104.664,0,0,0,.635,18.421c.168,1.339.36,2.68.553,4.021a78.921,78.921,0,0,1,1.078,11.435c-.016,4.271-.822,10.341-4.572,15C669.467,813.722,662.957,816.378,655.407,816.378Z",
    transform: "translate(-632.335 -743.39)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(98.822 53.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M683.431,769.693c-.013-.006-.257.211-.769.506a4.53,4.53,0,0,1-2.368.55,5.42,5.42,0,0,1-3.334-1.28,9.688,9.688,0,0,1-2.611-3.6,39.561,39.561,0,0,1-1.5-4.313,21.7,21.7,0,0,0-1.369-3.52,9.576,9.576,0,0,0-1.44-2.106,2.8,2.8,0,0,0-.7-.64",
    transform: "translate(-668.579 -754.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M680.259,771.287c-.077,0-.154,0-.231-.005a6.207,6.207,0,0,1-3.8-1.461,10.519,10.519,0,0,1-2.823-3.893,40.346,40.346,0,0,1-1.527-4.4,20.92,20.92,0,0,0-1.32-3.39,8.779,8.779,0,0,0-1.322-1.931,2.148,2.148,0,0,0-.543-.508.766.766,0,1,1,.828-1.29,3.547,3.547,0,0,1,.89.816,10.091,10.091,0,0,1,1.518,2.23,22.492,22.492,0,0,1,1.421,3.649,39.069,39.069,0,0,0,1.47,4.235,8.956,8.956,0,0,0,2.4,3.315,4.665,4.665,0,0,0,2.857,1.094,3.744,3.744,0,0,0,1.977-.457,5.9,5.9,0,0,0,.6-.4.8.8,0,0,1,.871-.123.766.766,0,0,1,.055,1.345,7.712,7.712,0,0,1-.779.513A5.314,5.314,0,0,1,680.259,771.287Z",
    transform: "translate(-668.345 -754.288)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(101.132 65.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M672.361,820.9a2.471,2.471,0,0,0,.094-.494q.076-.557.189-1.444c.158-1.267.366-3.066.631-5.308.474-4.491,1.041-10.7,1.533-17.565s.788-13.1.952-17.615c.082-2.255.133-4.079.151-5.339v-1.451a2.156,2.156,0,0,0,0-.507",
    transform: "translate(-671.594 -770.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M672.127,821.429a.768.768,0,0,1-.734-.987,1.674,1.674,0,0,0,.065-.339c.054-.408.117-.887.192-1.476.113-.913.254-2.107.424-3.546l.206-1.755c.319-3.026.943-9.341,1.529-17.53.523-7.3.806-13.6.952-17.589.079-2.18.131-4.021.15-5.324v-1.438a.823.823,0,0,1,.005-.088,1.416,1.416,0,0,0,0-.331.766.766,0,0,1,1.523-.176,2.947,2.947,0,0,1,0,.636V772.9c-.02,1.326-.072,3.178-.152,5.368-.146,4.005-.429,10.316-.954,17.642-.589,8.212-1.215,14.546-1.535,17.591l-.208,1.763c-.17,1.443-.31,2.641-.424,3.559q-.115.894-.191,1.453a3.058,3.058,0,0,1-.12.611A.766.766,0,0,1,672.127,821.429Z",
    transform: "translate(-671.36 -770.171)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(103.608 87.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M686.734,800.734c-.007-.115-2.5-.1-5.568-.179s-5.561-.23-5.574-.109",
    transform: "translate(-674.826 -799.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M686.5,801.268a.765.765,0,0,1-.278-.052c-.323-.033-1.382-.051-2.41-.068-.845-.014-1.838-.031-2.9-.059-.986-.027-1.912-.06-2.716-.089-1.1-.04-2.244-.079-2.586-.062a.776.776,0,0,1-.332.038.766.766,0,0,1-.681-.843c.083-.794.218-.789,3.654-.665.8.029,1.722.062,2.7.089,1.056.028,2.043.044,2.884.058,3.257.055,3.385.057,3.428.844a.767.767,0,0,1-.723.808Zm-.765-.722a.84.84,0,0,0,.013.1A.857.857,0,0,1,685.735,800.547Zm0,0v0Zm-9.615-.249a.651.651,0,0,1-.014.086A.8.8,0,0,0,676.12,800.3Z",
    transform: "translate(-674.592 -799.407)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(77.169 29.259)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    width: 17.483,
    height: 39.069,
    rx: 8.009,
    transform: "matrix(0.033, -0.999, 0.999, 0.033, 0.568, 18.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M673.776,743.166c-.077,0-.153,0-.231,0l-26.78-.884a6.911,6.911,0,0,1-6.672-7.126l.172-5.207a6.9,6.9,0,0,1,7.127-6.672l26.779.884a6.911,6.911,0,0,1,6.672,7.127l-.172,5.206A6.912,6.912,0,0,1,673.776,743.166ZM647.16,724.8A5.37,5.37,0,0,0,641.8,730l-.172,5.207a5.377,5.377,0,0,0,5.191,5.544l26.78.884h0a5.376,5.376,0,0,0,5.545-5.191l.172-5.207a5.376,5.376,0,0,0-5.191-5.544l-26.779-.884C647.281,724.8,647.22,724.8,647.16,724.8Z",
    transform: "translate(-640.089 -723.269)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(101.328 30.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M680.131,725.359a4.348,4.348,0,0,0-2.8.525,8.044,8.044,0,0,0-3.168,2.815,10.668,10.668,0,0,0-1.5,4.966,8.9,8.9,0,0,0,1.031,5.081,7.2,7.2,0,0,0,3.033,2.962,7.613,7.613,0,0,0,2.874,1.112",
    transform: "translate(-671.85 -724.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M679.36,743.354h-.029a7.1,7.1,0,0,1-2.867-1.024l-.33-.174a7.943,7.943,0,0,1-3.353-3.277,9.635,9.635,0,0,1-1.12-5.521,11.427,11.427,0,0,1,1.609-5.287,8.847,8.847,0,0,1,3.485-3.108,5.1,5.1,0,0,1,3.257-.6.766.766,0,1,1-.228,1.516,3.6,3.6,0,0,0-2.309.432,7.345,7.345,0,0,0-2.907,2.569,9.906,9.906,0,0,0-1.38,4.584,8.14,8.14,0,0,0,.939,4.68,6.417,6.417,0,0,0,2.71,2.647l.346.182a5.955,5.955,0,0,0,2.206.845.766.766,0,0,1-.029,1.532Z",
    transform: "translate(-671.616 -724.312)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(92.067 30.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M662.982,724.656l4.07.2a4.718,4.718,0,0,0-2.873,1.6,7.9,7.9,0,0,0-1.568,2.937,12.747,12.747,0,0,0,3.839,12.933l-3.3-.051s-8.018-9.676-.2-17.624",
    transform: "translate(-659.531 -724.656)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(73.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M636.617,708.472c-1.775-4.293-1.871-11.748.84-15.7s7.789-6.512,12.451-7.509a4,4,0,0,1,2.355,0,1.591,1.591,0,0,1,.969,1.925,9.835,9.835,0,0,1,2.969-1.379,3.358,3.358,0,0,1,3.1.682,2.048,2.048,0,0,1,.129,2.894l-.047.049a3.57,3.57,0,0,1,4.513,4.778,11.4,11.4,0,0,1-2.608,3.474,3.211,3.211,0,0,0-.976,3.147",
    transform: "translate(-635.343 -685.086)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(71.483 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M659.536,701.923c-.148,5.621-.394,11.835-.752,14.83-.74,6.176-7.039,6.472-7.039,6.472-.012.185-.1,1.738-.172,3.587a7.339,7.339,0,0,1-2.256,4.956,7.229,7.229,0,0,1-5.042,2.046c-.123,0-.247,0-.369-.012a7.314,7.314,0,0,1-6.966-7.667l.641-13.832c-.727.136-4.179.172-3.9-3.624.284-3.637,3.279-2.934,4.192-2.626l.209-4.536c.148-6.5,4.031-11.822,10.5-11.5l.591.061A11.616,11.616,0,0,1,659.536,701.923Z",
    transform: "translate(-632.902 -689.235)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M644.041,734.347a4.338,4.338,0,0,1-.446-.016,8.079,8.079,0,0,1-7.654-8.467l.6-12.994a4.355,4.355,0,0,1-2.684-1,4.02,4.02,0,0,1-1.172-3.482,3.408,3.408,0,0,1,4.233-3.533l.166-3.607a13.524,13.524,0,0,1,3.884-9.627,9.919,9.919,0,0,1,7.422-2.6l.633.064a12.448,12.448,0,0,1,11.042,12.629c-.108,4.1-.349,11.484-.757,14.9a8.049,8.049,0,0,1-7.07,7.06c-.035.652-.088,1.732-.136,2.939a8.089,8.089,0,0,1-2.493,5.48A7.957,7.957,0,0,1,644.041,734.347ZM637.347,711.3a.767.767,0,0,1,.766.8l-.641,13.831a6.547,6.547,0,0,0,6.234,6.867,3.2,3.2,0,0,0,.335.011,6.436,6.436,0,0,0,4.508-1.83,6.565,6.565,0,0,0,2.025-4.444c.074-1.851.161-3.414.173-3.6a.766.766,0,0,1,.729-.714c.229-.012,5.663-.356,6.314-5.8.4-3.356.64-10.687.747-14.759h0a10.907,10.907,0,0,0-9.672-11.065l-.588-.061a8.386,8.386,0,0,0-6.262,2.2,12.011,12.011,0,0,0-3.4,8.557l-.21,4.554a.767.767,0,0,1-1.011.691,2.991,2.991,0,0,0-2.343.048,2.384,2.384,0,0,0-.84,1.911,2.584,2.584,0,0,0,.667,2.224,3.182,3.182,0,0,0,2.325.589A.711.711,0,0,1,637.347,711.3Z",
    transform: "translate(-632.668 -689.001)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(77.644 33.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M652.806,732.743c-4.658-.411-8.461-1.215-12.1-4.156,0,0,2.009,6.4,12.15,6.578Z",
    transform: "translate(-640.709 -728.587)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(75.942 2.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M664,693.829c.077,5.542-6.88,7.321-9.6,4.019-1.28-1.529-2.336-3.4-4.159-4.185a5.025,5.025,0,0,0-3.9.109h-.038a6.491,6.491,0,0,0-3.431,4.652c-.582,2.694-.333,5.12-1.228,7.571a1.71,1.71,0,0,1-.6.928,1.347,1.347,0,0,1-1.644-.557,5.248,5.248,0,0,1-.851-2.886,17.518,17.518,0,0,1,.781-6.861,11.943,11.943,0,0,1,3.9-5.631,11.277,11.277,0,0,1,8.179-2.106,13.9,13.9,0,0,1,7.68,3.718,8.122,8.122,0,0,1,2.271,3.277",
    transform: "translate(-638.488 -688.784)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(0 38.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M618.108,745.35,616.124,759.9,592.1,764.568a12.723,12.723,0,0,1-7.951-1.011l-27.453-14.586-.247.286c-1.38.986-3.812-1.424-5.353-2.126l-2.119-3.467c-.395-.3-8.591-5.649-8.591-6.167a1.084,1.084,0,0,1,1.085-1.072c3.428.185,12.83,2.532,13.323,2.655.641.172,8.694,2.979,8.694,2.979l26.024,9.048Z",
    transform: "translate(-539.617 -735.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M589.394,765.344a13.442,13.442,0,0,1-5.812-1.329l-26.976-14.331c-1.4.939-3.2-.258-4.641-1.222a11.772,11.772,0,0,0-1.424-.867.764.764,0,0,1-.336-.3l-2.035-3.331c-.165-.112-.477-.32-.887-.595-7.9-5.283-7.9-5.542-7.9-6.107a1.846,1.846,0,0,1,1.851-1.839c3.445.185,12.489,2.423,13.509,2.677.663.178,7.933,2.71,8.76,3l25.826,8.98,28.395-5.716a.766.766,0,0,1,.91.854l-1.985,14.546a.765.765,0,0,1-.613.648l-24.026,4.673A13.5,13.5,0,0,1,589.394,765.344ZM556.46,747.972a.775.775,0,0,1,.359.089l27.453,14.586a11.856,11.856,0,0,0,7.443.936l23.49-4.568,1.765-12.935-27.543,5.544a.766.766,0,0,1-.4-.028L563,742.548c-3.228-1.124-8.192-2.841-8.642-2.962-.992-.247-9.9-2.454-13.165-2.63a.285.285,0,0,0-.21.118c.7.628,3.1,2.313,7.152,5.024.587.392.984.658,1.065.72a.782.782,0,0,1,.195.213l2,3.277a15.488,15.488,0,0,1,1.42.88c.979.654,2.31,1.54,2.892,1.25l.171-.2A.768.768,0,0,1,556.46,747.972Z",
    transform: "translate(-539.384 -735.425)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(8.562 45.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M550.557,743.9",
    transform: "translate(-550.557 -743.897)",
    fill: "#fff",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(74.241 41.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M657.96,741.914s-2.374-2.343-9.964-.378c-7.993,2.067-12.21,9.548-10.239,30.717,1.638,17.471,8.543,19.979,8.543,19.979s-3.782-26.347-3.13-37.366c.819-13.919,14.776-10.457,14.776-10.457C659.943,743.783,657.96,741.914,657.96,741.914Z",
    transform: "translate(-636.503 -739.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M646.064,792.763a.761.761,0,0,1-.262-.046c-.3-.109-7.38-2.878-9.045-20.628-1.831-19.668,1.4-29.1,10.81-31.531,7.72-2,10.374.264,10.687.567.238.225,1.335,1.339,1.074,2.478a1.817,1.817,0,0,1-1.387,1.3.767.767,0,0,1-.414.012c-.06-.014-6.049-1.441-10.084,1.535-2.261,1.667-3.521,4.434-3.744,8.223-.641,10.818,3.085,36.95,3.123,37.213a.767.767,0,0,1-.759.875Zm7.111-51.477a21.022,21.022,0,0,0-5.224.756c-6.012,1.555-11.864,6.324-9.668,29.9,1.131,12.061,4.82,16.782,6.788,18.477-.825-6.027-3.463-26.352-2.9-35.838.251-4.27,1.722-7.422,4.372-9.372,4.182-3.077,9.872-2.1,11.116-1.837a.454.454,0,0,0,.178-.118c.043-.159-.29-.7-.637-1.022l0,0C657.153,742.2,656.064,741.286,653.175,741.286Z",
    transform: "translate(-636.268 -739.742)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(51.8 39.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M655.3,812.438c-5.769,7.149-40.2,0-40.2,0s1.788-15.508,1.788-17.678.826-10.1,1.134-12.574c.16-1.258,1.343-9.936,2.477-18.22l-8.013.875-4.5-14.275,15.791-9.652,7-1.936c7.187,3.661,14.793-.924,14.805-.912,12.031,5.288,9.48,28.156,9.48,28.156l-1.565,32.94Z",
    transform: "translate(-607.216 -737.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M641.88,816.133c-11.69,0-26.246-2.981-27.174-3.173a.765.765,0,0,1-.605-.838c.018-.156,1.782-15.49,1.782-17.59,0-2.261.856-10.387,1.139-12.669.158-1.236,1.291-9.547,2.346-17.258l-7.038.769a.766.766,0,0,1-.814-.532l-4.5-14.275a.766.766,0,0,1,.331-.884l15.792-9.652a.756.756,0,0,1,.2-.085l7-1.936a.774.774,0,0,1,.552.056c6.169,3.143,12.772-.175,14.035-.872a.885.885,0,0,1,.728-.051l0-.008c12.4,5.452,10.04,27.986,9.933,28.943L654.031,798.9l1.791,13.208a.765.765,0,0,1-.163.584C653.569,815.279,648.135,816.133,641.88,816.133ZM615.7,811.6c9.791,1.967,33.649,5.459,38.553.366l-1.753-12.93a.766.766,0,0,1-.006-.14l1.566-32.939c.028-.269,2.307-21.983-8.689-27.265-1.947,1.011-8.553,3.936-14.909.874l-6.616,1.828-15.188,9.284,4.13,13.1,7.388-.808a.766.766,0,0,1,.842.866c-1.09,7.965-2.313,16.932-2.477,18.213-.335,2.69-1.128,10.392-1.128,12.477C617.416,796.479,616.056,808.516,615.7,811.6Z",
    transform: "translate(-606.983 -737.089)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(63.351 50.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M623.061,774.884c-.09-.013.855-4.953,1.438-11.224a87.262,87.262,0,0,1,1.772-11.711",
    transform: "translate(-622.29 -751.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M622.828,775.415a.766.766,0,0,1-.109-.008.775.775,0,0,1-.51-.3c-.214-.288-.214-.288.058-2.057.295-1.925.845-5.508,1.234-9.692.315-3.389.76-6.366,1.078-8.266.676-4.039.733-4.193,1.511-4.14a.767.767,0,0,1,.71.819.783.783,0,0,1-.075.281,96.446,96.446,0,0,0-1.7,11.447c-.392,4.23-.947,7.842-1.244,9.782-.089.575-.172,1.121-.192,1.308a.841.841,0,0,1-.005.169A.767.767,0,0,1,622.828,775.415Z",
    transform: "translate(-622.056 -750.942)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(79.009 82.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M662.074,806.267s-2.24,7.2-10.156-4.69S645.109,795,645.109,795l-1.619,1.919s8.71,19.615,18.481,16.543Z",
    transform: "translate(-642.724 -793.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M659.617,814.324c-9.253,0-16.723-16.564-17.061-17.327a.766.766,0,0,1,.115-.8l1.4-1.657a1.5,1.5,0,0,1,.709-1.637c.911-.382,2.172-.054,7.546,8.015,3.978,5.975,6.2,6.632,7.172,6.493,1.136-.163,1.61-1.59,1.615-1.6a.766.766,0,0,1,1.5.238l-.1,7.2a.765.765,0,0,1-.536.72A7.786,7.786,0,0,1,659.617,814.324Zm-15.46-17.517c1.306,2.751,8.784,17.628,16.822,15.832l.06-4.246a3.03,3.03,0,0,1-1.328.53c-2.395.339-5.229-2-8.666-7.16-3.172-4.765-4.711-6.474-5.41-7.087a.773.773,0,0,1-.175.584Z",
    transform: "translate(-642.49 -792.797)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(59.674 54.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M624.03,756.172l-6.771,12.615,5.158-.563Z",
    transform: "translate(-617.259 -756.172)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(63.053 72.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M621.668,794.583A58.706,58.706,0,0,0,637.7,806.889c2.515,1.319,5.3,2.477,8.114,2.112a9.937,9.937,0,0,0,7.212-5.395c1.453-2.758,1.281-4.089,1.606-7.186.384-3.418.384-7.98.563-11.1,0-.551.038-1.191.038-1.8a3.06,3.06,0,0,1,2.182-2.931h0a7.336,7.336,0,0,0-3.155-.71,4.466,4.466,0,0,0-2.88,2.323c-3.513,5.791-1.984,14.284-8.684,17.918a11.321,11.321,0,0,1-7.186,1.056c-5.484-.9-9.683-4.48-13.727-8.012",
    transform: "translate(-621.668 -779.86)",
    fill: "#231f20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(57.731 246.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M643.941,1008.611v-2.342l-28.068,1.152s-1.28.575-1.139,1.491Z",
    transform: "translate(-614.723 -1006.269)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(86.483 172.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M653.251,910.856a3.491,3.491,0,0,1,.1.562c.051.4.128.941.224,1.626.173,1.421.391,3.474.589,6.015.409,5.087.716,12.159.831,19.915s0,14.841-.306,19.934c-.128,2.56-.3,4.608-.429,6.028-.077.685-.141,1.228-.185,1.632a3.87,3.87,0,0,1-.084.569,3.292,3.292,0,0,1,0-.576c.032-.4.071-.947.122-1.638.1-1.421.224-3.481.326-6.028.211-5.087.3-12.159.2-19.915s-.384-14.821-.736-19.9c-.166-2.56-.346-4.6-.48-6.022-.07-.684-.128-1.228-.166-1.631A3.446,3.446,0,0,1,653.251,910.856Z",
    transform: "translate(-652.478 -910.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M653.76,967.672l-.051,0a.767.767,0,0,1-.713-.7,4.064,4.064,0,0,1,0-.71l.121-1.628c.139-2.059.245-4.025.325-6,.22-5.312.294-12.556.2-19.875-.089-7.166-.356-14.4-.734-19.859-.133-2.041-.289-4-.478-6l-.056-.54c-.045-.437-.083-.8-.11-1.091a4.2,4.2,0,0,1-.015-.688.767.767,0,0,1,1.506-.153,4.317,4.317,0,0,1,.124.686c.043.327.108.793.189,1.369l.032.226c.154,1.268.381,3.336.594,6.062.425,5.28.721,12.371.834,19.963.115,7.7.005,14.8-.308,19.992-.106,2.106-.251,4.146-.431,6.054l-.187,1.644a4.515,4.515,0,0,1-.1.653A.767.767,0,0,1,653.76,967.672Z",
    transform: "translate(-652.244 -909.856)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(25.611 69.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M602.976,776.945l-29.169-.569.339,1.414,28.689.422Z",
    transform: "translate(-573.04 -775.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M602.6,778.744h-.011l-28.689-.422a.767.767,0,0,1-.734-.588l-.339-1.414a.767.767,0,0,1,.76-.946l29.169.569a.767.767,0,0,1,.746.851l-.141,1.267A.766.766,0,0,1,602.6,778.744Z",
    transform: "translate(-572.807 -775.375)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(79.38 44.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M654.744,744.629a5.111,5.111,0,0,0-3.276.288c-2.362.992-6.687,3.839-6.995,11.928l-.5,13.036,18.654,2.444S664.216,747.151,654.744,744.629Z",
    transform: "translate(-643.208 -743.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M662.395,772.859a.88.88,0,0,1-.1-.006l-18.655-2.445a.766.766,0,0,1-.666-.788l.5-13.036c.319-8.374,4.813-11.492,7.464-12.605a5.9,5.9,0,0,1,3.755-.326l.016,0c9.964,2.653,8.518,27.432,8.451,28.486a.766.766,0,0,1-.765.718Zm-17.861-3.88,17.135,2.245c.164-4.29.484-23.988-7.347-26.086a4.372,4.372,0,0,0-2.778.247c-2.326.977-6.252,3.732-6.538,11.257Z",
    transform: "translate(-642.974 -743.485)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(80.178 70.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M644.016,777.427",
    transform: "translate(-644.016 -777.427)",
    fill: "#fff",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447",
    transform: "translate(79.233 44.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M662.251,772.247h0l-.979-.109-3.769-.46-13.6-1.7h-.122v-.128c.077-3.149.135-6.6.256-10.278a38.9,38.9,0,0,1,.57-5.67,14.664,14.664,0,0,1,2.182-5.555,9.979,9.979,0,0,1,3-2.95,7.132,7.132,0,0,1,3.923-1.113,8.918,8.918,0,0,1,6.687,3.469,8.779,8.779,0,0,1,1.587,3.2c.07.282.115.57.173.857a7.749,7.749,0,0,1,.083.858c0,.557,0,1.114.038,1.657.045,2.176.083,4.2.122,6.054.064,3.673.115,6.649.153,8.729,0,1,0,1.8.032,2.355v.64a.88.88,0,0,1,0,.179Z",
    transform: "translate(-643.016 -743.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M662.351,772.811a.614.614,0,0,1-.074,0l-.333-.032h-.012l-.979-.109-3.778-.461-13.628-1.7a.766.766,0,0,1-.766-.766v-.128l.068-2.964c.051-2.318.1-4.772.189-7.339a39.837,39.837,0,0,1,.581-5.776,15.329,15.329,0,0,1,2.3-5.842,10.668,10.668,0,0,1,3.226-3.178,7.936,7.936,0,0,1,4.344-1.233,9.677,9.677,0,0,1,7.284,3.767,9.481,9.481,0,0,1,1.722,3.474c.054.215.093.425.132.636l.051.266a5.137,5.137,0,0,1,.078.7l.017.243c0,.626,0,1.154.04,1.671l.277,14.822c0,1.007,0,1.79.031,2.326l0,.651a1.649,1.649,0,0,1,0,.289A.766.766,0,0,1,662.351,772.811Zm-18.023-3.76,17.255,2.142c-.031-.535-.031-1.326-.031-2.323l-.275-14.767c-.038-.532-.038-1.113-.038-1.674l-.017-.215a3.711,3.711,0,0,0-.051-.491l-.054-.287c-.034-.18-.066-.359-.11-.536a7.963,7.963,0,0,0-1.447-2.912,8.14,8.14,0,0,0-6.117-3.176,6.336,6.336,0,0,0-3.479.995,9.157,9.157,0,0,0-2.765,2.724,13.817,13.817,0,0,0-2.068,5.264,38.375,38.375,0,0,0-.559,5.561c-.085,2.565-.139,5.014-.189,7.327Z",
    transform: "translate(-642.782 -743.281)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    transform: "translate(30.453 67.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M643.686,778.949l-.789,15.483a10.091,10.091,0,0,1-7.779,9.455,10.265,10.265,0,0,1-2.293.259,10.047,10.047,0,0,1-4.992-1.319l-25.1-14.263-9.2-1.035c-2.847.123-12.648-8.74-13.412-10.281l11.045.345-1.713-1.369a15.21,15.21,0,0,1,6.891-1.578c1.3.087,2.9-.049,3.933.727l5.363,3.957,23.521,7.076.358-9.517Z",
    transform: "translate(-579.359 -773.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M632.591,804.68a10.828,10.828,0,0,1-5.373-1.42l-24.96-14.185-8.989-1.011h-.013c-3.439,0-13.257-9.107-14.051-10.708a.765.765,0,0,1,.041-.754.742.742,0,0,1,.669-.352l8.755.274a.768.768,0,0,1-.121-.9c.451-.834,5.245-2.2,7.635-1.977.231.015.491.023.758.031a6.12,6.12,0,0,1,3.564.846l5.251,3.875,22.445,6.752.32-8.526a.767.767,0,0,1,.876-.729l14.165,2.058a.766.766,0,0,1,.655.8l-.789,15.483a10.885,10.885,0,0,1-8.369,10.163A11.02,11.02,0,0,1,632.591,804.68ZM593.3,786.531a.82.82,0,0,1,.086,0l9.2,1.035a.764.764,0,0,1,.293.1l25.1,14.263a9.463,9.463,0,0,0,6.735.98,9.351,9.351,0,0,0,7.185-8.738l.754-14.8-12.63-1.835L629.7,786.2a.766.766,0,0,1-.986.705l-23.521-7.076a.763.763,0,0,1-.234-.117l-5.362-3.957a5,5,0,0,0-2.7-.544c-.285-.008-.565-.018-.831-.035a14.831,14.831,0,0,0-5.4.98l.755.6a.766.766,0,0,1-.5,1.365l-9.4-.294c2.639,2.8,9.807,8.768,11.762,8.7Z",
    transform: "translate(-579.125 -773.627)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(75.456 28.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M651.515,731.693c-9.162,0-13.521-7.72-13.566-7.8a.766.766,0,0,1,1.342-.74,14.4,14.4,0,0,0,13.375,6.966.766.766,0,1,1,.115,1.528Q652.135,731.692,651.515,731.693Z",
    transform: "translate(-637.854 -722.756)",
    fill: "#231f20"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-15",
    transform: "translate(322.536 73.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    transform: "translate(95.085 214.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M965.439,1014.246l7.107.231,1.063-17.841-7.1-.232Z",
    transform: "translate(-964.673 -995.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M972.313,1015.009h-.025l-7.107-.231a.766.766,0,0,1-.74-.812l1.074-17.841a.769.769,0,0,1,.79-.72l7.1.232a.768.768,0,0,1,.74.812l-1.064,17.841A.766.766,0,0,1,972.313,1015.009Zm-6.3-1.737,5.574.181.972-16.31L967,996.96Z",
    transform: "translate(-964.439 -995.404)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(45.777 206.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M901.094,1002.063l7.032,2.2,4.869-16.537-7.032-2.2Z",
    transform: "translate(-900.327 -984.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M907.892,1004.794a.776.776,0,0,1-.228-.034l-7.032-2.2a.766.766,0,0,1-.507-.947l4.87-16.537a.766.766,0,0,1,.964-.515l7.031,2.2a.767.767,0,0,1,.507.948l-4.87,16.536a.766.766,0,0,1-.735.549Zm-6.084-3.47,5.569,1.741L911.813,988l-5.569-1.741Z",
    transform: "translate(-900.093 -984.526)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452",
    transform: "translate(39.925 219.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M906.543,1007.659l-6.8-4.792a.591.591,0,0,0-.776.092l-5.207,5.367a1.172,1.172,0,0,0,.077,1.657l.015.014.116.082c2.4,1.632,3.636,2.293,6.6,4.41,1.851,1.324,6.4,5.17,8.939,6.954s5.184-1.169,4.2-2.127c-4.044-4.374-5.763-8.1-6.418-10.565A1.937,1.937,0,0,0,906.543,1007.659Z",
    transform: "translate(-892.69 -1001.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M910.962,1022.537a3.668,3.668,0,0,1-2.124-.7c-1.44-1.01-3.519-2.676-5.353-4.148-1.435-1.151-2.791-2.238-3.592-2.81-1.781-1.271-2.906-2-4.1-2.763-.767-.493-1.537-.989-2.489-1.638l-.127-.089c-.027-.02-.068-.054-.093-.077a1.941,1.941,0,0,1-.123-2.737l5.223-5.384a1.353,1.353,0,0,1,1.761-.19l6.8,4.8.005,0a2.707,2.707,0,0,1,1.043,1.526c.592,2.228,2.156,5.818,6.239,10.234.63.61.552,1.669-.222,2.605A3.758,3.758,0,0,1,910.962,1022.537ZM899.2,1003.349l-5.118,5.277a.405.405,0,0,0,.043.559l.057.035c.928.631,1.688,1.12,2.445,1.608,1.155.743,2.349,1.512,4.16,2.8.835.6,2.207,1.7,3.659,2.862,1.816,1.456,3.875,3.107,5.274,4.089a2.038,2.038,0,0,0,2.422.049,1.529,1.529,0,0,0,.779-1.037c-4.3-4.64-5.966-8.478-6.6-10.88a1.173,1.173,0,0,0-.451-.665Zm.109-.112-.01.01Z",
    transform: "translate(-892.456 -1001.761)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(90.561 228.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M971.956,1015.071l-8.663-1.228a.751.751,0,0,0-.8.447l-2.854,6.62a1.057,1.057,0,0,0,.492,1.411c.024.012.049.023.074.033a1.249,1.249,0,0,0,.31.091c3.065.444,4.512.613,8.333,1.139,2.369.325,9.153,2.4,12.411,1.953s3.409-3.738,2.044-3.852c-6.084-.49-8.6-4.024-10.187-6A1.743,1.743,0,0,0,971.956,1015.071Z",
    transform: "translate(-958.768 -1013.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M979.977,1026.134a42.811,42.811,0,0,1-8.422-1.385c-1.271-.293-2.368-.546-3.045-.638-1.526-.21-2.674-.363-3.7-.5-1.54-.205-2.8-.373-4.643-.641a2.047,2.047,0,0,1-.508-.148c-.018-.007-.061-.025-.1-.047a1.823,1.823,0,0,1-.843-2.432l2.841-6.59a1.517,1.517,0,0,1,1.613-.9l8.646,1.225a2.5,2.5,0,0,1,1.654.889l.253.317c1.576,1.978,3.956,4.967,9.407,5.406a1.736,1.736,0,0,1,1.516,1.847,3.7,3.7,0,0,1-3.516,3.528A8.482,8.482,0,0,1,979.977,1026.134Zm-17.025-11.766-2.841,6.612a.3.3,0,0,0,.121.419.7.7,0,0,0,.169.056c1.827.265,3.081.432,4.615.637,1.025.136,2.173.29,3.7.5.745.1,1.874.362,3.18.664,2.9.67,6.883,1.586,9.021,1.29a2.276,2.276,0,0,0,2.159-1.638.815.815,0,0,0-.07-.691c-6.116-.493-8.851-3.927-10.485-5.979l-.241-.3a.961.961,0,0,0-.641-.336l-.028,0Z",
    transform: "translate(-958.535 -1012.836)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(96.207 216.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M973.6,998.582l-.547,9.188-7.148.5.589-9.917Z",
    transform: "translate(-965.903 -998.352)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455",
    transform: "translate(48.462 208.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M906.118,987.633l7.033,2.209-2.513,8.506-7.041-2.187Z",
    transform: "translate(-903.597 -987.633)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(65.509 81.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M939.858,822.48A11.365,11.365,0,0,1,950,828.961c5.8,12.277,17.625,40.009,18.787,64.293,1.038,21.636-1.549,66.6-1.549,66.6l-12.426,2.936s-1.8-45.957-3.842-63.685c-3.486-30.32-24.123-76.763-24.123-76.763Z",
    transform: "translate(-926.077 -821.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M954.574,963.325a.766.766,0,0,1-.766-.736c-.018-.459-1.822-46.13-3.838-63.626-3.433-29.858-23.856-76.077-24.062-76.54a.768.768,0,0,1,.061-.733.793.793,0,0,1,.648-.345l13.014.135h0a12.207,12.207,0,0,1,10.822,6.919c5.277,11.163,17.675,39.8,18.861,64.585,1.028,21.429-1.524,66.233-1.549,66.684a.767.767,0,0,1-.589.7L954.75,963.3A.76.76,0,0,1,954.574,963.325ZM927.786,822.89c3.117,7.2,20.544,48.383,23.708,75.9,1.862,16.159,3.54,56.2,3.809,62.813l10.965-2.591c.294-5.294,2.478-45.916,1.517-65.951-1.172-24.508-13.478-52.923-18.714-64a10.664,10.664,0,0,0-9.454-6.043Z",
    transform: "translate(-925.843 -821.345)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(92.034 215.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M977.675,1002.665l-15.852,1.607-.365-6.025,16.667-1.108Z",
    transform: "translate(-960.692 -996.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M961.59,1004.8a.767.767,0,0,1-.765-.72l-.366-6.025a.766.766,0,0,1,.714-.811l16.667-1.108a.736.736,0,0,1,.6.227.765.765,0,0,1,.218.6l-.451,5.525a.766.766,0,0,1-.686.7l-15.852,1.608C961.641,1004.8,961.615,1004.8,961.59,1004.8Zm.446-6.077.27,4.467,14.423-1.462.327-4Zm15.406,3.7h0Z",
    transform: "translate(-960.458 -996.138)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    transform: "translate(75.845 96.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M941.46,841.731l-2.129,8.961a346.547,346.547,0,0,1,10.712,33.432C952.3,867.141,944.854,849.237,941.46,841.731Z",
    transform: "translate(-939.331 -841.731)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459",
    transform: "translate(48.359 81.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M937.056,822.561s3.443,43.483-2.383,71.854c-4.728,22.918-21.473,61.178-21.473,61.178l-8.737-5.264s7.366-38.434,11.278-53.888c8.033-31.657-5.716-52.933-4.75-66.845a7.971,7.971,0,0,1,8.133-7.354Z",
    transform: "translate(-903.696 -821.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M912.966,956.126a.767.767,0,0,1-.4-.109l-8.738-5.264a.766.766,0,0,1-.357-.8c.074-.384,7.416-38.632,11.288-53.931,5.21-20.532,1.22-36.476-1.986-49.288-1.678-6.7-3.127-12.494-2.785-17.422a8.735,8.735,0,0,1,8.915-8.067l17.929.316a.767.767,0,0,1,.75.706c.035.436,3.385,43.917-2.4,72.07-4.69,22.734-21.354,60.948-21.522,61.331a.767.767,0,0,1-.47.424A.779.779,0,0,1,912.966,956.126Zm-7.884-6.411,7.53,4.536c2.423-5.628,16.8-39.471,21.078-60.225,5.338-25.993,2.824-65.258,2.42-70.946l-17.233-.3a7.207,7.207,0,0,0-7.355,6.647c-.325,4.68,1.1,10.36,2.743,16.938,3.247,12.978,7.29,29.13,1.985,50.036C912.636,910.674,905.982,945.049,905.082,949.715Z",
    transform: "translate(-903.462 -821.241)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460",
    transform: "translate(46.645 206.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M914.373,995.4l-12.148-4.039.933-5.051,13.5,4.932Z",
    transform: "translate(-901.459 -985.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M914.139,995.93a.755.755,0,0,1-.241-.04l-12.148-4.039a.765.765,0,0,1-.512-.866l.932-5.051a.767.767,0,0,1,1.017-.581l13.5,4.933a.767.767,0,0,1,.409,1.089l-2.284,4.157A.767.767,0,0,1,914.139,995.93Zm-11.273-5.323,10.909,3.628,1.547-2.815L903.513,987.1Z",
    transform: "translate(-901.225 -985.307)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(49.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M910.145,725.305c-4.513,4.986-6.434,12.6-3.587,18.681a14.156,14.156,0,0,0,4.489,5.474,17.07,17.07,0,0,0,7.268,2.941c7.527,1.274,15.228-1.6,22.815-.753,8.816.988,16.388,6.851,25.171,8.4a26.93,26.93,0,0,0,23.965-8.021,7.019,7.019,0,0,0,1.826-2.887,2.894,2.894,0,0,0-.946-3.091,1.856,1.856,0,0,0-2.581.478,1.875,1.875,0,0,0-.208.4,35.342,35.342,0,0,0,15.531-9.721,12.053,12.053,0,0,0,3.136-5.067,5.357,5.357,0,0,0-1.51-5.494c-1.572-1.248-4.3-.913-5.166.9a15.459,15.459,0,0,0,4.161-5.422c.856-2.159.415-4.933-1.5-6.2-2.418-1.626-5.7-.024-8.191,1.563l-18.543,11.8a9.882,9.882,0,0,0,2.5-2.733,3.392,3.392,0,0,0-.031-3.545,3.459,3.459,0,0,0-3.389-1.088,11.533,11.533,0,0,0-3.412,1.518,58.15,58.15,0,0,1-13.473,5.417c-2.579.674-5.623,1.08-7.672-.624s-2.086-4.913-3.495-7.227c-6.13-10.107-16.232-3.756-19.088-4.206C920.422,715.551,913.758,721.26,910.145,725.305Z",
    transform: "translate(-905.219 -715.246)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(142.197 44.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M1027.888,776.936c.3.433-1.458,4.932-.831,4.74s7.417,1.674,7.417,1.674l7.413-6.417-.684-2.261-7.3,2.89Z",
    transform: "translate(-1026.154 -773.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M1034.24,783.882a.76.76,0,0,1-.2-.028,62.847,62.847,0,0,0-7.061-1.661h0a.841.841,0,0,1-.775-.219c-.472-.461-.314-1.124.255-3.149a16.316,16.316,0,0,0,.467-1.9.767.767,0,0,1,.813-.984l5.828.607,7.125-2.821a.766.766,0,0,1,1.016.49l.683,2.261a.766.766,0,0,1-.232.8l-7.413,6.417A.765.765,0,0,1,1034.24,783.882Zm-6.7-3.158a61.178,61.178,0,0,1,6.512,1.544l6.728-5.824-.3-.988-6.526,2.584a.777.777,0,0,1-.362.05l-5.218-.544c-.086.416-.235.959-.441,1.694C1027.8,779.689,1027.634,780.288,1027.535,780.724Zm-.586,1.471Zm.1-.02h0Zm-.027-5.041h0Z",
    transform: "translate(-1025.92 -773.671)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(81.866 35.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M1013.338,777.126c-1,2.586-2.4,2.989-2.4,2.989a9.734,9.734,0,0,1-4.972-1.14,4.015,4.015,0,0,1-2.533,2.265c-6.566,1.287-22.822,2.559-26.306,1.675-10.145-2.546-27.056-7.156-28.316-9.716-1.877-3.833.7-11.337,5.079-9.984,5.682,1.836,20.248,6.727,27.123,9.381,3.149,1.22,16.015.469,21.616.818a16.086,16.086,0,0,1,4.154,1.3l4.569-2.681S1014.344,774.54,1013.338,777.126Z",
    transform: "translate(-947.423 -762.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M981.152,783.743a21.312,21.312,0,0,1-4.447-.318c-18.043-4.529-27.739-7.934-28.815-10.12a9.686,9.686,0,0,1,1.387-9.553,4.208,4.208,0,0,1,4.606-1.5c5.868,1.9,20.319,6.753,27.172,9.4,1.894.733,7.985.7,13.358.673,3.092-.015,6.01-.031,8.029.094.027,0,.054.005.08.009a16.8,16.8,0,0,1,3.982,1.194l4.227-2.48a.769.769,0,0,1,.88.074c.139.116,3.4,2.894,2.205,5.957-1.111,2.857-2.721,3.4-2.9,3.448a.77.77,0,0,1-.182.029,10.438,10.438,0,0,1-4.674-.893,4.793,4.793,0,0,1-2.636,1.985.639.639,0,0,1-.077.019A149.955,149.955,0,0,1,981.152,783.743Zm-28.525-20.156a2.87,2.87,0,0,0-2.185,1.16,8.25,8.25,0,0,0-1.176,7.882c.632,1.283,8.271,4.4,27.815,9.31,3.262.828,19.083-.342,25.931-1.676a3.256,3.256,0,0,0,2.016-1.821.766.766,0,0,1,1.067-.375,9,9,0,0,0,4.452,1.053,4.449,4.449,0,0,0,1.842-2.505h0c.6-1.539-.7-3.154-1.38-3.86l-4.071,2.388a.768.768,0,0,1-.713.032,15.282,15.282,0,0,0-3.917-1.231c-1.968-.12-4.843-.1-7.887-.089-5.777.031-11.754.062-13.917-.776-6.825-2.635-21.237-7.477-27.083-9.366A2.687,2.687,0,0,0,952.627,763.587Z",
    transform: "translate(-947.188 -762.055)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(51.863 34.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M946.759,813.859l-.346.506a14.8,14.8,0,0,1,.974,1.923,1.206,1.206,0,0,1-.308,1.22c-.32-.222-34.271,1.442-35,1.11l-.284-.468a2.355,2.355,0,0,1-.345-1.146,11.449,11.449,0,0,1,.246-2.367,7,7,0,0,1-2.034-8.383c1.861-4.142,3.316-10.084,3.316-18.639a115.894,115.894,0,0,0-3.057-24.642,88.541,88.541,0,0,1,12.746-1.516,94.95,94.95,0,0,1,13.635.172,54.625,54.625,0,0,1,8.481,1.221c.259.628,4.068,9.652,5.448,15.964a5.061,5.061,0,0,1,.111,1.43c-.172,3.082-.949,15.311-3.415,25l.727,2.515A7.407,7.407,0,0,1,946.759,813.859Z",
    transform: "translate(-908.27 -760.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M913.011,819.192a4.444,4.444,0,0,1-1.484-.111.764.764,0,0,1-.336-.3l-.284-.468a3.123,3.123,0,0,1-.455-1.52,12.427,12.427,0,0,1,.175-2.091,7.741,7.741,0,0,1-1.894-9c2.155-4.8,3.248-10.962,3.248-18.324a116.224,116.224,0,0,0-3.04-24.478.766.766,0,0,1,.6-.917,89.614,89.614,0,0,1,12.857-1.529,95.871,95.871,0,0,1,13.734.175,55.683,55.683,0,0,1,8.585,1.236.77.77,0,0,1,.541.456l.051.125a110.807,110.807,0,0,1,5.437,15.967,5.777,5.777,0,0,1,.128,1.633c-.25,4.46-1.079,15.762-3.386,24.948l.669,2.315a8.174,8.174,0,0,1-.992,6.731l-.011.016-.074.108a14.721,14.721,0,0,1,.78,1.6,1.993,1.993,0,0,1-.487,2.06.767.767,0,0,1-.69.2c-.794-.05-7.7.23-14.376.5C919.978,819.024,915.055,819.192,913.011,819.192Zm-1.165-.808h0Zm.457-.725c1.991.057,12.294-.356,19.945-.666,9.612-.389,12.941-.516,14.185-.494a.434.434,0,0,0-.011-.214,14.524,14.524,0,0,0-.9-1.762.766.766,0,0,1,.025-.822l.339-.5a6.646,6.646,0,0,0,.8-5.464l-.728-2.516a.768.768,0,0,1-.006-.4c2.313-9.092,3.143-20.41,3.392-24.854a4.271,4.271,0,0,0-.092-1.21A108.114,108.114,0,0,0,944,763.277a54.189,54.189,0,0,0-7.976-1.118,94.629,94.629,0,0,0-13.539-.172,88.068,88.068,0,0,0-11.877,1.359,116.412,116.412,0,0,1,2.908,24.035c0,7.581-1.139,13.957-3.384,18.953a6.21,6.21,0,0,0,1.808,7.466.767.767,0,0,1,.277.764,10.708,10.708,0,0,0-.23,2.205,1.576,1.576,0,0,0,.235.749Zm34.221-4.034h0Z",
    transform: "translate(-908.035 -760.289)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    transform: "translate(65.419 19.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M928.262,741.432c.812,4.417,1.578,12.47-1.537,15.374l9.595,7.909,4.071-7.755c-4.862-1.232-3.354-6.1-3.816-10.969Z",
    transform: "translate(-925.959 -740.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M936.086,765.247a.767.767,0,0,1-.487-.176L926,757.163a.767.767,0,0,1-.035-1.152c2.521-2.349,2.327-9.121,1.306-14.674a.766.766,0,0,1,1.122-.811l8.313,4.559a.766.766,0,0,1,.395.6c.113,1.188.112,2.353.111,3.48,0,3.848.141,6.062,3.13,6.819a.766.766,0,0,1,.49,1.1l-4.071,7.756a.764.764,0,0,1-.526.395A.788.788,0,0,1,936.086,765.247ZM927.6,756.49l8.249,6.8,3.21-6.116c-3.379-1.355-3.376-4.735-3.373-8.012,0-.959,0-1.948-.071-2.932l-6.568-3.6C929.639,746.589,930.141,753.208,927.6,756.49Z",
    transform: "translate(-925.726 -740.432)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(67.692 21.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M928.845,742.791c.655,3.542,1.28,9.429-.153,13.133,2.6-.415,7.674-1.333,8.325-3.56.224-1.527-.849-4.021-.871-5.565Z",
    transform: "translate(-928.692 -742.791)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467",
    transform: "translate(62.142 2.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M944.125,731.233c-1.269,7.241-1.711,10.328-5.832,13.628-6.209,5-14.812,1.761-15.687-5.694-.8-6.74,1.484-17.434,8.968-19.494a10.042,10.042,0,0,1,12.552,11.559Z",
    transform: "translate(-921.684 -718.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M931.5,747.8a10.241,10.241,0,0,1-3.884-.765,9.734,9.734,0,0,1-6-8.016c-.846-7.116,1.55-18.126,9.525-20.322a10.81,10.81,0,0,1,13.51,12.437l-.1.565c-1.215,6.956-1.77,10.13-6.008,13.523A11.238,11.238,0,0,1,931.5,747.8Zm2.523-27.965a9.239,9.239,0,0,0-2.478.339c-7.023,1.933-9.171,12.281-8.412,18.664a8.22,8.22,0,0,0,5.063,6.777,9.258,9.258,0,0,0,9.383-1.589c3.787-3.032,4.276-5.831,5.458-12.591l.1-.572,0-.011a9.277,9.277,0,0,0-9.115-11.018Z",
    transform: "translate(-921.449 -718.306)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(65.42 0.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M945.895,734.808c-12.108,1.578-8.836-10.66-20.169-13.668,6.012-4.5,13.5-5.756,16.918-3.831S945.895,734.808,945.895,734.808Z",
    transform: "translate(-925.726 -716.437)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(0 7.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M854.856,738.181l-4.369,3.156-6.339-6.08.135-.057a6.84,6.84,0,0,1-.566-.5l-2.362-4.869,3.05-4.195,4.51,3.317,2.135,3.8.2-.064Z",
    transform: "translate(-840.588 -724.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M850.253,741.869a.762.762,0,0,1-.53-.214l-6.339-6.08a.767.767,0,0,1-.208-.344c-.077-.071-.154-.143-.231-.219a.761.761,0,0,1-.152-.211l-2.363-4.87a.766.766,0,0,1,.07-.785l3.05-4.195a.764.764,0,0,1,.5-.307.775.775,0,0,1,.572.14l4.51,3.317a.771.771,0,0,1,.214.242l1.9,3.385a.766.766,0,0,1,.4.307l3.613,5.491a.767.767,0,0,1-.192,1.043l-4.37,3.155A.762.762,0,0,1,850.253,741.869ZM844.8,734.81l5.523,5.3,3.257-2.352-2.957-4.494a.766.766,0,0,1-.476-.367l-2.054-3.658-3.756-2.762-2.327,3.2,2.1,4.333c.132.126.265.241.41.355A.767.767,0,0,1,844.8,734.81Z",
    transform: "translate(-840.354 -724.636)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(55.162 45.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M912.34,777.45c.872.1,1.556,10.9,1.576,13.264s6.012-11.756,5.237-14.334C917.945,772.239,912.34,777.45,912.34,777.45Z",
    transform: "translate(-912.34 -774.781)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(8.914 19.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M853.059,745.851s5.772,18.562,45.383,23.563c12.972,1.652,9.087-10.97.211-11.31-6.581-.283-20.995-2.157-28.983-7.2s-6.489-9.278-12.07-8.849S853.059,745.851,853.059,745.851Z",
    transform: "translate(-852.219 -741.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M900.434,770.1a18.455,18.455,0,0,1-2.321-.157c-39.644-5.005-45.777-23.319-46.019-24.1v0a3.349,3.349,0,0,1,.457-2.7c.818-1.2,2.418-1.9,4.758-2.083,3.468-.264,4.613,1.172,6.193,3.163a22.851,22.851,0,0,0,6.345,5.8c7.87,4.97,22.153,6.808,28.606,7.084a9.532,9.532,0,0,1,8.186,5.1,5.255,5.255,0,0,1-.146,5.493C905.668,768.855,903.96,770.1,900.434,770.1Zm-46.876-24.707c.1.31,6.333,18.179,44.748,23.03,3.422.437,5.887-.136,6.941-1.611a3.784,3.784,0,0,0,.016-3.927,7.971,7.971,0,0,0-6.873-4.246c-6.6-.283-21.219-2.177-29.362-7.319a24.514,24.514,0,0,1-6.727-6.146c-1.521-1.917-2.216-2.792-4.875-2.588-1.826.14-3.074.631-3.609,1.417A1.815,1.815,0,0,0,853.558,745.391Z",
    transform: "translate(-851.986 -741.025)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(90.706 41.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M958.724,769.365l3.13,9.827,6.869,2.075S960.857,776.986,958.724,769.365Z",
    transform: "translate(-958.724 -769.365)",
    fill: "#231f20"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-15",
    transform: "translate(704.963 73.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(72.32 24.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M1464.432,753.576a2.807,2.807,0,0,1-1.25,3.7q-5.018,2.575-10.052,5.026c-4.179,2.011-8.386,3.978-12.6,5.823a4.308,4.308,0,0,1-3.59-7.79v.036q6.268-2.959,12.615-5.744l12.723-5.586Z",
    transform: "translate(-1434.028 -748.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M1438.875,768.888a5.068,5.068,0,0,1-2.555-9.452.777.777,0,0,1,.272-.1c4.109-1.936,8.287-3.837,12.421-5.651l12.724-5.586a.766.766,0,0,1,1,.373l2.154,4.538h0a3.56,3.56,0,0,1-1.59,4.707c-3.326,1.707-6.714,3.4-10.068,5.034-4.833,2.326-8.845,4.18-12.629,5.837A5.2,5.2,0,0,1,1438.875,768.888Zm-1.964-8.015a3.542,3.542,0,0,0,3.131,6.293c3.713-1.628,7.71-3.475,12.523-5.791,3.341-1.628,6.719-3.316,10.034-5.017a2.033,2.033,0,0,0,.907-2.688l-1.834-3.865-12.042,5.287c-4.193,1.841-8.431,3.77-12.6,5.736A.808.808,0,0,1,1436.911,760.872Z",
    transform: "translate(-1433.795 -748.037)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(0 36.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M1390,771.009a4.986,4.986,0,0,1-.825.616h-.038c-3.057,2.343-6.151,4.438-9.332,6.46a95.221,95.221,0,0,1-10.1,5.486c-.876.419-1.8.788-2.713,1.171a10.145,10.145,0,0,1-1.973.616,9.538,9.538,0,0,1-2.046.222,19.7,19.7,0,0,1-6.534-1.208,42.137,42.137,0,0,1-10.416-5.436,1.991,1.991,0,0,1-.419-.431.512.512,0,0,1-.062.012c-.3,0-4.66-5.079-5.067-5.547-.025-.012-.037-.025-.061-.038v-4.844l5.288,1.442.666,3.353a.578.578,0,0,1-.1.049h.136l2.1,2.379a73.884,73.884,0,0,0,9.628,2.577,15.547,15.547,0,0,0,4.4.221,4.7,4.7,0,0,0,.715-.172,1.1,1.1,0,0,0,.209-.1l.419-.209c.753-.382,1.529-.777,2.281-1.2,3.045-1.664,6.065-3.587,9.024-5.584s5.979-4.044,8.827-6.1h.074a4.308,4.308,0,1,1,5.917,6.263Z",
    transform: "translate(-1339.652 -762.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M1362.744,786.114a20.442,20.442,0,0,1-6.8-1.254,42.937,42.937,0,0,1-10.6-5.533,3.025,3.025,0,0,1-.4-.364c-.467-.264-1.473-1.318-5.114-5.53l-.084-.1a.682.682,0,0,1-.332-.634v-4.844a.766.766,0,0,1,.968-.739l5.289,1.443a.766.766,0,0,1,.549.59l.628,3.159,1.859,2.111a73.39,73.39,0,0,0,9.336,2.484,14.757,14.757,0,0,0,4.182.211,4.128,4.128,0,0,0,.556-.14c.017-.01.079-.044.1-.053l.419-.21c.756-.384,1.515-.769,2.25-1.179,2.675-1.462,5.523-3.225,8.969-5.55,3.415-2.282,6.295-4.273,8.806-6.088a.734.734,0,0,1,.171-.094,5.074,5.074,0,0,1,6.8,7.534l-.012.011a5.692,5.692,0,0,1-.954.71.777.777,0,0,1-.081.041c-2.748,2.1-5.7,4.136-9.264,6.4a96.085,96.085,0,0,1-10.182,5.533c-.714.343-1.47.656-2.2.959l-.539.225a10.867,10.867,0,0,1-2.119.661A10.172,10.172,0,0,1,1362.744,786.114Zm-17.166-8.581a.767.767,0,0,1,.426.3,1.238,1.238,0,0,0,.256.26,41.366,41.366,0,0,0,10.207,5.322,18.9,18.9,0,0,0,6.285,1.164,8.717,8.717,0,0,0,1.874-.2,9.331,9.331,0,0,0,1.838-.573l.546-.228c.713-.3,1.45-.6,2.134-.929a94.776,94.776,0,0,0,10.021-5.445c3.578-2.273,6.526-4.313,9.272-6.418a.777.777,0,0,1,.224-.119,4.385,4.385,0,0,0,.586-.452,3.542,3.542,0,0,0-4.872-5.142.768.768,0,0,1-.308.177c-2.489,1.8-5.335,3.762-8.692,6-3.484,2.351-6.37,4.138-9.082,5.62-.747.416-1.524.811-2.277,1.194l-.447.225a1.6,1.6,0,0,1-.309.139,5.445,5.445,0,0,1-.845.2,16.323,16.323,0,0,1-4.661-.228,74.842,74.842,0,0,1-9.729-2.6.76.76,0,0,1-.327-.218l-1.9-2.16a.765.765,0,0,1-.506-.581.756.756,0,0,1,.029-.4l-.5-2.535-3.863-1.054v3.522l.044.05C1344.266,776.215,1345.272,777.25,1345.578,777.533Zm44.188-6.756h0Z",
    transform: "translate(-1339.418 -762.578)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(52.794 21.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M1419.51,749.6c-.8,3.217-.833,7.18,2.671,8.307,0,0,4.387,3.677-4.057,3.677-7.676,0-8.81-4.193-8.81-4.193,2.872-2.765,2.405-8.48,1.594-12.616Z",
    transform: "translate(-1408.548 -744.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M1417.89,762.116c-8.169,0-9.5-4.565-9.55-4.759a.764.764,0,0,1,.208-.753c2.58-2.484,2.171-7.851,1.373-11.916a.766.766,0,0,1,1.126-.816l8.6,4.825a.767.767,0,0,1,.369.854c-.579,2.314-1.068,6.353,2.162,7.392a.772.772,0,0,1,.258.142c.191.16,1.849,1.605,1.306,3.1C1423.266,761.5,1421.405,762.116,1417.89,762.116Zm-7.913-4.791c.482.926,2.256,3.258,7.913,3.258,3.965,0,4.379-.826,4.414-.92.11-.3-.336-.932-.748-1.313-2.981-1.051-4.117-4.159-3.157-8.6L1411.71,746C1412.527,751.284,1411.946,755.085,1409.978,757.325Z",
    transform: "translate(-1408.314 -743.774)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(49.656 29.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M1405.219,759.188s1.436-2.632,3.281-3.414,9.845.381,11.079.776,2.355,2.514,2.355,2.514Z",
    transform: "translate(-1404.453 -754.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M1404.985,759.721a.766.766,0,0,1-.673-1.133c.064-.117,1.589-2.877,3.656-3.753,2.184-.926,10.466.385,11.612.753,1.489.477,2.669,2.641,2.8,2.885a.767.767,0,0,1-.672,1.125l-16.715.123Zm5.459-3.687a5.643,5.643,0,0,0-1.878.212,6.069,6.069,0,0,0-2.154,1.931l13.879-.1a3.062,3.062,0,0,0-1.179-1.028A46.93,46.93,0,0,0,1410.445,756.034Z",
    transform: "translate(-1404.219 -754.51)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(55.594 185.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M1413.536,958.6h5.643l-.567,13.082h-5.644Z",
    transform: "translate(-1412.202 -957.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M1418.378,972.214h-5.644a.767.767,0,0,1-.765-.8l.567-13.082a.767.767,0,0,1,.765-.733h5.644a.767.767,0,0,1,.765.8l-.567,13.082A.766.766,0,0,1,1418.378,972.214Zm-4.843-1.532h4.109l.5-11.55h-4.11Z",
    transform: "translate(-1411.968 -957.599)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(53.425 198.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M1419.279,975.262c3.819,2.355,5.026,2.463,9.42,3.432.969.208.323,2.556-1.988,2.556-3.835,0-4.237-.179-7.5-.179-2.8,0-6.017.122-8.243.166a.984.984,0,0,1-.2,0,.818.818,0,0,1-.6-.984l1.106-5.026a.494.494,0,0,1,.48-.388h6.176A2.674,2.674,0,0,1,1419.279,975.262Z",
    transform: "translate(-1409.372 -974.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M1426.477,981.782c-2.011,0-3.082-.048-4.117-.1-.944-.043-1.835-.083-3.386-.083-1.892,0-3.979.056-5.822.106-.873.023-1.691.045-2.407.059a1.248,1.248,0,0,1-.3,0,.685.685,0,0,1-.1-.017,1.589,1.589,0,0,1-1.168-1.9l1.1-5.015a1.256,1.256,0,0,1,1.225-.989h6.179a3.454,3.454,0,0,1,1.765.541,19.634,19.634,0,0,0,8.043,3.085l1.135.247a1.37,1.37,0,0,1,1.025,1.592A3.015,3.015,0,0,1,1426.477,981.782Zm-7.5-1.712c1.585,0,2.494.041,3.455.085,1.019.047,2.072.094,4.048.094a1.727,1.727,0,0,0,1.433-.618,1.054,1.054,0,0,0,.218-.461l-.956-.209a21.246,21.246,0,0,1-8.528-3.281l-.013-.008a1.912,1.912,0,0,0-.967-.3h-5.93l-1.068,4.866.051,0c.713-.013,1.526-.035,2.4-.058C1414.963,980.127,1417.061,980.07,1418.973,980.07Zm9.329-.861h0Z",
    transform: "translate(-1409.138 -973.838)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479",
    transform: "translate(30.535 27.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M1437.2,764.584s-5.486,4.314-10.676,5.93c.567,7.248.358,19-2.207,37.809h-30.165a178.868,178.868,0,0,0,.419-33.507l-8.284,2.343-1.442-1.257-4.574-4.943s10.048-10.7,15.348-11.921a3.979,3.979,0,0,1,.506-.086,5.294,5.294,0,0,1,1.985-.641c1.454-.16,2.959-.3,4.389-.382,4.277-.258,12.438-.444,16.7-.185.308.024.431.062.456.111,7.52-2.367,24.286-5.474,24.286-5.474Z",
    transform: "translate(-1379.5 -751.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M1424.079,808.854h-30.166a.767.767,0,0,1-.76-.864,179.448,179.448,0,0,0,.49-32.419l-7.386,2.09a.766.766,0,0,1-.712-.16l-1.442-1.258a.682.682,0,0,1-.059-.057l-4.574-4.943a.767.767,0,0,1,0-1.045c.417-.444,10.269-10.884,15.734-12.143.154-.033.3-.063.441-.083a6.088,6.088,0,0,1,2.131-.658c1.575-.174,3.065-.3,4.432-.386,4.061-.245,12.379-.453,16.8-.185a2.846,2.846,0,0,1,.447.061c7.6-2.343,23.942-5.382,24.108-5.412a.767.767,0,0,1,.811,1.124l-6.743,12.2a.775.775,0,0,1-.2.232,41.786,41.786,0,0,1-10.341,5.868c.64,9.123-.118,21.691-2.256,37.371A.766.766,0,0,1,1424.079,808.854Zm-29.3-1.533h28.632c2.1-15.609,2.812-28.049,2.112-36.983a.767.767,0,0,1,.536-.792c4.577-1.424,9.485-5.079,10.31-5.708l5.877-10.638c-4.366.838-16.563,3.249-22.6,5.148a.768.768,0,0,1-.609-.065c-.037,0-.083-.008-.139-.013-4.343-.263-12.573-.057-16.6.186-1.343.08-2.807.208-4.351.379a4.525,4.525,0,0,0-1.693.546.757.757,0,0,1-.317.1,3.165,3.165,0,0,0-.4.071c-4.356,1-12.388,9.051-14.455,11.181l4.056,4.384,1.1.957,7.885-2.229a.765.765,0,0,1,.972.674A183.951,183.951,0,0,1,1394.777,807.322Zm42.184-42.973h0Zm-18.225-6.383Zm0,0v0Z",
    transform: "translate(-1379.266 -751.38)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(36.329 48.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M1395.88,779.129s.206,1.818.2,1.825l-9.25,2.544h0S1397.736,776.427,1395.88,779.129Z",
    transform: "translate(-1386.827 -778.514)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    transform: "translate(56.634 187.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M1413.612,959.527l-.287,6.742h5.651l.287-6.742Z",
    transform: "translate(-1413.325 -959.527)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(51.418 5.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M1407.659,730.41a7.654,7.654,0,0,1,8.961-6.067c5.809,1.091,8.207,9.076,8.035,14.245-.165,5.744-6.462,9.629-11.488,6.247-3.332-2.261-3.913-5.5-5.363-10.913A7.547,7.547,0,0,1,1407.659,730.41Z",
    transform: "translate(-1406.752 -723.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M1416.957,746.62a7.952,7.952,0,0,1-4.451-1.383c-3.273-2.222-4.081-5.3-5.305-9.95l-.371-1.4a8.33,8.33,0,0,1-.156-3.855,8.429,8.429,0,0,1,9.858-6.674c6.275,1.179,8.84,9.5,8.656,15.024a8.544,8.544,0,0,1-4.623,7.356A7.872,7.872,0,0,1,1416.957,746.62Zm-2.016-21.883a6.9,6.9,0,0,0-6.763,5.584v0a6.794,6.794,0,0,0,.129,3.154l.375,1.419c1.176,4.473,1.886,7.172,4.681,9.07a6.243,6.243,0,0,0,6.5.406,7.011,7.011,0,0,0,3.791-6.041c.161-4.843-2.083-12.47-7.411-13.471A6.9,6.9,0,0,0,1414.941,724.737Zm-7.515,5.439h0Z",
    transform: "translate(-1406.518 -723.204)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(14.947 83.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M1389.1,825.329s-4.782,11.23-9.263,30.1c-5.837,24.606-19.911,74.875-19.911,74.875l9.959,2.19s20.542-58.511,25.942-76.153a205.591,205.591,0,0,1,12.766-31.011Z",
    transform: "translate(-1359.158 -824.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M1369.65,933.025a.756.756,0,0,1-.165-.018l-9.96-2.19a.767.767,0,0,1-.573-.955c.141-.5,14.136-50.535,19.9-74.846,4.444-18.717,9.254-30.11,9.3-30.222a.766.766,0,0,1,.705-.466h19.494a.766.766,0,0,1,.682,1.114,205.555,205.555,0,0,0-12.719,30.9c-5.339,17.446-25.744,75.588-25.949,76.174A.766.766,0,0,1,1369.65,933.025Zm-9-3.53,8.5,1.87c2.252-6.425,20.678-59.049,25.707-75.482a207.042,207.042,0,0,1,12.252-30.021h-17.734a214.715,214.715,0,0,0-9.03,29.51C1374.969,878.038,1362.455,923.014,1360.647,929.5Z",
    transform: "translate(-1358.924 -824.329)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    transform: "translate(46.068 96.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M1411.79,841.339c-9.985,27.162-12.108,35.315-12.253,35.839,1.218-16.531,6.191-34.976,12.253-35.839C1412.218,841.267,1411.378,841.2,1411.79,841.339Z",
    transform: "translate(-1399.537 -841.259)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(54.217 83.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M1411.413,825.329s.352,13.248-.072,32.433c-.388,17.6,0,75.133,0,75.133h9.571s7.353-58.7,9.277-76.591a207.128,207.128,0,0,0,1.07-30.975Z",
    transform: "translate(-1410.404 -824.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M1420.679,933.428h-9.571a.766.766,0,0,1-.766-.761c0-.576-.383-57.747,0-75.155.418-18.945.076-32.264.072-32.4a.765.765,0,0,1,.766-.786h19.846a.766.766,0,0,1,.765.735,208.475,208.475,0,0,1-1.073,31.091c-1.9,17.693-9.2,76.015-9.279,76.6A.766.766,0,0,1,1420.679,933.428Zm-8.809-1.533H1420c.823-6.575,7.4-59.256,9.192-75.907a207.112,207.112,0,0,0,1.094-30.127h-18.325c.066,3.13.271,15.313-.09,31.684C1411.516,873.834,1411.826,925.025,1411.87,931.9Z",
    transform: "translate(-1410.171 -824.329)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(52.973 187.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M1409.548,961.157l.324,3.54H1421.5s.582-3.971.539-3.971Z",
    transform: "translate(-1408.781 -959.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M1421.269,965.229h-11.631a.766.766,0,0,1-.763-.7l-.323-3.539a.766.766,0,0,1,.737-.836l12.493-.431a.762.762,0,0,1,.607.265c.266.307.266.307-.36,4.582A.766.766,0,0,1,1421.269,965.229Zm-10.932-1.533h10.27c.13-.9.255-1.788.339-2.408l-10.795.372Z",
    transform: "translate(-1408.548 -959.726)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    transform: "translate(14.581 187.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M1362,961.626l5.5.417-2.535,10.82-5.521-.395Z",
    transform: "translate(-1358.68 -960.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M1364.734,973.4l-.054,0-5.522-.4a.767.767,0,0,1-.691-.94l2.556-10.842a.756.756,0,0,1,.8-.588l5.5.416a.766.766,0,0,1,.688.939L1365.48,972.8A.766.766,0,0,1,1364.734,973.4Zm-4.569-1.861,3.972.284,2.182-9.313-3.955-.3Z",
    transform: "translate(-1358.447 -960.625)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(16.855 188.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M1362.527,961.233l-1.113,4.76,5.507.395,1.12-4.775Z",
    transform: "translate(-1361.414 -961.233)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(6.284 196.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M1355.587,974.492c-1.487,1.759-2.269,2.664-6.584,4.028-.956.294-.1,2.571,2.211,2.369,3.819-.345,1.709-.337,4.961-.618,2.786-.251,6-.4,8.222-.56a.833.833,0,0,0,.753-.907.88.88,0,0,0-.034-.17l-1.551-4.9a.489.489,0,0,0-.517-.337l-6.146.546A1.872,1.872,0,0,0,1355.587,974.492Z",
    transform: "translate(-1347.852 -972.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M1350.694,981.435a2.966,2.966,0,0,1-3.04-2.205,1.37,1.37,0,0,1,.89-1.675c4.124-1.3,4.782-2.084,6.224-3.791a.548.548,0,0,1,.041-.045,2.623,2.623,0,0,1,1.851-.779l6.085-.542a1.258,1.258,0,0,1,1.315.868l1.552,4.905a1.638,1.638,0,0,1,.067.333,1.6,1.6,0,0,1-1.444,1.739c-.791.057-1.685.111-2.641.169-1.77.107-3.776.229-5.582.392a14.986,14.986,0,0,0-2.142.264,21.023,21.023,0,0,1-2.82.354C1350.928,981.43,1350.81,981.435,1350.694,981.435Zm-1.53-2.47a1.057,1.057,0,0,0,.256.435,1.755,1.755,0,0,0,1.493.492,19.885,19.885,0,0,0,2.634-.326,16.322,16.322,0,0,1,2.33-.291c1.825-.165,3.844-.287,5.625-.395.949-.058,1.838-.112,2.608-.166a.08.08,0,0,0,.044-.071l-1.485-4.7-5.932.527a1.158,1.158,0,0,0-.819.311C1354.3,976.7,1353.372,977.619,1349.164,978.966Zm-.162.051h0Zm13.893-5.1h0Z",
    transform: "translate(-1347.618 -972.391)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(13.698 186.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M1358.352,959.911l-.058,3.59,11.976,1.257s1.027-3.892.984-3.892Z",
    transform: "translate(-1357.528 -959.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M1370.037,965.29c-.027,0-.054,0-.081,0l-11.977-1.257a.767.767,0,0,1-.686-.775l.058-3.59a.766.766,0,0,1,.249-.553.752.752,0,0,1,.573-.2l12.9.955a.769.769,0,0,1,.551.3c.261.34.261.34-.85,4.554A.766.766,0,0,1,1370.037,965.29Zm-11.2-2.711,10.625,1.114c.231-.877.457-1.753.61-2.362l-11.2-.829Z",
    transform: "translate(-1357.294 -958.91)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(49.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M1420.67,718.946a5.636,5.636,0,0,0,5.9-3.519,6.8,6.8,0,0,1-2.972,5.17,7.577,7.577,0,0,0,4.969-3.5,6.612,6.612,0,0,1-3.519,5.7l3.4-1.493a8.352,8.352,0,0,1-6.053,4.043,11.814,11.814,0,0,0-2.427.373,2.068,2.068,0,0,0-1.5,1.752c0,.862.718,1.537.969,2.356.33,1.113-.28,2.254-.768,3.3-1.206,2.57-2.585,4.875-2.628,7.618a.962.962,0,0,1-.847.933c-2.958.344-5.364.136-7.9-1.687-2.758-2-3.835-6.039-3.741-9.442a7.06,7.06,0,0,1,2.225-4.775,12.821,12.821,0,0,0,2.248-3.648C1409.023,719.9,1411.271,717.66,1420.67,718.946Z",
    transform: "translate(-1403.554 -715.427)",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(70.069 8.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M1460.039,752.661l-22.091-16.074-.038-.05-3.723-5.72-2.33-.37,1.479-1.689,6.373-1.282,1.59,6.213,20.7,9a6.866,6.866,0,0,1,3.661,4.093C1466.4,749.049,1465.9,751.823,1460.039,752.661Z",
    transform: "translate(-1431.092 -726.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M1459.806,753.194a.767.767,0,0,1-.451-.147l-22.091-16.075a.761.761,0,0,1-.162-.159c-.011-.014-.057-.077-.067-.091l-3.537-5.435-1.993-.316a.766.766,0,0,1-.457-1.261l1.48-1.689a.761.761,0,0,1,.425-.247l6.373-1.283a.767.767,0,0,1,.893.562l1.5,5.85,20.354,8.85a7.662,7.662,0,0,1,4.083,4.553,4.6,4.6,0,0,1-.3,3.959c-.939,1.51-2.937,2.494-5.936,2.923A.742.742,0,0,1,1459.806,753.194Zm-21.535-17.385L1460,751.622c2.326-.375,3.9-1.122,4.547-2.169a3.084,3.084,0,0,0,.15-2.668,6.113,6.113,0,0,0-3.25-3.632l-20.687-8.995a.767.767,0,0,1-.437-.513l-1.41-5.509-5.406,1.088-.394.45.959.152a.765.765,0,0,1,.522.339Z",
    transform: "translate(-1430.858 -726.476)",
    fill: "#231f20"
  })))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(64.781 449.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M335.83,978.9H296.085a.766.766,0,1,1,0-1.533H335.83a.766.766,0,1,1,0,1.533Z",
    transform: "translate(-295.319 -977.369)",
    fill: "#231f20"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImg1);
export default __webpack_public_path__ + "static/media/About_Img_1.556dd1733c3612f86bebfb5cc3c5cb24.svg";
export { ForwardRef as ReactComponent };